(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("@angular/animations"), require("@angular/forms"), require("@angular/platform-browser"), require("rxjs/add/observable/fromEvent"), require("rxjs/add/observable/interval"), require("rxjs/add/operator/debounce"), require("rxjs/Observable"), require("@angular/platform-browser/animations"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "@angular/animations", "@angular/forms", "@angular/platform-browser", "rxjs/add/observable/fromEvent", "rxjs/add/observable/interval", "rxjs/add/operator/debounce", "rxjs/Observable", "@angular/platform-browser/animations"], factory);
	else if(typeof exports === 'object')
		exports["jsblocks"] = factory(require("@angular/core"), require("@angular/common"), require("@angular/animations"), require("@angular/forms"), require("@angular/platform-browser"), require("rxjs/add/observable/fromEvent"), require("rxjs/add/observable/interval"), require("rxjs/add/operator/debounce"), require("rxjs/Observable"), require("@angular/platform-browser/animations"));
	else
		root["jsblocks"] = factory(root["ng"]["core"], root["ng"]["common"], root["ng"]["animations"], root["ng"]["forms"], root["ng"]["platformBrowser"], root["Rx"], root["Rx"], root["Rx"], root["Rx"], root["ng"]["platformBrowserAnimations"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_62__, __WEBPACK_EXTERNAL_MODULE_63__, __WEBPACK_EXTERNAL_MODULE_64__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_87__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var IgxIcon = (function () {
    function IgxIcon(el) {
        this.el = el;
        this.font = "material";
        this.active = "true";
    }
    Object.defineProperty(IgxIcon.prototype, "fontSet", {
        set: function (value) {
            this.font = value || this.font;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "isActive", {
        set: function (value) {
            this.active = value || this.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "color", {
        set: function (value) {
            this.iconColor = value;
            this.el.nativeElement.style.color = this.iconColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "name", {
        set: function (value) {
            this.iconName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "getFontSet", {
        get: function () {
            return this.font;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "getActive", {
        get: function () {
            if (this.active.toLowerCase() === "true") {
                return true;
            }
            else if (this.active.toLowerCase() === "false") {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "getIconColor", {
        get: function () {
            return this.iconColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxIcon.prototype, "getIconName", {
        get: function () {
            return this.iconName;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.ViewChild("icon"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxIcon.prototype, "themeIcon", void 0);
    __decorate([
        core_1.Input("fontSet"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxIcon.prototype, "fontSet", null);
    __decorate([
        core_1.Input("isActive"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxIcon.prototype, "isActive", null);
    __decorate([
        core_1.Input("color"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxIcon.prototype, "color", null);
    __decorate([
        core_1.Input("name"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxIcon.prototype, "name", null);
    IgxIcon = __decorate([
        core_1.Component({
            selector: "igx-icon",
            styles: [__webpack_require__(55)],
            template: __webpack_require__(57)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], IgxIcon);
    return IgxIcon;
}());
exports.IgxIcon = IgxIcon;
var IgxIconModule = (function () {
    function IgxIconModule() {
    }
    IgxIconModule = __decorate([
        core_1.NgModule({
            declarations: [IgxIcon],
            exports: [IgxIcon],
            imports: [common_1.CommonModule]
        })
    ], IgxIconModule);
    return IgxIconModule;
}());
exports.IgxIconModule = IgxIconModule;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxButton = (function () {
    function IgxButton(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
        this._type = "flat";
        this._cssClass = "igx-button";
    }
    Object.defineProperty(IgxButton.prototype, "type", {
        set: function (value) {
            this._type = value || this._type;
            this._renderer.addClass(this._el.nativeElement, this._cssClass + "--" + this._type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButton.prototype, "color", {
        set: function (value) {
            this._color = value || this._el.nativeElement.style.color;
            this._renderer.setStyle(this._el.nativeElement, "color", this._color);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButton.prototype, "background", {
        set: function (value) {
            this._backgroundColor = value || this._backgroundColor;
            this._renderer.setStyle(this._el.nativeElement, "background", this._backgroundColor);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButton.prototype, "label", {
        set: function (value) {
            this._label = value || this._label;
            this._renderer.setAttribute(this._el.nativeElement, "aria-label", this._label);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButton.prototype, "disabled", {
        set: function (val) {
            val = !!val;
            if (val) {
                this._renderer.addClass(this._el.nativeElement, this._cssClass + "--disabled");
            }
            else {
                this._renderer.removeClass(this._el.nativeElement, this._cssClass + "--disabled");
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input("igxButton"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxButton.prototype, "type", null);
    __decorate([
        core_1.Input("igxButtonColor"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxButton.prototype, "color", null);
    __decorate([
        core_1.Input("igxButtonBackground"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxButton.prototype, "background", null);
    __decorate([
        core_1.Input("igxLabel"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxButton.prototype, "label", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], IgxButton.prototype, "disabled", null);
    IgxButton = __decorate([
        core_1.Directive({
            host: {
                role: "button"
            },
            selector: "[igxButton]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxButton);
    return IgxButton;
}());
exports.IgxButton = IgxButton;
var IgxButtonModule = (function () {
    function IgxButtonModule() {
    }
    IgxButtonModule = __decorate([
        core_1.NgModule({
            declarations: [IgxButton],
            exports: [IgxButton]
        })
    ], IgxButtonModule);
    return IgxButtonModule;
}());
exports.IgxButtonModule = IgxButtonModule;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EaseIn;
(function (EaseIn) {
    EaseIn[EaseIn["quad"] = "cubic-bezier(0.550, 0.085, 0.680, 0.530)"] = "quad";
    EaseIn[EaseIn["cubic"] = "cubic-bezier(0.550, 0.055, 0.675, 0.190)"] = "cubic";
    EaseIn[EaseIn["quart"] = "cubic-bezier(0.895, 0.030, 0.685, 0.220)"] = "quart";
    EaseIn[EaseIn["quint"] = "cubic-bezier(0.755, 0.050, 0.855, 0.060)"] = "quint";
    EaseIn[EaseIn["sine"] = "cubic-bezier(0.470, 0.000, 0.745, 0.715)"] = "sine";
    EaseIn[EaseIn["expo"] = "cubic-bezier(0.950, 0.050, 0.795, 0.035)"] = "expo";
    EaseIn[EaseIn["circ"] = "cubic-bezier(0.600, 0.040, 0.980, 0.335)"] = "circ";
    EaseIn[EaseIn["back"] = "cubic-bezier(0.600, -0.280, 0.735, 0.045)"] = "back";
})(EaseIn || (EaseIn = {}));
exports.EaseIn = EaseIn;
var EaseOut;
(function (EaseOut) {
    EaseOut[EaseOut["quad"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)"] = "quad";
    EaseOut[EaseOut["cubic"] = "cubic-bezier(0.215, 0.610, 0.355, 1.000)"] = "cubic";
    EaseOut[EaseOut["quart"] = "cubic-bezier(0.165, 0.840, 0.440, 1.000)"] = "quart";
    EaseOut[EaseOut["quint"] = "cubic-bezier(0.230, 1.000, 0.320, 1.000)"] = "quint";
    EaseOut[EaseOut["sine"] = "cubic-bezier(0.390, 0.575, 0.565, 1.000)"] = "sine";
    EaseOut[EaseOut["expo"] = "cubic-bezier(0.190, 1.000, 0.220, 1.000)"] = "expo";
    EaseOut[EaseOut["circ"] = "cubic-bezier(0.075, 0.820, 0.165, 1.000)"] = "circ";
    EaseOut[EaseOut["back"] = "cubic-bezier(0.175, 0.885, 0.320, 1.275)"] = "back";
})(EaseOut || (EaseOut = {}));
exports.EaseOut = EaseOut;
var EaseInOut;
(function (EaseInOut) {
    EaseInOut[EaseInOut["quad"] = "cubic-bezier(0.455, 0.030, 0.515, 0.955)"] = "quad";
    EaseInOut[EaseInOut["cubic"] = "cubic-bezier(0.645, 0.045, 0.355, 1.000)"] = "cubic";
    EaseInOut[EaseInOut["quart"] = "cubic-bezier(0.770, 0.000, 0.175, 1.000)"] = "quart";
    EaseInOut[EaseInOut["quint"] = "cubic-bezier(0.860, 0.000, 0.070, 1.000)"] = "quint";
    EaseInOut[EaseInOut["sine"] = "cubic-bezier(0.445, 0.050, 0.550, 0.950)"] = "sine";
    EaseInOut[EaseInOut["expo"] = "cubic-bezier(1.000, 0.000, 0.000, 1.000)"] = "expo";
    EaseInOut[EaseInOut["circ"] = "cubic-bezier(0.785, 0.135, 0.150, 0.860)"] = "circ";
    EaseInOut[EaseInOut["back"] = "cubic-bezier(0.680, -0.550, 0.265, 1.550)"] = "back";
})(EaseInOut || (EaseInOut = {}));
exports.EaseInOut = EaseInOut;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortingDirection;
(function (SortingDirection) {
    SortingDirection[SortingDirection["None"] = 0] = "None";
    SortingDirection[SortingDirection["Asc"] = 1] = "Asc";
    SortingDirection[SortingDirection["Desc"] = 2] = "Desc";
})(SortingDirection = exports.SortingDirection || (exports.SortingDirection = {}));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var filtering_condition_1 = __webpack_require__(12);
var filtering_state_interface_1 = __webpack_require__(19);
var sorting_state_interface_1 = __webpack_require__(21);
var paging_state_interface_1 = __webpack_require__(22);
var DataType;
(function (DataType) {
    DataType[DataType["String"] = 0] = "String";
    DataType[DataType["Number"] = 1] = "Number";
    DataType[DataType["Boolean"] = 2] = "Boolean";
    DataType[DataType["Date"] = 3] = "Date";
})(DataType = exports.DataType || (exports.DataType = {}));
var DataUtil = (function () {
    function DataUtil() {
    }
    DataUtil.mergeDefaultProperties = function (target, defaults) {
        if (!defaults) {
            return target;
        }
        if (!target) {
            target = Object.assign({}, defaults);
            return target;
        }
        Object
            .keys(defaults)
            .forEach(function (key) {
            if (target[key] === undefined && defaults[key] !== undefined) {
                target[key] = defaults[key];
            }
        });
        return target;
    };
    DataUtil.getFilteringConditionsForDataType = function (dataType) {
        var dt;
        switch (dataType) {
            case DataType.String:
                dt = "string";
                break;
            case DataType.Number:
                dt = "number";
                break;
            case DataType.Boolean:
                dt = "boolean";
                break;
            case DataType.Date:
                dt = "date";
                break;
        }
        return filtering_condition_1.FilteringCondition[dt];
    };
    DataUtil.getListOfFilteringConditionsForDataType = function (dataType) {
        return Object.keys(DataUtil.getFilteringConditionsForDataType(dataType));
    };
    DataUtil.sort = function (data, state) {
        DataUtil.mergeDefaultProperties(state, sorting_state_interface_1.SortingStateDefaults);
        return state.strategy.sort(data, state.expressions);
    };
    DataUtil.page = function (data, state) {
        if (!state) {
            return data;
        }
        var len = data.length;
        var index = state.index;
        var res = [];
        var recordsPerPage = state.recordsPerPage;
        state.metadata = {
            countPages: 0,
            countRecords: data.length,
            error: paging_state_interface_1.PagingError.None
        };
        if (index < 0 || isNaN(index)) {
            state.metadata.error = paging_state_interface_1.PagingError.IncorrectPageIndex;
            return res;
        }
        if (recordsPerPage <= 0 || isNaN(recordsPerPage)) {
            state.metadata.error = paging_state_interface_1.PagingError.IncorrectRecordsPerPage;
            return res;
        }
        state.metadata.countPages = Math.ceil(len / recordsPerPage);
        if (!len) {
            return data;
        }
        if (index >= state.metadata.countPages) {
            state.metadata.error = paging_state_interface_1.PagingError.IncorrectPageIndex;
            return res;
        }
        return data.slice(index * recordsPerPage, (index + 1) * recordsPerPage);
    };
    DataUtil.filter = function (data, state) {
        DataUtil.mergeDefaultProperties(state, filtering_state_interface_1.filteringStateDefaults);
        if (!state.strategy) {
            return data;
        }
        return state.strategy.filter(data, state.expressions, state.logic);
    };
    DataUtil.process = function (data, state) {
        if (!state) {
            return data;
        }
        if (state.filtering) {
            data = DataUtil.filter(data, state.filtering);
        }
        if (state.sorting) {
            data = DataUtil.sort(data, state.sorting);
        }
        if (state.paging) {
            data = DataUtil.page(data, state.paging);
        }
        return data;
    };
    return DataUtil;
}());
exports.DataUtil = DataUtil;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxRippleDirective = (function () {
    function IgxRippleDirective(el, renderer, zone) {
        this.el = el;
        this.renderer = renderer;
        this.zone = zone;
        this.rippleTarget = "";
        this.rippleDuration = 600;
        this._centered = false;
        this.animationQueue = [];
        this.container = el.nativeElement;
    }
    Object.defineProperty(IgxRippleDirective.prototype, "centered", {
        set: function (value) {
            this._centered = value || this.centered;
        },
        enumerable: true,
        configurable: true
    });
    IgxRippleDirective.prototype.onMouseDown = function (event) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this._ripple(event); });
    };
    IgxRippleDirective.prototype._ripple = function (event) {
        var _this = this;
        var target;
        var top;
        var left;
        var radius;
        var rippleEl;
        var rectBounds;
        var scrollLeft = (document.body.scrollLeft || document.documentElement.scrollLeft);
        var scrollTop = (document.body.scrollTop || document.documentElement.scrollTop);
        event.stopPropagation();
        target = (this.rippleTarget ?
            this.container.querySelector(this.rippleTarget) || this.container
            : this.container);
        rectBounds = target.getBoundingClientRect();
        this.renderer.addClass(target, "ig-ripple-host");
        rippleEl = this.renderer.createElement("span");
        this.renderer.appendChild(target, rippleEl);
        this.renderer.addClass(rippleEl, "ig-ripple-host__ripple");
        radius = Math.max(rectBounds.width, rectBounds.height);
        left = event.pageX - rectBounds.left - radius / 2 - scrollLeft;
        top = event.pageY - rectBounds.top - radius / 2 - scrollTop;
        this.renderer.setStyle(rippleEl, "width", radius + "px");
        this.renderer.setStyle(rippleEl, "height", radius + "px");
        this.renderer.setStyle(rippleEl, "top", top + "px");
        this.renderer.setStyle(rippleEl, "left", left + "px");
        if (this._centered) {
            this.renderer.setStyle(rippleEl, "top", "0");
            this.renderer.setStyle(rippleEl, "left", "0");
        }
        if (this.rippleColor) {
            this.renderer.setStyle(rippleEl, "background", this.rippleColor);
        }
        var FRAMES = [
            { opacity: 0.5, transform: "scale(0)" },
            { opacity: 0, transform: "scale(2)" }
        ];
        var animation = rippleEl.animate(FRAMES, {
            duration: this.rippleDuration,
            fill: "forwards"
        });
        this.animationQueue.push(animation);
        animation.onfinish = function () {
            _this.animationQueue.splice(_this.animationQueue.indexOf(animation), 1);
            target.removeChild(rippleEl);
            if (_this.animationQueue.length < 1) {
                _this.renderer.removeClass(target, "ig-ripple-host");
            }
        };
    };
    __decorate([
        core_1.Input("igxRippleTarget"),
        __metadata("design:type", String)
    ], IgxRippleDirective.prototype, "rippleTarget", void 0);
    __decorate([
        core_1.Input("igxRipple"),
        __metadata("design:type", String)
    ], IgxRippleDirective.prototype, "rippleColor", void 0);
    __decorate([
        core_1.Input("igxRippleDuration"),
        __metadata("design:type", Number)
    ], IgxRippleDirective.prototype, "rippleDuration", void 0);
    __decorate([
        core_1.Input("igxRippleCentered"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], IgxRippleDirective.prototype, "centered", null);
    __decorate([
        core_1.HostListener("mousedown", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxRippleDirective.prototype, "onMouseDown", null);
    IgxRippleDirective = __decorate([
        core_1.Directive({
            selector: "[igxRipple]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2, core_1.NgZone])
    ], IgxRippleDirective);
    return IgxRippleDirective;
}());
exports.IgxRippleDirective = IgxRippleDirective;
var IgxRippleModule = (function () {
    function IgxRippleModule() {
    }
    IgxRippleModule = __decorate([
        core_1.NgModule({
            declarations: [IgxRippleDirective],
            exports: [IgxRippleDirective]
        })
    ], IgxRippleModule);
    return IgxRippleModule;
}());
exports.IgxRippleModule = IgxRippleModule;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilteringLogic;
(function (FilteringLogic) {
    FilteringLogic[FilteringLogic["And"] = 0] = "And";
    FilteringLogic[FilteringLogic["Or"] = 1] = "Or";
})(FilteringLogic = exports.FilteringLogic || (exports.FilteringLogic = {}));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function applyIgnoreCase(a, ignoreCase) {
    a = a || "";
    return ignoreCase ? ("" + a).toLowerCase() : a;
}
function getDateParts(date, dateFormat) {
    var res = {
        day: null,
        hours: null,
        milliseconds: null,
        minutes: null,
        month: null,
        seconds: null,
        year: null
    };
    if (!date || !dateFormat) {
        return res;
    }
    if (dateFormat.indexOf("y") >= 0) {
        res.year = date.getFullYear();
    }
    if (dateFormat.indexOf("M") >= 0) {
        res.month = date.getMonth();
    }
    if (dateFormat.indexOf("d") >= 0) {
        res.day = date.getDate();
    }
    if (dateFormat.indexOf("h") >= 0) {
        res.hours = date.getHours();
    }
    if (dateFormat.indexOf("m") >= 0) {
        res.minutes = date.getMinutes();
    }
    if (dateFormat.indexOf("s") >= 0) {
        res.seconds = date.getSeconds();
    }
    if (dateFormat.indexOf("f") >= 0) {
        res.milliseconds = date.getMilliseconds();
    }
    return res;
}
exports.FilteringCondition = {
    boolean: {
        true: function (target) {
            return target;
        },
        false: function (target) {
            return !target;
        },
        null: function (target) {
            return target === null;
        },
        notNull: function (target) {
            return target !== null;
        },
        empty: function (target) {
            return target === null || target === undefined;
        },
        notEmpty: function (target) {
            return target !== null && target !== undefined;
        }
    },
    date: {
        equals: function (target, searchVal) {
            return +target === +searchVal;
        },
        doesNotEqual: function (target, searchVal) {
            return !exports.FilteringCondition.date.equals(target, searchVal);
        },
        before: function (target, searchVal) {
            return target < searchVal;
        },
        after: function (target, searchVal) {
            return target > searchVal;
        },
        today: function (target) {
            var d = getDateParts(target, "yMd");
            var now = getDateParts(new Date(), "yMd");
            return d.year === now.year &&
                d.month === now.month &&
                d.day === now.day;
        },
        yesterday: function (target) {
            var td = getDateParts(target, "yMd");
            var y = (function (d) { return new Date(d.setDate(d.getDate() - 1)); })(new Date());
            var yesterday = getDateParts(y, "yMd");
            return td.year === yesterday.year &&
                td.month === yesterday.month &&
                td.day === yesterday.day;
        },
        thisMonth: function (target) {
            var d = getDateParts(target, "yM");
            var now = getDateParts(new Date(), "yM");
            return d.year === now.year &&
                d.month === now.month;
        },
        lastMonth: function (target) {
            var d = getDateParts(target, "yM");
            var now = getDateParts(new Date(), "yM");
            if (!now.month) {
                now.month = 11;
                now.year -= 1;
            }
            else {
                now.month--;
            }
            return d.year === now.year &&
                d.month === now.month;
        },
        nextMonth: function (target) {
            var d = getDateParts(target, "yM");
            var now = getDateParts(new Date(), "yM");
            if (now.month === 11) {
                now.month = 0;
                now.year += 1;
            }
            else {
                now.month++;
            }
            return d.year === now.year &&
                d.month === now.month;
        },
        thisYear: function (target) {
            var d = getDateParts(target, "y");
            var now = getDateParts(new Date(), "y");
            return d.year === now.year;
        },
        lastYear: function (target) {
            var d = getDateParts(target, "y");
            var now = getDateParts(new Date(), "y");
            return d.year === now.year - 1;
        },
        nextYear: function (target) {
            var d = getDateParts(target, "y");
            var now = getDateParts(new Date(), "y");
            return d.year === now.year + 1;
        },
        null: function (target) {
            return target === null;
        },
        notNull: function (target) {
            return target !== null;
        },
        empty: function (target) {
            return target === null || target === undefined;
        },
        notEmpty: function (target) {
            return target !== null && target !== undefined;
        }
    },
    number: {
        equals: function (target, searchVal) {
            return target === searchVal;
        },
        doesNotEqual: function (target, searchVal) {
            return target !== searchVal;
        },
        greaterThan: function (target, searchVal) {
            return target > searchVal;
        },
        lessThan: function (target, searchVal) {
            return target < searchVal;
        },
        greaterThanOrEqualTo: function (target, searchVal) {
            return target >= searchVal;
        },
        lessThanOrEqualTo: function (target, searchVal) {
            return target <= searchVal;
        },
        null: function (target) {
            return target === null;
        },
        notNull: function (target) {
            return target !== null;
        },
        empty: function (target) {
            return target === null || target === undefined || isNaN(target);
        },
        notEmpty: function (target) {
            return target !== null && target !== undefined && !isNaN(target);
        }
    },
    string: {
        contains: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target.indexOf(search) !== -1;
        },
        startsWith: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target.startsWith(search);
        },
        endsWith: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target.endsWith(search);
        },
        doesNotContain: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target.indexOf(search) === -1;
        },
        equals: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target === search;
        },
        doesNotEqual: function (target, searchVal, ignoreCase) {
            var search = applyIgnoreCase(searchVal, ignoreCase);
            target = applyIgnoreCase(target, ignoreCase);
            return target !== search;
        },
        null: function (target) {
            return target === null;
        },
        notNull: function (target) {
            return target !== null;
        },
        empty: function (target) {
            return target === null || target === undefined || target.length === 0;
        },
        notEmpty: function (target) {
            return target !== null && target !== undefined && target.length > 0;
        }
    }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sorting_expression_interface_1 = __webpack_require__(8);
var SortingStrategy = (function () {
    function SortingStrategy() {
    }
    SortingStrategy.prototype.sort = function (data, expressions) {
        return this.sortDataRecursive(data, expressions);
    };
    SortingStrategy.prototype.compareValues = function (a, b) {
        var an = (a === null || a === undefined);
        var bn = (b === null || b === undefined);
        if (an) {
            if (bn) {
                return 0;
            }
            return -1;
        }
        else if (bn) {
            return 1;
        }
        return a > b ? 1 : a < b ? -1 : 0;
    };
    SortingStrategy.prototype.compareObjects = function (obj1, obj2, key, reverse, ignoreCase) {
        var a = obj1[key];
        var b = obj2[key];
        if (ignoreCase) {
            a = a && a.toLowerCase ? a.toLowerCase() : a;
            b = b && b.toLowerCase ? b.toLowerCase() : b;
        }
        return reverse * this.compareValues(a, b);
    };
    SortingStrategy.prototype.arraySort = function (data, compareFn) {
        return data.sort(compareFn);
    };
    SortingStrategy.prototype.groupedRecordsByExpression = function (data, index, expression) {
        var i;
        var groupval;
        var res = [];
        var key = expression.fieldName;
        var len = data.length;
        var cmpFunc = function (val1, val2) {
            return val1 === val2;
        };
        res.push(data[index]);
        groupval = data[index][key];
        index++;
        for (i = index; i < len; i++) {
            if (cmpFunc(data[i][key], groupval)) {
                res.push(data[i]);
            }
            else {
                break;
            }
        }
        return res;
    };
    SortingStrategy.prototype.sortByFieldExpression = function (data, expression) {
        var _this = this;
        var key = expression.fieldName;
        var ignoreCase = expression.ignoreCase ?
            data[0] && (typeof data[0][key] === "string" ||
                data[0][key] === null ||
                data[0][key] === undefined) :
            false;
        var reverse = (expression.dir === sorting_expression_interface_1.SortingDirection.Desc ? -1 : 1);
        var cmpFunc = function (obj1, obj2) {
            return _this.compareObjects(obj1, obj2, key, reverse, ignoreCase);
        };
        return this.arraySort(data, cmpFunc);
    };
    SortingStrategy.prototype.sortDataRecursive = function (data, expressions, expressionIndex) {
        if (expressionIndex === void 0) { expressionIndex = 0; }
        var i;
        var j;
        var expr;
        var gbData;
        var gbDataLen;
        var exprsLen = expressions.length;
        var dataLen = data.length;
        expressionIndex = expressionIndex || 0;
        if (expressionIndex >= exprsLen || dataLen <= 1) {
            return data;
        }
        expr = expressions[expressionIndex];
        data = this.sortByFieldExpression(data, expr);
        if (expressionIndex === exprsLen - 1) {
            return data;
        }
        for (i = 0; i < dataLen; i++) {
            gbData = this.groupedRecordsByExpression(data, i, expr);
            gbDataLen = gbData.length;
            if (gbDataLen > 1) {
                gbData = this.sortDataRecursive(gbData, expressions, expressionIndex + 1);
            }
            for (j = 0; j < gbDataLen; j++) {
                data[i + j] = gbData[j];
            }
            i += gbDataLen - 1;
        }
        return data;
    };
    return SortingStrategy;
}());
exports.SortingStrategy = SortingStrategy;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var main_1 = __webpack_require__(15);
var button_directive_1 = __webpack_require__(6);
var ripple_directive_1 = __webpack_require__(10);
var IgxDialog = (function () {
    function IgxDialog() {
        this.title = "";
        this.message = "";
        this.leftButtonLabel = "";
        this.leftButtonType = "flat";
        this.leftButtonColor = "";
        this.leftButtonBackgroundColor = "";
        this.leftButtonRipple = "";
        this.rightButtonLabel = "";
        this.rightButtonType = "flat";
        this.rightButtonColor = "";
        this.rightButtonBackgroundColor = "";
        this.rightButtonRipple = "";
        this.closeOnOutsideSelect = false;
        this.onOpen = new core_1.EventEmitter();
        this.onClose = new core_1.EventEmitter();
        this.onLeftButtonSelect = new core_1.EventEmitter();
        this.onRightButtonSelect = new core_1.EventEmitter();
        this._isOpen = false;
        this._titleId = IgxDialog_1.NEXT_ID++ + "_title";
    }
    IgxDialog_1 = IgxDialog;
    Object.defineProperty(IgxDialog.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxDialog.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxDialog.prototype, "role", {
        get: function () {
            if (this.leftButtonLabel !== "" && this.rightButtonLabel !== "") {
                return "dialog";
            }
            else if (this.leftButtonLabel !== "" ||
                this.rightButtonLabel !== "") {
                return "alertdialog";
            }
            else {
                return "alert";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxDialog.prototype, "titleId", {
        get: function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    IgxDialog.prototype.open = function () {
        if (this.isOpen) {
            return;
        }
        this.toggleState("open");
        this.onOpen.emit(this);
    };
    IgxDialog.prototype.close = function () {
        if (!this.isOpen) {
            return;
        }
        this.toggleState(null);
        this.onClose.emit(this);
    };
    IgxDialog.prototype.onDialogSelected = function (event) {
        if (this.isOpen &&
            this.closeOnOutsideSelect &&
            event.target.classList.contains(IgxDialog_1.DIALOG_CLASS)) {
            this.close();
        }
    };
    IgxDialog.prototype.onInternalLeftButtonSelect = function (event) {
        this.onLeftButtonSelect.emit({ dialog: this, event: event });
    };
    IgxDialog.prototype.onInternalRightButtonSelect = function (event) {
        this.onRightButtonSelect.emit({ dialog: this, event: event });
    };
    IgxDialog.prototype.toggleState = function (state) {
        this._state = state;
        this._isOpen = state === "open" ? true : false;
    };
    IgxDialog.NEXT_ID = 1;
    IgxDialog.DIALOG_CLASS = "igx-dialog";
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "leftButtonLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "leftButtonType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "leftButtonColor", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "leftButtonBackgroundColor", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "leftButtonRipple", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "rightButtonLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "rightButtonType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "rightButtonColor", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "rightButtonBackgroundColor", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDialog.prototype, "rightButtonRipple", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxDialog.prototype, "closeOnOutsideSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDialog.prototype, "onOpen", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDialog.prototype, "onClose", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDialog.prototype, "onLeftButtonSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDialog.prototype, "onRightButtonSelect", void 0);
    __decorate([
        core_1.ViewChild("dialog"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxDialog.prototype, "dialogEl", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxDialog.prototype, "isOpen", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxDialog.prototype, "role", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxDialog.prototype, "titleId", null);
    IgxDialog = IgxDialog_1 = __decorate([
        core_1.Component({
            animations: [
                animations_1.trigger("fadeInOut", [
                    animations_1.transition("void => open", animations_1.useAnimation(main_1.fadeIn)),
                    animations_1.transition("open => void", animations_1.useAnimation(main_1.fadeOut))
                ]),
                animations_1.trigger("slideIn", [
                    animations_1.transition("void => open", animations_1.useAnimation(main_1.slideInBottom))
                ])
            ],
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-dialog",
            styles: [__webpack_require__(51)],
            template: __webpack_require__(53)
        }),
        __metadata("design:paramtypes", [])
    ], IgxDialog);
    return IgxDialog;
    var IgxDialog_1;
}());
exports.IgxDialog = IgxDialog;
var IgxDialogModule = (function () {
    function IgxDialogModule() {
    }
    IgxDialogModule = __decorate([
        core_1.NgModule({
            declarations: [IgxDialog],
            exports: [IgxDialog],
            imports: [common_1.CommonModule, button_directive_1.IgxButtonModule, ripple_directive_1.IgxRippleModule]
        })
    ], IgxDialogModule);
    return IgxDialogModule;
}());
exports.IgxDialogModule = IgxDialogModule;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(42));
__export(__webpack_require__(43));
__export(__webpack_require__(44));
__export(__webpack_require__(45));
__export(__webpack_require__(48));
__export(__webpack_require__(49));
__export(__webpack_require__(50));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var IgxInputClass = (function () {
    function IgxInputClass(el) {
        this.el = el;
        this.isInput = true;
        this.focused = false;
        this.filled = false;
        this.placeholder = false;
    }
    IgxInputClass.prototype.onFocus = function (event) {
        this.focused = true;
    };
    IgxInputClass.prototype.onBlur = function (event) {
        this.focused = false;
    };
    IgxInputClass.prototype.ngDoCheck = function () {
        var value = this.el.nativeElement.value;
        this.filled = value && (value !== "");
        this.placeholder = this.el.nativeElement.getAttribute("placeholder") && !this.filled;
    };
    __decorate([
        core_1.HostBinding("class.igx-form-group__input"),
        __metadata("design:type", Boolean)
    ], IgxInputClass.prototype, "isInput", void 0);
    __decorate([
        core_1.HostBinding("class.igx-form-group__input--focused"),
        __metadata("design:type", Boolean)
    ], IgxInputClass.prototype, "focused", void 0);
    __decorate([
        core_1.HostBinding("class.igx-form-group__input--filled"),
        __metadata("design:type", Boolean)
    ], IgxInputClass.prototype, "filled", void 0);
    __decorate([
        core_1.HostBinding("class.igx-form-group__input--placeholder"),
        __metadata("design:type", Boolean)
    ], IgxInputClass.prototype, "placeholder", void 0);
    __decorate([
        core_1.HostListener("focus", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxInputClass.prototype, "onFocus", null);
    __decorate([
        core_1.HostListener("blur", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxInputClass.prototype, "onBlur", null);
    IgxInputClass = __decorate([
        core_1.Directive({
            selector: "[igxInput]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], IgxInputClass);
    return IgxInputClass;
}());
exports.IgxInputClass = IgxInputClass;
var IgxInput = (function () {
    function IgxInput() {
    }
    IgxInput = __decorate([
        core_1.NgModule({
            declarations: [IgxInputClass],
            exports: [IgxInputClass],
            imports: [common_1.CommonModule]
        })
    ], IgxInput);
    return IgxInput;
}());
exports.IgxInput = IgxInput;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(18));
__export(__webpack_require__(34));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NavigationService = (function () {
    function NavigationService() {
        this.navs = {};
    }
    NavigationService.prototype.add = function (id, navItem) {
        this.navs[id] = navItem;
    };
    NavigationService.prototype.remove = function (id) {
        delete this.navs[id];
    };
    NavigationService.prototype.get = function (id) {
        if (id) {
            return this.navs[id];
        }
    };
    NavigationService.prototype.toggle = function (id, fireEvents) {
        if (this.navs[id]) {
            return this.navs[id].toggle(fireEvents);
        }
        else {
            return Promise.reject("No ToggleView component found for id:" + id);
        }
    };
    NavigationService.prototype.open = function (id, fireEvents) {
        if (this.navs[id]) {
            return this.navs[id].open(fireEvents);
        }
        else {
            return Promise.reject("No ToggleView component found for id:" + id);
        }
    };
    NavigationService.prototype.close = function (id, fireEvents) {
        if (this.navs[id]) {
            return this.navs[id].close(fireEvents);
        }
        else {
            return Promise.reject("No ToggleView component found for id:" + id);
        }
    };
    return NavigationService;
}());
exports.NavigationService = NavigationService;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var filtering_expression_interface_1 = __webpack_require__(11);
var filtering_strategy_1 = __webpack_require__(20);
exports.filteringStateDefaults = {
    logic: filtering_expression_interface_1.FilteringLogic.And,
    strategy: new filtering_strategy_1.FilteringStrategy()
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var filtering_expression_interface_1 = __webpack_require__(11);
var FilteringStrategy = (function () {
    function FilteringStrategy() {
    }
    FilteringStrategy.prototype.filter = function (data, expressions, logic) {
        var i;
        var rec;
        var len = data.length;
        var res = [];
        if (!expressions || !expressions.length || !len) {
            return data;
        }
        for (i = 0; i < len; i++) {
            rec = data[i];
            if (this.matchRecordByExpressions(rec, expressions, i, logic)) {
                res.push(rec);
            }
        }
        return res;
    };
    FilteringStrategy.prototype.findMatch = function (rec, expr, index) {
        var cond = expr.condition;
        var val = rec[expr.fieldName];
        return cond(val, expr.searchVal, expr.ignoreCase);
    };
    FilteringStrategy.prototype.matchRecordByExpressions = function (rec, expressions, index, logic) {
        var i;
        var match = false;
        var and = (logic === filtering_expression_interface_1.FilteringLogic.And);
        var len = expressions.length;
        for (i = 0; i < len; i++) {
            match = this.findMatch(rec, expressions[i], i);
            if (and) {
                if (!match) {
                    return false;
                }
            }
            else {
                if (match) {
                    return true;
                }
            }
        }
        return match;
    };
    return FilteringStrategy;
}());
exports.FilteringStrategy = FilteringStrategy;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sorting_strategy_1 = __webpack_require__(13);
exports.SortingStateDefaults = {
    strategy: new sorting_strategy_1.SortingStrategy()
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PagingError;
(function (PagingError) {
    PagingError[PagingError["None"] = 0] = "None";
    PagingError[PagingError["IncorrectPageIndex"] = 1] = "IncorrectPageIndex";
    PagingError[PagingError["IncorrectRecordsPerPage"] = 2] = "IncorrectRecordsPerPage";
})(PagingError = exports.PagingError || (exports.PagingError = {}));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var data_util_1 = __webpack_require__(9);
var DataAccess;
(function (DataAccess) {
    DataAccess[DataAccess["OriginalData"] = 0] = "OriginalData";
    DataAccess[DataAccess["TransformedData"] = 1] = "TransformedData";
})(DataAccess = exports.DataAccess || (exports.DataAccess = {}));
var DataContainer = (function () {
    function DataContainer(data) {
        if (data === void 0) { data = []; }
        this.state = {};
        this.data = data;
        this.transformedData = data;
    }
    DataContainer.prototype.process = function (state) {
        if (state) {
            this.state = state;
        }
        this.transformedData = this.data;
        this.transformedData = data_util_1.DataUtil.process(this.data, this.state);
        return this;
    };
    DataContainer.prototype.getIndexOfRecord = function (record, dataAccess) {
        if (dataAccess === void 0) { dataAccess = DataAccess.OriginalData; }
        var data = this.accessData(dataAccess);
        return data.indexOf(record);
    };
    DataContainer.prototype.getRecordByIndex = function (index, dataAccess) {
        if (dataAccess === void 0) { dataAccess = DataAccess.OriginalData; }
        var data = this.accessData(dataAccess);
        return data[index];
    };
    DataContainer.prototype.getRecordInfoByKeyValue = function (fieldName, value, dataAccess) {
        if (dataAccess === void 0) { dataAccess = DataAccess.OriginalData; }
        var data = this.accessData(dataAccess);
        var len = data.length;
        var res = { index: -1, record: undefined };
        var i;
        for (i = 0; i < len; i++) {
            if (data[i][fieldName] === value) {
                res.index = i;
                res.record = data[i];
                break;
            }
        }
        return res;
    };
    DataContainer.prototype.addRecord = function (record, at) {
        var data = this.accessData(DataAccess.OriginalData);
        if (at === null || at === undefined) {
            data.push(record);
        }
        else {
            data.splice(at, 0, record);
        }
    };
    DataContainer.prototype.deleteRecord = function (record) {
        var index = this.getIndexOfRecord(record, DataAccess.OriginalData);
        return this.deleteRecordByIndex(index);
    };
    DataContainer.prototype.deleteRecordByIndex = function (index) {
        var data = this.accessData(DataAccess.OriginalData);
        return data.splice(index, 1).length === 1;
    };
    DataContainer.prototype.updateRecordByIndex = function (index, newProperties) {
        var dataAccess = DataAccess.OriginalData;
        var foundRec = this.getRecordByIndex(index, dataAccess);
        if (!foundRec) {
            return undefined;
        }
        return Object.assign(foundRec, newProperties);
    };
    DataContainer.prototype.accessData = function (dataAccess) {
        var res;
        switch (dataAccess) {
            case DataAccess.OriginalData:
                res = this.data;
                break;
            case DataAccess.TransformedData:
                res = this.transformedData;
                break;
        }
        return res;
    };
    return DataContainer;
}());
exports.DataContainer = DataContainer;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var data_util_1 = __webpack_require__(9);
var filtering_condition_1 = __webpack_require__(12);
var grid_common_1 = __webpack_require__(25);
var IgxColumnComponent = (function () {
    function IgxColumnComponent() {
        this.header = "";
        this.sortable = false;
        this.editable = false;
        this.filtering = false;
        this.hidden = false;
        this.movable = false;
        this.filteringCondition = filtering_condition_1.FilteringCondition.string.contains;
        this.filteringIgnoreCase = true;
        this.dataType = data_util_1.DataType.String;
    }
    IgxColumnComponent.prototype.ngAfterContentInit = function () {
        if (this.cellTemplate) {
            this.bodyTemplate = this.cellTemplate.template;
        }
        if (this.headTemplate) {
            this.headerTemplate = this.headTemplate.template;
        }
        if (this.footTemplate) {
            this.footerTemplate = this.footTemplate.template;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxColumnComponent.prototype, "field", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxColumnComponent.prototype, "header", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "sortable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "editable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "filtering", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "hidden", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "movable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxColumnComponent.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxColumnComponent.prototype, "index", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], IgxColumnComponent.prototype, "filteringCondition", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnComponent.prototype, "filteringIgnoreCase", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxColumnComponent.prototype, "dataType", void 0);
    __decorate([
        core_1.ContentChild(grid_common_1.IgxCellTemplateDirective),
        __metadata("design:type", grid_common_1.IgxCellTemplateDirective)
    ], IgxColumnComponent.prototype, "cellTemplate", void 0);
    __decorate([
        core_1.ContentChild(grid_common_1.IgxCellHeaderTemplateDirective),
        __metadata("design:type", grid_common_1.IgxCellHeaderTemplateDirective)
    ], IgxColumnComponent.prototype, "headTemplate", void 0);
    __decorate([
        core_1.ContentChild(grid_common_1.IgxCellFooterTemplateDirective),
        __metadata("design:type", grid_common_1.IgxCellFooterTemplateDirective)
    ], IgxColumnComponent.prototype, "footTemplate", void 0);
    IgxColumnComponent = __decorate([
        core_1.Component({
            selector: "igx-column",
            template: ""
        })
    ], IgxColumnComponent);
    return IgxColumnComponent;
}());
exports.IgxColumnComponent = IgxColumnComponent;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var sorting_expression_interface_1 = __webpack_require__(8);
var column_component_1 = __webpack_require__(24);
var IgxCellTemplateDirective = (function () {
    function IgxCellTemplateDirective(template) {
        this.template = template;
    }
    IgxCellTemplateDirective = __decorate([
        core_1.Directive({
            selector: "[igxCell]"
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], IgxCellTemplateDirective);
    return IgxCellTemplateDirective;
}());
exports.IgxCellTemplateDirective = IgxCellTemplateDirective;
var IgxCellHeaderTemplateDirective = (function () {
    function IgxCellHeaderTemplateDirective(template) {
        this.template = template;
    }
    IgxCellHeaderTemplateDirective = __decorate([
        core_1.Directive({
            selector: "[igxHeader]"
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], IgxCellHeaderTemplateDirective);
    return IgxCellHeaderTemplateDirective;
}());
exports.IgxCellHeaderTemplateDirective = IgxCellHeaderTemplateDirective;
var IgxCellFooterTemplateDirective = (function () {
    function IgxCellFooterTemplateDirective(template) {
        this.template = template;
    }
    IgxCellFooterTemplateDirective = __decorate([
        core_1.Directive({
            selector: "[igxFooter]"
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], IgxCellFooterTemplateDirective);
    return IgxCellFooterTemplateDirective;
}());
exports.IgxCellFooterTemplateDirective = IgxCellFooterTemplateDirective;
var IgxColumnSortingDirective = (function () {
    function IgxColumnSortingDirective() {
        this.sortDirection = sorting_expression_interface_1.SortingDirection.None;
        this.onSort = new core_1.EventEmitter();
    }
    Object.defineProperty(IgxColumnSortingDirective.prototype, "off", {
        get: function () {
            return this.sortDirection === sorting_expression_interface_1.SortingDirection.None;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxColumnSortingDirective.prototype, "asc", {
        get: function () {
            return this.sortDirection === sorting_expression_interface_1.SortingDirection.Asc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxColumnSortingDirective.prototype, "desc", {
        get: function () {
            return this.sortDirection === sorting_expression_interface_1.SortingDirection.Desc;
        },
        enumerable: true,
        configurable: true
    });
    IgxColumnSortingDirective.prototype.onClick = function (event) {
        if (this.column.sortable) {
            this.sortDirection = ++this.sortDirection > sorting_expression_interface_1.SortingDirection.Desc ? sorting_expression_interface_1.SortingDirection.None
                : this.sortDirection;
            this.onSort.emit({
                column: this.column,
                direction: this.sortDirection
            });
        }
    };
    __decorate([
        core_1.Input("igxColumnSorting"),
        __metadata("design:type", column_component_1.IgxColumnComponent)
    ], IgxColumnSortingDirective.prototype, "column", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxColumnSortingDirective.prototype, "sortDirection", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxColumnSortingDirective.prototype, "onSort", void 0);
    __decorate([
        core_1.HostBinding("class.off"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], IgxColumnSortingDirective.prototype, "off", null);
    __decorate([
        core_1.HostBinding("class.asc"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], IgxColumnSortingDirective.prototype, "asc", null);
    __decorate([
        core_1.HostBinding("class.desc"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], IgxColumnSortingDirective.prototype, "desc", null);
    __decorate([
        core_1.HostListener("click", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], IgxColumnSortingDirective.prototype, "onClick", null);
    IgxColumnSortingDirective = __decorate([
        core_1.Directive({
            selector: "[igxColumnSorting]"
        })
    ], IgxColumnSortingDirective);
    return IgxColumnSortingDirective;
}());
exports.IgxColumnSortingDirective = IgxColumnSortingDirective;
var IgxCellBodyComponent = (function () {
    function IgxCellBodyComponent(viewContainer) {
        this.viewContainer = viewContainer;
    }
    IgxCellBodyComponent.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.column.bodyTemplate, this);
    };
    IgxCellBodyComponent.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", column_component_1.IgxColumnComponent)
    ], IgxCellBodyComponent.prototype, "column", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxCellBodyComponent.prototype, "item", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCellBodyComponent.prototype, "rowIndex", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxCellBodyComponent.prototype, "row", void 0);
    IgxCellBodyComponent = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-cell-body",
            template: ""
        }),
        __metadata("design:paramtypes", [core_1.ViewContainerRef])
    ], IgxCellBodyComponent);
    return IgxCellBodyComponent;
}());
exports.IgxCellBodyComponent = IgxCellBodyComponent;
var IgxCellHeaderComponent = (function () {
    function IgxCellHeaderComponent(viewContainer) {
        this.viewContainer = viewContainer;
    }
    IgxCellHeaderComponent.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.column.headerTemplate, this);
    };
    IgxCellHeaderComponent.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", column_component_1.IgxColumnComponent)
    ], IgxCellHeaderComponent.prototype, "column", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCellHeaderComponent.prototype, "colIndex", void 0);
    IgxCellHeaderComponent = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-cell-header",
            template: ""
        }),
        __metadata("design:paramtypes", [core_1.ViewContainerRef])
    ], IgxCellHeaderComponent);
    return IgxCellHeaderComponent;
}());
exports.IgxCellHeaderComponent = IgxCellHeaderComponent;
var IgxCellFooterComponent = (function () {
    function IgxCellFooterComponent(viewContainer) {
        this.viewContainer = viewContainer;
    }
    IgxCellFooterComponent.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.column.footerTemplate, this);
    };
    IgxCellFooterComponent.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", column_component_1.IgxColumnComponent)
    ], IgxCellFooterComponent.prototype, "column", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCellFooterComponent.prototype, "colIndex", void 0);
    IgxCellFooterComponent = __decorate([
        core_1.Component({
            selector: "igx-cell-footer",
            template: ""
        }),
        __metadata("design:paramtypes", [core_1.ViewContainerRef])
    ], IgxCellFooterComponent);
    return IgxCellFooterComponent;
}());
exports.IgxCellFooterComponent = IgxCellFooterComponent;
var IgxColumnFilteringComponent = (function () {
    function IgxColumnFilteringComponent() {
        this.hidden = true;
        this.onFilter = new core_1.EventEmitter();
    }
    IgxColumnFilteringComponent.prototype.show = function () {
        this.hidden = false;
    };
    IgxColumnFilteringComponent.prototype.hide = function () {
        this.hidden = true;
    };
    IgxColumnFilteringComponent.prototype.toggle = function () {
        this.hidden = !this.hidden;
    };
    IgxColumnFilteringComponent.prototype.filterData = function (event) {
        this.onFilter.emit({
            column: this.column,
            value: event.target.value
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", column_component_1.IgxColumnComponent)
    ], IgxColumnFilteringComponent.prototype, "column", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxColumnFilteringComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxColumnFilteringComponent.prototype, "hidden", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxColumnFilteringComponent.prototype, "onFilter", void 0);
    IgxColumnFilteringComponent = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-col-filter",
            styles: [__webpack_require__(37)],
            template: __webpack_require__(39)
        })
    ], IgxColumnFilteringComponent);
    return IgxColumnFilteringComponent;
}());
exports.IgxColumnFilteringComponent = IgxColumnFilteringComponent;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(27);
var EVENT_SUFFIX = "precise";
var HammerGesturesManager = (function () {
    function HammerGesturesManager(_zone, doc) {
        this._zone = _zone;
        this.doc = doc;
        this.hammerOptions = {
            inputClass: Hammer.TouchInput,
            recognizers: [
                [Hammer.Pan, { threshold: 0 }],
                [Hammer.Pinch, { enable: true }],
                [Hammer.Rotate, { enable: true }],
                [Hammer.Swipe, {
                        direction: Hammer.DIRECTION_HORIZONTAL
                    }]
            ]
        };
        this._hammerManagers = [];
    }
    HammerGesturesManager.prototype.supports = function (eventName) {
        return eventName.toLowerCase().endsWith("." + EVENT_SUFFIX);
    };
    HammerGesturesManager.prototype.addEventListener = function (element, eventName, eventHandler, options) {
        var _this = this;
        if (options === void 0) { options = null; }
        return this._zone.runOutsideAngular(function () {
            var mc = _this.getManagerForElement(element);
            if (mc === null) {
                mc = new Hammer(element, _this.hammerOptions);
                _this.addManagerForElement(element, mc);
            }
            var handler = function (eventObj) { _this._zone.run(function () { eventHandler(eventObj); }); };
            mc.on(eventName, handler);
            return function () { mc.off(eventName, handler); };
        });
    };
    HammerGesturesManager.prototype.addGlobalEventListener = function (target, eventName, eventHandler) {
        var element = this.getGlobalEventTarget(target);
        return this.addEventListener(element, eventName, eventHandler);
    };
    HammerGesturesManager.prototype.getGlobalEventTarget = function (target) {
        return platform_browser_1.ɵgetDOM().getGlobalEventTarget(this.doc, target);
    };
    HammerGesturesManager.prototype.setManagerOption = function (element, event, options) {
        var manager = this.getManagerForElement(element);
        manager.get(event).set(options);
    };
    HammerGesturesManager.prototype.addManagerForElement = function (element, manager) {
        this._hammerManagers.push({ element: element, manager: manager });
    };
    HammerGesturesManager.prototype.getManagerForElement = function (element) {
        var result = this._hammerManagers.filter(function (value, index, array) {
            return value.element === element;
        });
        return result.length ? result[0].manager : null;
    };
    HammerGesturesManager.prototype.removeManagerForElement = function (element) {
        var index = null;
        for (var i = 0; i < this._hammerManagers.length; i++) {
            if (element === this._hammerManagers[i].element) {
                index = i;
                break;
            }
        }
        if (index !== null) {
            var item = this._hammerManagers.splice(index, 1)[0];
            item.manager.destroy();
        }
    };
    HammerGesturesManager.prototype.destroy = function () {
        for (var _i = 0, _a = this._hammerManagers; _i < _a.length; _i++) {
            var item = _a[_i];
            item.manager.destroy();
        }
        this._hammerManagers = [];
    };
    HammerGesturesManager = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
        __metadata("design:paramtypes", [core_1.NgZone, Object])
    ], HammerGesturesManager);
    return HammerGesturesManager;
}());
exports.HammerGesturesManager = HammerGesturesManager;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_27__;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(75);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var icon_component_1 = __webpack_require__(4);
var Type;
(function (Type) {
    Type[Type["DEFAULT"] = 0] = "DEFAULT";
    Type[Type["INFO"] = 1] = "INFO";
    Type[Type["SUCCESS"] = 2] = "SUCCESS";
    Type[Type["WARNING"] = 3] = "WARNING";
    Type[Type["ERROR"] = 4] = "ERROR";
})(Type = exports.Type || (exports.Type = {}));
var Position;
(function (Position) {
    Position[Position["TOP_LEFT"] = 0] = "TOP_LEFT";
    Position[Position["TOP_RIGHT"] = 1] = "TOP_RIGHT";
    Position[Position["BOTTOM_LEFT"] = 2] = "BOTTOM_LEFT";
    Position[Position["BOTTOM_RIGHT"] = 3] = "BOTTOM_RIGHT";
})(Position = exports.Position || (exports.Position = {}));
var IgxBadge = (function () {
    function IgxBadge() {
        this.typeEnum = Type;
        this.positionEnum = Position;
        this._type = "";
    }
    Object.defineProperty(IgxBadge.prototype, "type", {
        get: function () {
            return this._type === undefined ? "default" : this._type;
        },
        set: function (value) {
            var sizeType = this.typeEnum[value.toUpperCase()];
            this._type = sizeType === undefined ? "default" : value.toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxBadge.prototype, "position", {
        get: function () {
            return this._position === undefined ? "top-right" : this._position;
        },
        set: function (value) {
            var positionType = this.positionEnum[value.replace("-", "_").toUpperCase()];
            this._position = positionType === undefined ? "top-right" : value.toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxBadge.prototype, "value", {
        get: function () {
            return this._value === undefined ? "?" : this._value;
        },
        set: function (value) {
            this._value = value === undefined ? "-" : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxBadge.prototype, "iconBdg", {
        get: function () {
            return this._iconBdg;
        },
        set: function (value) {
            this._iconBdg = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxBadge.prototype, "roleDescription", {
        get: function () {
            var message;
            if (this._iconBdg) {
                message = this._type + " type badge with icon type " + this._iconBdg;
            }
            else if (this._value) {
                message = this._type + " badge type with value " + this._value;
            }
            else {
                message = this._type + " badge type without value";
            }
            return message;
        },
        enumerable: true,
        configurable: true
    });
    IgxBadge.prototype.setClasses = function () {
        var classes = {};
        switch (this.typeEnum[this._type.toUpperCase()]) {
            case Type.DEFAULT:
                classes = {
                    "igx-badge__circle--default": true
                };
                break;
            case Type.INFO:
                classes = {
                    "igx-badge__circle--info": true
                };
                break;
            case Type.SUCCESS:
                classes = {
                    "igx-badge__circle--success": true
                };
                break;
            case Type.WARNING:
                classes = {
                    "igx-badge__circle--warning": true
                };
                break;
            case Type.ERROR:
                classes = {
                    "igx-badge__circle--error": true
                };
                break;
        }
        return classes;
    };
    IgxBadge.prototype.setPosition = function () {
        var className = {};
        switch (this.positionEnum[this.position.replace("-", "_").toUpperCase()]) {
            case Position.BOTTOM_LEFT:
                className = {
                    "igx-badge--bottom-left": true
                };
                break;
            case Position.BOTTOM_RIGHT:
                className = {
                    "igx-badge--bottom-right": true
                };
                break;
            case Position.TOP_LEFT:
                className = {
                    "igx-badge--top-left": true
                };
                break;
            case Position.TOP_RIGHT:
                className = {
                    "igx-badge--top-right": true
                };
                break;
        }
        return className;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxBadge.prototype, "type", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxBadge.prototype, "position", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxBadge.prototype, "value", null);
    __decorate([
        core_1.Input("icon"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxBadge.prototype, "iconBdg", null);
    IgxBadge = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-badge",
            styles: [__webpack_require__(79)],
            template: __webpack_require__(81)
        })
    ], IgxBadge);
    return IgxBadge;
}());
exports.IgxBadge = IgxBadge;
var IgxBadgeModule = (function () {
    function IgxBadgeModule() {
    }
    IgxBadgeModule = __decorate([
        core_1.NgModule({
            declarations: [IgxBadge],
            exports: [IgxBadge],
            imports: [common_1.CommonModule, icon_component_1.IgxIconModule]
        })
    ], IgxBadgeModule);
    return IgxBadgeModule;
}());
exports.IgxBadgeModule = IgxBadgeModule;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var animations_2 = __webpack_require__(87);
var main_1 = __webpack_require__(15);
var icon_component_1 = __webpack_require__(4);
var calendar_1 = __webpack_require__(31);
var CalendarView;
(function (CalendarView) {
    CalendarView[CalendarView["DEFAULT"] = 0] = "DEFAULT";
    CalendarView[CalendarView["YEAR"] = 1] = "YEAR";
    CalendarView[CalendarView["DECADE"] = 2] = "DECADE";
})(CalendarView = exports.CalendarView || (exports.CalendarView = {}));
var IgxCalendarComponent = (function () {
    function IgxCalendarComponent(elementRef) {
        this.elementRef = elementRef;
        this.locale = "en";
        this.onSelection = new core_1.EventEmitter();
        this.formatOptions = {
            day: "numeric",
            month: "short",
            weekday: "short",
            year: "numeric"
        };
        this._activeView = CalendarView.DEFAULT;
        this._selection = "single";
        this._rangeStarted = false;
        this._monthAction = "";
        this._onTouchedCallback = function () { };
        this._onChangeCallback = function () { };
        this.calendarModel = new calendar_1.Calendar();
    }
    IgxCalendarComponent_1 = IgxCalendarComponent;
    Object.defineProperty(IgxCalendarComponent.prototype, "weekStart", {
        get: function () {
            return this.calendarModel.firstWeekDay;
        },
        set: function (value) {
            this.calendarModel.firstWeekDay = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "selection", {
        get: function () {
            return this._selection;
        },
        set: function (value) {
            switch (value) {
                case "single":
                    this.selectedDates = null;
                    break;
                case "multi":
                case "range":
                    this.selectedDates = [];
                    break;
                default:
                    throw new Error("Invalid selection value");
            }
            this._onChangeCallback(this.selectedDates);
            this._rangeStarted = false;
            this._selection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "viewDate", {
        get: function () {
            return this._viewDate;
        },
        set: function (value) {
            this._viewDate = new Date(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "value", {
        get: function () {
            return this.selectedDates;
        },
        set: function (val) {
            this.selectDate(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "activeView", {
        get: function () {
            return this._activeView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "monthAction", {
        get: function () {
            return this._monthAction;
        },
        enumerable: true,
        configurable: true
    });
    IgxCalendarComponent.prototype.registerOnChange = function (fn) { this._onChangeCallback = fn; };
    IgxCalendarComponent.prototype.registerOnTouched = function (fn) { this._onTouchedCallback = fn; };
    IgxCalendarComponent.prototype.writeValue = function (value) {
        this.selectedDates = value;
    };
    IgxCalendarComponent.prototype.ngOnInit = function () {
        this.calendarModel.firstWeekDay = this.weekStart;
        var today = new Date(Date.now());
        if (!this._viewDate) {
            this._viewDate = new Date(today);
        }
        this.headerDate = new Date(today);
    };
    IgxCalendarComponent.prototype.generateWeekHeader = function () {
        var dayNames = [];
        var rv = this.calendarModel.monthdatescalendar(this.viewDate.getFullYear(), this.viewDate.getMonth())[0];
        for (var _i = 0, rv_1 = rv; _i < rv_1.length; _i++) {
            var day = rv_1[_i];
            dayNames.push(day.date.toLocaleString(this.locale, { weekday: this.formatOptions.weekday }));
        }
        return dayNames;
    };
    Object.defineProperty(IgxCalendarComponent.prototype, "getCalendarMonth", {
        get: function () {
            return this.calendarModel.monthdatescalendar(this.viewDate.getFullYear(), this.viewDate.getMonth(), true);
        },
        enumerable: true,
        configurable: true
    });
    IgxCalendarComponent.prototype.onDateClick = function (event) {
        var target = event.target;
        if (target.nodeName.toLowerCase() !== "span") {
            return;
        }
        if (target.dataset.prevmonth) {
            this.prevMonth();
        }
        if (target.dataset.nextmonth) {
            this.nextMonth();
        }
        var value = new Date(this._viewDate.getFullYear(), this._viewDate.getMonth(), parseInt(target.textContent, 10));
        this.selectDate(value);
    };
    IgxCalendarComponent.prototype.selectDate = function (date) {
        switch (this.selection) {
            case "single":
                this.selectSingle(date);
                break;
            case "multi":
                this.selectMulti(date);
                break;
            case "range":
                this.selectRange(date);
                break;
            default:
                this.selectSingle(date);
        }
        this.onSelection.emit(this.selectedDates);
    };
    IgxCalendarComponent.prototype.handleKeyDown = function (event) {
        if (event.key.startsWith("Page")) {
            this.handlePageUpDown(event);
            return;
        }
        if (event.key.endsWith("Left") || event.key.endsWith("Right") ||
            event.key.endsWith("Up") || event.key.endsWith("Down")) {
            this.handleKeyboardNavigation(event);
            return;
        }
        switch (event.key) {
            case "Home":
                event.preventDefault();
                this.elementRef.nativeElement.querySelectorAll("[data-curmonth='true']")[0].focus();
                break;
            case "End":
                event.preventDefault();
                var curentDates = this.elementRef.nativeElement.querySelectorAll("[data-curmonth='true']");
                curentDates[curentDates.length - 1].focus();
                break;
            case "Enter":
                this.onDateClick(event);
                break;
            default:
                return;
        }
    };
    IgxCalendarComponent.prototype.selectSingle = function (newVal) {
        this.selectedDates = newVal;
        this._onChangeCallback(this.selectedDates);
    };
    IgxCalendarComponent.prototype.selectMulti = function (newVal) {
        if (newVal instanceof Array) {
            this.selectedDates = this.selectedDates.concat(newVal);
        }
        else {
            if (this.selectedDates.every(function (date) { return date.toDateString() !== newVal.toDateString(); })) {
                this.selectedDates.push(newVal);
            }
            else {
                this.selectedDates = this.selectedDates.filter(function (date) { return date.toDateString() !== newVal.toDateString(); });
            }
        }
        this._onChangeCallback(this.selectedDates);
    };
    IgxCalendarComponent.prototype.selectRange = function (newVal) {
        if (newVal instanceof Array) {
            this._rangeStarted = false;
            newVal.sort(function (a, b) { return a.valueOf() - b.valueOf(); });
            var start = newVal[0];
            this.selectedDates = [start];
            while (start.toDateString() !== newVal[newVal.length - 1].toDateString()) {
                start = this.calendarModel.timedelta(start, "day", 1);
                this.selectedDates.push(start);
            }
        }
        else {
            if (!this._rangeStarted) {
                this._rangeStarted = true;
                this.selectedDates = [newVal];
            }
            else {
                this._rangeStarted = false;
                if (this.selectedDates[0].toDateString() === newVal.toDateString()) {
                    this.selectedDates = [];
                    this._onChangeCallback(this.selectedDates);
                    return;
                }
                this.selectedDates.push(newVal);
                this.selectedDates.sort(function (a, b) { return a.valueOf() - b.valueOf(); });
                var start = this.selectedDates[0];
                var end = this.selectedDates.pop();
                while (start.toDateString() !== end.toDateString()) {
                    start = this.calendarModel.timedelta(start, "day", 1);
                    this.selectedDates.push(start);
                }
            }
        }
        this._onChangeCallback(this.selectedDates);
    };
    IgxCalendarComponent.prototype.prevMonth = function () {
        this._viewDate = this.calendarModel.timedelta(this._viewDate, "month", -1);
        this._monthAction = "prev";
    };
    IgxCalendarComponent.prototype.nextMonth = function () {
        this._viewDate = this.calendarModel.timedelta(this._viewDate, "month", 1);
        this._monthAction = "next";
    };
    IgxCalendarComponent.prototype.handleScroll = function (event) {
        event.preventDefault();
        event.stopPropagation();
        var currentYear = new Date(Date.now()).getFullYear();
        var delta = event.deltaY < 0 ? 1 : -1;
        if (delta > 0 && this._viewDate.getFullYear() - currentYear >= 95) {
            return;
        }
        if (delta < 0 && currentYear - this._viewDate.getFullYear() >= 95) {
            return;
        }
        this._viewDate = this.calendarModel.timedelta(this._viewDate, "year", delta);
    };
    IgxCalendarComponent.prototype.handlePageUpDown = function (event) {
        event.preventDefault();
        if (event.key === "PageUp") {
            if (event.shiftKey) {
                this.viewDate = this.calendarModel.timedelta(this.viewDate, "year", -1);
            }
            else {
                this.prevMonth();
            }
        }
        else {
            if (event.shiftKey) {
                this.viewDate = this.calendarModel.timedelta(this.viewDate, "year", 1);
            }
            else {
                this.nextMonth();
            }
        }
    };
    IgxCalendarComponent.prototype.handleKeyboardNavigation = function (event) {
        event.preventDefault();
        if (event.target.nodeName.toLowerCase() !== "span") {
            return;
        }
        var target = event.target;
        var dest = null;
        if (event.key.endsWith("Left")) {
            dest = target.previousElementSibling;
            if (dest) {
                dest.focus();
            }
        }
        if (event.key.endsWith("Right")) {
            dest = target.nextElementSibling;
            if (dest) {
                dest.focus();
            }
        }
        if (event.key.endsWith("Down")) {
            var targetIndex = Array.from(target.parentNode.children).indexOf(target);
            dest = target.parentNode.nextElementSibling;
            if (dest) {
                dest.children[targetIndex].focus();
            }
        }
        if (event.key.endsWith("Up")) {
            var targetIndex = Array.from(target.parentNode.children).indexOf(target);
            dest = target.parentNode.previousElementSibling;
            if (dest) {
                dest.children[targetIndex].focus();
            }
        }
    };
    IgxCalendarComponent.prototype.getMonthName = function (date) {
        return date.toLocaleString(this.locale, { month: this.formatOptions.month });
    };
    IgxCalendarComponent.prototype.getFormattedDate = function () {
        var date = this.selectedDates ? this.selectedDates : this.headerDate;
        return {
            monthday: date.toLocaleString(this.locale, { month: this.formatOptions.month, day: this.formatOptions.day }),
            weekday: date.toLocaleString(this.locale, { weekday: this.formatOptions.weekday })
        };
    };
    IgxCalendarComponent.prototype.getHeaderYear = function () {
        var res = this.headerDate.toLocaleString(this.locale, { year: this.formatOptions.year });
        if (this.selectedDates) {
            res = this.selectedDates.toLocaleString(this.locale, { year: this.formatOptions.year });
        }
        return res;
    };
    IgxCalendarComponent.prototype.isInactive = function (day) {
        return day.isNextMonth || day.isPrevMonth;
    };
    IgxCalendarComponent.prototype.isWeekend = function (day) {
        return day.date.getDay() === 0 || day.date.getDay() === 6;
    };
    IgxCalendarComponent.prototype.isCurrentMonth = function (value) {
        return this.viewDate.getMonth() === value.getMonth();
    };
    IgxCalendarComponent.prototype.isCurrentYear = function (value) {
        return this.viewDate.getFullYear() === value;
    };
    IgxCalendarComponent.prototype.isSelected = function (day) {
        if (this.selection === "multi" || this.selection === "range") {
            for (var _i = 0, _a = this.selectedDates; _i < _a.length; _i++) {
                var date = _a[_i];
                if (date.toDateString() === day.date.toDateString()) {
                    return true;
                }
            }
            return false;
        }
        if (this.selectedDates) {
            return day.date.toDateString() === this.selectedDates.toDateString();
        }
        return false;
    };
    IgxCalendarComponent.prototype.isToday = function (day) {
        var today = new Date(Date.now());
        return (day.date.getFullYear() === today.getFullYear() &&
            day.date.getMonth() === today.getMonth() &&
            day.date.getDate() === today.getDate());
    };
    Object.defineProperty(IgxCalendarComponent.prototype, "isDefaultView", {
        get: function () {
            return this.activeView === CalendarView.DEFAULT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "isYearView", {
        get: function () {
            return this.activeView === CalendarView.YEAR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCalendarComponent.prototype, "isDecadeView", {
        get: function () {
            return this.activeView === CalendarView.DECADE;
        },
        enumerable: true,
        configurable: true
    });
    IgxCalendarComponent.prototype.activeViewYear = function () {
        this._activeView = CalendarView.YEAR;
    };
    IgxCalendarComponent.prototype.activeViewDecade = function () {
        this._activeView = CalendarView.DECADE;
    };
    IgxCalendarComponent.prototype.getDecade = function () {
        var res = [];
        var start = this._viewDate.getFullYear() - 5;
        var end = this._viewDate.getFullYear() + 6;
        for (var _i = 0, _a = calendar_1.range(start, end); _i < _a.length; _i++) {
            var year = _a[_i];
            res.push(year);
        }
        return res;
    };
    IgxCalendarComponent.prototype.getYear = function () {
        var start = new Date(this._viewDate.getFullYear(), 0, 1);
        var res = [];
        for (var i = 0; i < 12; i++) {
            res.push(start);
            start = this.calendarModel.timedelta(start, "month", 1);
        }
        return res;
    };
    IgxCalendarComponent.prototype.changeYear = function (event) {
        var year = parseInt(event.target.textContent, 10);
        this._viewDate = new Date(year, this._viewDate.getMonth(), 1);
        this._activeView = CalendarView.DEFAULT;
    };
    IgxCalendarComponent.prototype.changeMonth = function (event) {
        var month = event.target.dataset.index;
        this._viewDate = new Date(this._viewDate.getFullYear(), month, 1);
        this._activeView = CalendarView.DEFAULT;
    };
    IgxCalendarComponent.prototype.dateTracker = function (index, item) {
        return item.date.getMonth() + "--" + item.date.getDate();
    };
    IgxCalendarComponent.prototype.rowTracker = function (index, item) {
        return "" + item[index].date.getMonth() + item[index].date.getDate();
    };
    IgxCalendarComponent.prototype.monthTracker = function (index, item) {
        return index;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxCalendarComponent.prototype, "weekStart", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxCalendarComponent.prototype, "locale", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [Object])
    ], IgxCalendarComponent.prototype, "selection", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Date),
        __metadata("design:paramtypes", [Date])
    ], IgxCalendarComponent.prototype, "viewDate", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCalendarComponent.prototype, "onSelection", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], IgxCalendarComponent.prototype, "value", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxCalendarComponent.prototype, "formatOptions", void 0);
    IgxCalendarComponent = IgxCalendarComponent_1 = __decorate([
        core_1.Component({
            animations: [
                animations_1.trigger("animateView", [
                    animations_1.transition("void => 0", animations_1.useAnimation(main_1.fadeIn)),
                    animations_1.transition("void => *", animations_1.useAnimation(main_1.scaleInCenter, {
                        params: {
                            duration: ".2s",
                            fromScale: .9
                        }
                    }))
                ]),
                animations_1.trigger("animateChange", [
                    animations_1.transition("* => prev", animations_1.useAnimation(main_1.slideInLeft, {
                        params: {
                            fromPosition: "translateX(-30%)"
                        }
                    })),
                    animations_1.transition("* => next", animations_1.useAnimation(main_1.slideInRight, {
                        params: {
                            fromPosition: "translateX(30%)"
                        }
                    }))
                ])
            ],
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxCalendarComponent_1, multi: true }],
            selector: "igx-calendar",
            styles: [__webpack_require__(88)],
            template: __webpack_require__(90)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], IgxCalendarComponent);
    return IgxCalendarComponent;
    var IgxCalendarComponent_1;
}());
exports.IgxCalendarComponent = IgxCalendarComponent;
var IgxCalendarModule = (function () {
    function IgxCalendarModule() {
    }
    IgxCalendarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxCalendarComponent],
            exports: [IgxCalendarComponent],
            imports: [common_1.CommonModule, forms_1.FormsModule, animations_2.BrowserAnimationsModule, icon_component_1.IgxIconModule]
        })
    ], IgxCalendarModule);
    return IgxCalendarModule;
}());
exports.IgxCalendarModule = IgxCalendarModule;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MDAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var FEBRUARY = 1;
function range(start, stop, step) {
    if (start === void 0) { start = 0; }
    if (step === void 0) { step = 1; }
    var res = [];
    var cur = (stop === undefined) ? 0 : start;
    var max = (stop === undefined) ? start : stop;
    for (var i = cur; step < 0 ? i > max : i < max; i += step) {
        res.push(i);
    }
    return res;
}
exports.range = range;
function isLeap(year) {
    return (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0));
}
exports.isLeap = isLeap;
function weekDay(year, month, day) {
    return new Date(year, month, day).getDay();
}
exports.weekDay = weekDay;
function monthRange(year, month) {
    if ((month < 0) || (month > 11)) {
        throw new Error("Invalid month specified");
    }
    var day = weekDay(year, month, 1);
    var nDays = MDAYS[month];
    if ((month === FEBRUARY) && (isLeap(year))) {
        nDays++;
    }
    return [day, nDays];
}
exports.monthRange = monthRange;
var WEEKDAYS;
(function (WEEKDAYS) {
    WEEKDAYS[WEEKDAYS["SUNDAY"] = 0] = "SUNDAY";
    WEEKDAYS[WEEKDAYS["MONDAY"] = 1] = "MONDAY";
    WEEKDAYS[WEEKDAYS["TUESDAY"] = 2] = "TUESDAY";
    WEEKDAYS[WEEKDAYS["WEDNESDAY"] = 3] = "WEDNESDAY";
    WEEKDAYS[WEEKDAYS["THURSDAY"] = 4] = "THURSDAY";
    WEEKDAYS[WEEKDAYS["FRIDAY"] = 5] = "FRIDAY";
    WEEKDAYS[WEEKDAYS["SATURDAY"] = 6] = "SATURDAY";
})(WEEKDAYS = exports.WEEKDAYS || (exports.WEEKDAYS = {}));
var Calendar = (function () {
    function Calendar(firstWeekDay) {
        if (firstWeekDay === void 0) { firstWeekDay = WEEKDAYS.SUNDAY; }
        this._firstWeekDay = firstWeekDay;
    }
    Object.defineProperty(Calendar.prototype, "firstWeekDay", {
        get: function () {
            return this._firstWeekDay % 7;
        },
        set: function (value) {
            this._firstWeekDay = value;
        },
        enumerable: true,
        configurable: true
    });
    Calendar.prototype.weekdays = function () {
        var res = [];
        for (var _i = 0, _a = range(this.firstWeekDay, this.firstWeekDay + 7); _i < _a.length; _i++) {
            var i = _a[_i];
            res.push(i % 7);
        }
        return res;
    };
    Calendar.prototype.monthdates = function (year, month, extraWeek) {
        if (extraWeek === void 0) { extraWeek = false; }
        var date = new Date(year, month, 1, 12, 0, 0, 0);
        var days = (date.getDay() - this.firstWeekDay) % 7;
        if (days < 0) {
            days = 7 - Math.abs(days);
        }
        date = this.timedelta(date, "day", -days);
        var res = [];
        var value;
        while (true) {
            value = this.generateICalendarDate(date, year, month);
            res.push(value);
            date = this.timedelta(date, "day", 1);
            if ((date.getMonth() !== month) && (date.getDay() === this.firstWeekDay)) {
                if (extraWeek && res.length <= 35) {
                    for (var _i = 0, _a = range(0, 7); _i < _a.length; _i++) {
                        var i = _a[_i];
                        value = this.generateICalendarDate(date, year, month);
                        res.push(value);
                        date = this.timedelta(date, "day", 1);
                    }
                }
                break;
            }
        }
        return res;
    };
    Calendar.prototype.monthdatescalendar = function (year, month, extraWeek) {
        if (extraWeek === void 0) { extraWeek = false; }
        var dates = this.monthdates(year, month, extraWeek);
        var res = [];
        for (var _i = 0, _a = range(0, dates.length, 7); _i < _a.length; _i++) {
            var i = _a[_i];
            res.push(dates.slice(i, i + 7));
        }
        return res;
    };
    Calendar.prototype.timedelta = function (date, interval, units) {
        var ret = new Date(date);
        var checkRollover = function () {
            if (ret.getDate() !== date.getDate()) {
                ret.setDate(0);
            }
        };
        switch (interval.toLowerCase()) {
            case "year":
                ret.setFullYear(ret.getFullYear() + units);
                checkRollover();
                break;
            case "quarter":
                ret.setMonth(ret.getMonth() + 3 * units);
                checkRollover();
                break;
            case "month":
                ret.setMonth(ret.getMonth() + units);
                checkRollover();
                break;
            case "week":
                ret.setDate(ret.getDate() + 7 * units);
                break;
            case "day":
                ret.setDate(ret.getDate() + units);
                break;
            case "hour":
                ret.setTime(ret.getTime() + units * 3600000);
                break;
            case "minute":
                ret.setTime(ret.getTime() + units * 60000);
                break;
            case "second":
                ret.setTime(ret.getTime() + units * 1000);
                break;
            default:
                throw new Error("Invalid interval specifier");
        }
        return ret;
    };
    Calendar.prototype.generateICalendarDate = function (date, year, month) {
        return {
            date: date,
            isCurrentMonth: date.getFullYear() === year && date.getMonth() === month,
            isNextMonth: this.isNextMonth(date, year, month),
            isPrevMonth: this.isPreviousMonth(date, year, month)
        };
    };
    Calendar.prototype.isPreviousMonth = function (date, year, month) {
        if (date.getFullYear() === year) {
            return date.getMonth() < month;
        }
        return date.getFullYear() < year;
    };
    Calendar.prototype.isNextMonth = function (date, year, month) {
        if (date.getFullYear() === year) {
            return date.getMonth() > month;
        }
        return date.getFullYear() > year;
    };
    return Calendar;
}());
exports.Calendar = Calendar;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(115);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(17));
__export(__webpack_require__(11));
__export(__webpack_require__(12));
__export(__webpack_require__(19));
__export(__webpack_require__(20));
__export(__webpack_require__(8));
__export(__webpack_require__(21));
__export(__webpack_require__(13));
__export(__webpack_require__(35));
__export(__webpack_require__(22));
__export(__webpack_require__(9));
__export(__webpack_require__(23));
__export(__webpack_require__(36));
__export(__webpack_require__(61));
__export(__webpack_require__(4));
__export(__webpack_require__(6));
__export(__webpack_require__(70));
__export(__webpack_require__(74));
__export(__webpack_require__(78));
__export(__webpack_require__(30));
__export(__webpack_require__(91));
__export(__webpack_require__(16));
__export(__webpack_require__(96));
__export(__webpack_require__(100));
__export(__webpack_require__(104));
__export(__webpack_require__(105));
__export(__webpack_require__(109));
__export(__webpack_require__(113));
__export(__webpack_require__(14));
__export(__webpack_require__(114));
__export(__webpack_require__(118));
__export(__webpack_require__(122));
__export(__webpack_require__(10));
__export(__webpack_require__(29));
__export(__webpack_require__(123));
__export(__webpack_require__(127));
__export(__webpack_require__(131));
__export(__webpack_require__(135));
__export(__webpack_require__(139));
__export(__webpack_require__(143));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var nav_service_1 = __webpack_require__(18);
var NavigationToggle = (function () {
    function NavigationToggle(nav) {
        this.state = nav;
    }
    NavigationToggle.prototype.toggleNavigationDrawer = function () {
        this.state.toggle(this.target, true);
    };
    __decorate([
        core_1.Input("igxNavToggle"),
        __metadata("design:type", Object)
    ], NavigationToggle.prototype, "target", void 0);
    __decorate([
        core_1.HostListener("click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavigationToggle.prototype, "toggleNavigationDrawer", null);
    NavigationToggle = __decorate([
        core_1.Directive({ selector: "[igxNavToggle]" }),
        __metadata("design:paramtypes", [nav_service_1.NavigationService])
    ], NavigationToggle);
    return NavigationToggle;
}());
exports.NavigationToggle = NavigationToggle;
var NavigationClose = (function () {
    function NavigationClose(nav) {
        this.state = nav;
    }
    NavigationClose.prototype.closeNavigationDrawer = function () {
        this.state.close(this.target, true);
    };
    __decorate([
        core_1.Input("igxNavClose"),
        __metadata("design:type", Object)
    ], NavigationClose.prototype, "target", void 0);
    __decorate([
        core_1.HostListener("click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavigationClose.prototype, "closeNavigationDrawer", null);
    NavigationClose = __decorate([
        core_1.Directive({ selector: "[igxNavClose]" }),
        __metadata("design:paramtypes", [nav_service_1.NavigationService])
    ], NavigationClose);
    return NavigationClose;
}());
exports.NavigationClose = NavigationClose;
var IgxNavigationDirectives = (function () {
    function IgxNavigationDirectives() {
    }
    IgxNavigationDirectives = __decorate([
        core_1.NgModule({
            declarations: [NavigationClose, NavigationToggle],
            exports: [NavigationClose, NavigationToggle],
            providers: [nav_service_1.NavigationService]
        })
    ], IgxNavigationDirectives);
    return IgxNavigationDirectives;
}());
exports.IgxNavigationDirectives = IgxNavigationDirectives;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var sorting_strategy_1 = __webpack_require__(13);
var StableSortingStrategy = (function (_super) {
    __extends(StableSortingStrategy, _super);
    function StableSortingStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StableSortingStrategy.prototype.compareObjects = function (obj1, obj2) {
        var res = _super.prototype.compareObjects.apply(this, arguments);
        var replacerFn = function (key, val) {
            if (val === undefined) {
                return null;
            }
            return val;
        };
        if (!res) {
            return JSON.stringify(obj1, replacerFn)
                .localeCompare(JSON.stringify(obj2, replacerFn));
        }
        return res;
    };
    return StableSortingStrategy;
}(sorting_strategy_1.SortingStrategy));
exports.StableSortingStrategy = StableSortingStrategy;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var data_container_1 = __webpack_require__(23);
var column_component_1 = __webpack_require__(24);
var grid_common_1 = __webpack_require__(25);
var paginator_component_1 = __webpack_require__(40);
var button_directive_1 = __webpack_require__(6);
var data_util_1 = __webpack_require__(9);
var sorting_expression_interface_1 = __webpack_require__(8);
var dialog_component_1 = __webpack_require__(14);
var dragdrop_directive_1 = __webpack_require__(54);
var icon_component_1 = __webpack_require__(4);
var input_directive_1 = __webpack_require__(16);
var IgxGridComponent = (function () {
    function IgxGridComponent(_renderer, _elementRef, _detector, _itDiff, _resolver, _viewRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._detector = _detector;
        this._itDiff = _itDiff;
        this._resolver = _resolver;
        this._viewRef = _viewRef;
        this.perPage = 25;
        this.state = {};
        this.id = "igx-grid-" + IgxGridComponent_1.nextId++;
        this.autoGenerate = false;
        this.onEditDone = new core_1.EventEmitter();
        this.onFilterDone = new core_1.EventEmitter();
        this.onSortingDone = new core_1.EventEmitter();
        this.onMovingDone = new core_1.EventEmitter();
        this.onCellSelection = new core_1.EventEmitter();
        this.onRowSelection = new core_1.EventEmitter();
        this.onPagingDone = new core_1.EventEmitter();
        this.onColumnInit = new core_1.EventEmitter();
        this.onBeforeProcess = new core_1.EventEmitter();
        this.dataContainer = new data_container_1.DataContainer([]);
        this.columns = [];
        this.filteringExpressions = {};
        this.sortingExpressions = {};
        this._paging = false;
        this.shouldDataBind = false;
        this._differ = this._itDiff.find([]).create(null);
    }
    IgxGridComponent_1 = IgxGridComponent;
    Object.defineProperty(IgxGridComponent.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
            this.dataContainer.data = value;
            this.shouldDataBind = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "paging", {
        get: function () {
            return this._paging;
        },
        set: function (value) {
            this._paging = value;
            if (this._paging) {
                var state = { index: 0, recordsPerPage: this.perPage };
                this.state.paging = data_util_1.DataUtil.mergeDefaultProperties(this.state.paging, state);
            }
            else {
                this.state.paging = null;
            }
            this.shouldDataBind = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "columnsToRender", {
        get: function () {
            return this.columns.filter(function (col) { return !col.hidden; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "hasEditableColumns", {
        get: function () {
            return this.columns.some(function (col) { return col.editable; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "hasSorting", {
        get: function () {
            return this.columns.some(function (col) { return col.sortable; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "hasFiltering", {
        get: function () {
            return this.columns.some(function (col) { return col.filtering; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxGridComponent.prototype, "editableColumns", {
        get: function () {
            var res = [];
            this.columns.forEach(function (col) {
                if (col.editable) {
                    res.push(col);
                }
            });
            return res;
        },
        enumerable: true,
        configurable: true
    });
    IgxGridComponent.prototype.ngOnInit = function () {
        this.dataContainer.state = this.state;
        if (this.paging) {
            var state = { index: 0, recordsPerPage: this.perPage };
            this.state.paging = data_util_1.DataUtil.mergeDefaultProperties(this.state.paging, state);
        }
    };
    IgxGridComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.data && this.autoGenerate) {
            this.autogenerate();
        }
        else {
            this.checkColumns();
        }
        this.colDiffer = this.cols.changes.subscribe(function (_) {
            _this.checkColumns();
            _this._detector.markForCheck();
        });
    };
    IgxGridComponent.prototype.ngDoCheck = function () {
        var diff = this._differ.diff(this.data);
        if (this.shouldDataBind || diff) {
            var bindingBehavior = {
                process: function (dataContainer) {
                    dataContainer.process();
                }
            };
            this.onBeforeProcess.emit(bindingBehavior);
            bindingBehavior.process(this.dataContainer);
            this.shouldDataBind = false;
        }
    };
    IgxGridComponent.prototype.ngOnDestroy = function () {
        this.colDiffer.unsubscribe();
    };
    IgxGridComponent.prototype.getColumnByIndex = function (index) {
        return this.columns[index];
    };
    IgxGridComponent.prototype.getColumnByField = function (field) {
        return this.columns.find(function (col) { return col.field === field; });
    };
    IgxGridComponent.prototype.formatBody = function (record, column) {
        if (!column.bodyTemplate) {
            return "" + record[column.field];
        }
    };
    IgxGridComponent.prototype.formatHeader = function (column) {
        if (!column.headerTemplate) {
            return "" + (column.header || column.field);
        }
    };
    IgxGridComponent.prototype.getCell = function (rowIndex, columnField) {
        var result = {
            columnField: columnField,
            dataItem: null,
            element: null,
            rowIndex: rowIndex
        };
        var column = this.getColumnByField(columnField);
        var colIndex = this.columnsToRender.indexOf(column);
        var record = this.dataContainer.getRecordByIndex(rowIndex, data_container_1.DataAccess.TransformedData);
        var element = this._elementRef.nativeElement
            .querySelector("td[data-row=\"" + rowIndex + "\"][data-col=\"" + colIndex + "\"]");
        if (record) {
            result.dataItem = record[column.field];
        }
        if (element) {
            result.element = element;
        }
        return result;
    };
    IgxGridComponent.prototype.getRow = function (rowIndex) {
        var _this = this;
        var result = {
            cells: [],
            element: null,
            index: rowIndex,
            record: null
        };
        var colFields = [];
        this.columns.forEach(function (col) { return colFields.push(col.field); });
        var record = this.dataContainer.getRecordByIndex(rowIndex, data_container_1.DataAccess.TransformedData);
        var element = this._elementRef.nativeElement.querySelector("tbody > tr[data-row=\"" + rowIndex + "\"]");
        if (record) {
            result.record = record;
            Object.keys(record).forEach(function (field) {
                if (colFields.indexOf(field) !== -1) {
                    result.cells.push(_this.getCell(rowIndex, field));
                }
            });
        }
        if (element) {
            result.element = element;
        }
        return result;
    };
    IgxGridComponent.prototype.focusCell = function (rowIndex, columnIndex) {
        var cell = this._elementRef.nativeElement
            .querySelector("td[data-row=\"" + rowIndex + "\"][data-col=\"" + columnIndex + "\"]");
        if (cell) {
            cell.focus();
        }
    };
    IgxGridComponent.prototype.focusRow = function (index) {
        var row = this._elementRef.nativeElement.querySelector("tbody > tr[data-row=\"" + index + "\"]");
        if (row) {
            row.focus();
        }
    };
    IgxGridComponent.prototype.filterData = function (searchTerm, column) {
        var _this = this;
        var filterInput = searchTerm;
        if (!searchTerm) {
            delete this.filteringExpressions[column.field];
        }
        else {
            switch (column.dataType) {
                case data_util_1.DataType.Number:
                    filterInput = parseFloat(searchTerm);
                    break;
                case data_util_1.DataType.Boolean:
                    filterInput = Boolean(searchTerm);
                    break;
                default:
                    break;
            }
            var expr = {
                condition: column.filteringCondition,
                fieldName: column.field,
                ignoreCase: column.filteringIgnoreCase,
                searchVal: filterInput
            };
            this.filteringExpressions[column.field] = expr;
        }
        var result = [];
        Object.keys(this.filteringExpressions)
            .forEach(function (expr) { return result.push(_this.filteringExpressions[expr]); });
        this.dataContainer.state.filtering = {
            expressions: result
        };
        if (this.paging) {
            this.dataContainer.state.paging.index = 0;
        }
        this.shouldDataBind = true;
        this.onFilterDone.emit({
            column: column,
            expression: this.filteringExpressions[column.field]
        });
    };
    IgxGridComponent.prototype.addRow = function (rowData, at) {
        this.dataContainer.addRecord(rowData, at);
        this.shouldDataBind = true;
    };
    IgxGridComponent.prototype.deleteRow = function (row) {
        if (typeof row === "object") {
            this.dataContainer.deleteRecord(row);
        }
        else if (typeof row === "number") {
            this.dataContainer.deleteRecordByIndex(row);
        }
        else if (typeof row === "string" && !isNaN(parseInt(row, 10))) {
            this.dataContainer.deleteRecordByIndex(parseInt(row, 10));
        }
        this.shouldDataBind = true;
    };
    IgxGridComponent.prototype.updateRow = function (index, rowData) {
        this.dataContainer.updateRecordByIndex(index, rowData);
        this.onEditDone.emit({ row: this.getRow(index) });
    };
    IgxGridComponent.prototype.updateCell = function (index, columnField, value) {
        var row = this.getRow(index);
        row.index = this.dataContainer.getIndexOfRecord(row.record);
        row.record[columnField] = value;
        this.updateRow(row.index, row.record);
        this.shouldDataBind = true;
    };
    IgxGridComponent.prototype.sortColumn = function (column, direction) {
        var _this = this;
        if (direction === sorting_expression_interface_1.SortingDirection.None) {
            delete this.sortingExpressions[column.field];
        }
        else {
            var expr = {
                dir: direction,
                fieldName: column.field,
                ignoreCase: true
            };
            this.sortingExpressions[column.field] = expr;
        }
        var result = [];
        Object.keys(this.sortingExpressions)
            .forEach(function (expr) { return result.push(_this.sortingExpressions[expr]); });
        this.dataContainer.state.sorting = this.dataContainer.state.sorting || { expressions: [] };
        this.dataContainer.state.sorting.expressions = result;
        this.shouldDataBind = true;
        this.onSortingDone.emit({
            column: column,
            direction: direction,
            expression: this.sortingExpressions[column.field]
        });
    };
    IgxGridComponent.prototype.paginate = function (page) {
        this.paginator.paginate(page);
    };
    IgxGridComponent.prototype.navigate = function (event) {
        var key = event.key;
        var row = event.target.dataset.row;
        var column = event.target.dataset.col;
        row = parseInt(row, 10);
        column = parseInt(column, 10);
        if (key.endsWith("Left")) {
            this.focusCell(row, column - 1);
        }
        else if (key.endsWith("Right")) {
            this.focusCell(row, column + 1);
        }
        else if (key.endsWith("Up")) {
            this.focusCell(row - 1, column);
        }
        else if (key.endsWith("Down")) {
            this.focusCell(row + 1, column);
        }
    };
    IgxGridComponent.prototype.checkColumns = function () {
        var _this = this;
        this.columns = this.cols.toArray();
        this.columns.forEach(function (col, index) {
            col.index = index;
            _this.onColumnInit.emit({ column: col });
        });
    };
    IgxGridComponent.prototype.onRowFocus = function (event, index) {
        var el = event.target;
        this._renderer.setAttribute(el, "aria-selected", "true");
        this._renderer.addClass(el, "igx-grid__tr--selected");
        this.onRowSelection.emit({ row: this.getRow(index) });
    };
    IgxGridComponent.prototype.onRowBlur = function (event) {
        var el = event.target;
        this._renderer.removeAttribute(el, "aria-selected");
        this._renderer.removeClass(el, "igx-grid__tr--selected");
    };
    IgxGridComponent.prototype.onCellFocus = function (event, index, columnField) {
        var el = event.target ? event.target : event;
        this._renderer.setAttribute(el, "aria-selected", "true");
        if (!this.getColumnByField(columnField).bodyTemplate) {
            this._renderer.addClass(el, "igx-grid__td--selected");
            this._renderer.addClass(el.parentElement, "igx-grid__tr--selected");
        }
        this.onCellSelection.emit({ cell: this.getCell(index, columnField) });
    };
    IgxGridComponent.prototype.onCellBlur = function (event) {
        var el = event.target;
        this._renderer.removeAttribute(el, "aria-selected");
        this._renderer.removeClass(el, "igx-grid__td--selected");
        this._renderer.removeClass(el.parentElement, "igx-grid__tr--selected");
    };
    IgxGridComponent.prototype.editCell = function (index, item, row) {
        if (!this.hasEditableColumns) {
            return;
        }
        this._lastRow = row;
        this.selectedRow = {
            index: index,
            item: item,
            row: Object.assign({}, row)
        };
        this.editingModal.open();
    };
    IgxGridComponent.prototype.processFilter = function (event) {
        this.filterData(event.value, event.column);
    };
    IgxGridComponent.prototype._setValue = function (field, event) {
        this.selectedRow.row[field] = event;
    };
    IgxGridComponent.prototype.getSortedExpression = function (column) {
        var dir = 0;
        if (column.sortable && this.state.sorting) {
            var expr = this.state.sorting.expressions
                .filter(function (each) { return each.fieldName === column.field; });
            if (expr && expr.length) {
                dir = expr[0].dir;
            }
        }
        return dir;
    };
    IgxGridComponent.prototype.cancelEdit = function () {
        this.selectedRow.row = this._lastRow;
        if (this.paging) {
            this.selectedRow.index = this.dataContainer.getIndexOfRecord(this._lastRow);
        }
        this.updateRow(this.selectedRow.index, this.selectedRow.row);
        this.shouldDataBind = true;
        this.editingModal.close();
    };
    IgxGridComponent.prototype.saveData = function () {
        if (this.paging) {
            this.selectedRow.index = this.dataContainer.getIndexOfRecord(this._lastRow);
        }
        this.updateRow(this.selectedRow.index, this.selectedRow.row);
        this.shouldDataBind = true;
        this.editingModal.close();
    };
    IgxGridComponent.prototype.moveColumn = function (event) {
        this.columns[event.dragData].index = event.dropData;
        this.columns[event.dropData].index = event.dragData;
        var temp = this.columns[event.dragData];
        this.columns[event.dragData] = this.columns[event.dropData];
        this.columns[event.dropData] = temp;
        this.onMovingDone.emit(event);
    };
    IgxGridComponent.prototype.processSort = function (event) {
        this.sortColumn(event.column, event.direction);
    };
    IgxGridComponent.prototype._paginate = function (event) {
        this.dataContainer.state.paging = {
            index: event.currentPage,
            recordsPerPage: event.perPage
        };
        this.shouldDataBind = true;
        this.onPagingDone.emit(event);
    };
    IgxGridComponent.prototype.autogenerate = function () {
        var _this = this;
        var factory = this._resolver
            .resolveComponentFactory(column_component_1.IgxColumnComponent);
        var colFields = Object.keys(this.data[0]);
        colFields.forEach(function (field, index) {
            var ref = _this._viewRef.createComponent(factory);
            ref.instance.field = field;
            ref.instance.index = index;
            _this.onColumnInit.emit({ column: ref.instance });
            _this.columns.push(ref.instance);
            ref.changeDetectorRef.detectChanges();
        });
    };
    IgxGridComponent.nextId = 1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], IgxGridComponent.prototype, "data", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxGridComponent.prototype, "perPage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "state", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], IgxGridComponent.prototype, "paging", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxGridComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxGridComponent.prototype, "autoGenerate", void 0);
    __decorate([
        core_1.ViewChild(dialog_component_1.IgxDialog),
        __metadata("design:type", dialog_component_1.IgxDialog)
    ], IgxGridComponent.prototype, "editingModal", void 0);
    __decorate([
        core_1.ViewChild(paginator_component_1.IgxPaginatorComponent),
        __metadata("design:type", paginator_component_1.IgxPaginatorComponent)
    ], IgxGridComponent.prototype, "paginator", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onEditDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onFilterDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onSortingDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onMovingDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onCellSelection", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onRowSelection", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onPagingDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onColumnInit", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxGridComponent.prototype, "onBeforeProcess", void 0);
    __decorate([
        core_1.ContentChildren(column_component_1.IgxColumnComponent),
        __metadata("design:type", core_1.QueryList)
    ], IgxGridComponent.prototype, "cols", void 0);
    IgxGridComponent = IgxGridComponent_1 = __decorate([
        core_1.Component({
            selector: "igx-grid",
            styles: [__webpack_require__(58)],
            template: __webpack_require__(60)
        }),
        __metadata("design:paramtypes", [core_1.Renderer2,
            core_1.ElementRef,
            core_1.ChangeDetectorRef,
            core_1.IterableDiffers,
            core_1.ComponentFactoryResolver,
            core_1.ViewContainerRef])
    ], IgxGridComponent);
    return IgxGridComponent;
    var IgxGridComponent_1;
}());
exports.IgxGridComponent = IgxGridComponent;
var GRID_DIRECTIVES = [
    IgxGridComponent,
    column_component_1.IgxColumnComponent,
    grid_common_1.IgxColumnFilteringComponent,
    grid_common_1.IgxColumnSortingDirective,
    grid_common_1.IgxCellTemplateDirective,
    grid_common_1.IgxCellFooterTemplateDirective,
    grid_common_1.IgxCellBodyComponent,
    grid_common_1.IgxCellHeaderComponent,
    grid_common_1.IgxCellFooterComponent,
    grid_common_1.IgxCellHeaderTemplateDirective,
    paginator_component_1.IgxPaginatorComponent
];
var IgxGridModule = (function () {
    function IgxGridModule() {
    }
    IgxGridModule = __decorate([
        core_1.NgModule({
            declarations: GRID_DIRECTIVES,
            entryComponents: [column_component_1.IgxColumnComponent],
            exports: GRID_DIRECTIVES,
            imports: [common_1.CommonModule, icon_component_1.IgxIconModule, dialog_component_1.IgxDialogModule, dragdrop_directive_1.IgxDragDropModule, input_directive_1.IgxInput, button_directive_1.IgxButtonModule, forms_1.FormsModule]
        })
    ], IgxGridModule);
    return IgxGridModule;
}());
exports.IgxGridModule = IgxGridModule;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(38);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-filtering{position:static}.igx-filtering__toggle{z-index:10}.igx-filtering__toggle i{font-size:1em;line-height:1em;padding:.5em}.igx-filtering__toggle--active{background:#0375be!important;color:#fff}.igx-filtering__options{display:block;position:absolute;width:calc(100% - 32px);user-select:none;right:16px;left:16px;background:#fff;box-shadow:0 2px 4px -1px rgba(0,0,0,.26),0 4px 5px 0 rgba(0,0,0,.12),0 1px 10px 0 rgba(0,0,0,.08);border-radius:2px;padding:.5em;z-index:10;margin-top:8px}.igx-filtering__options>input{font-weight:400;font-size:medium}", ""]);

// exports


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-filtering\" (click)=\"$event.stopPropagation()\">\n    <div class=\"igx-filtering__toggle\">\n        <span class=\"toggle-icon\" igxButton=\"icon\" (click)=\"toggle()\" [class.igx-filtering__toggle--active]=\"!hidden\">\n            <igx-icon fontSet=\"material\" name=\"filter_list\"></igx-icon>\n        </span>\n    </div>\n\n    <span class=\"igx-filtering__options\" *ngIf=\"!hidden\">\n        <input igxInput type=\"text\"\n            [value]=\"value\"\n            (input)=\"filterData($event)\"\n            (blur)=\"hidden = !hidden\"\n        />\n    </span>\n</div>"

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxPaginatorComponent = (function () {
    function IgxPaginatorComponent() {
        this.currentPage = 0;
        this.onPageChange = new core_1.EventEmitter();
    }
    Object.defineProperty(IgxPaginatorComponent.prototype, "isLast", {
        get: function () {
            return this.currentPage + 1 >= this.totalPages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxPaginatorComponent.prototype, "isFirst", {
        get: function () {
            return this.currentPage === 0;
        },
        enumerable: true,
        configurable: true
    });
    IgxPaginatorComponent.prototype.paginate = function (page) {
        var event = {
            currentPage: page,
            perPage: this.perPage,
            totalPages: this.totalPages
        };
        this.onPageChange.emit(event);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxPaginatorComponent.prototype, "currentPage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxPaginatorComponent.prototype, "totalPages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxPaginatorComponent.prototype, "perPage", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxPaginatorComponent.prototype, "onPageChange", void 0);
    IgxPaginatorComponent = __decorate([
        core_1.Component({
            selector: "igx-paginator",
            styles: [
                ".igx-paginator {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n            align-content: center;\n            margin: 1rem auto;\n            width: 100%;\n        }\n        .igx-paginator span {\n            padding: 1rem;\n        }\n        "
            ],
            template: __webpack_require__(41)
        })
    ], IgxPaginatorComponent);
    return IgxPaginatorComponent;
}());
exports.IgxPaginatorComponent = IgxPaginatorComponent;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-paginator\">\n    <button [disabled]=\"isFirst\" (click)=\"paginate(0)\" igxButton=\"icon\" igxRipple igxRippleCentered=\"true\">\n        <igx-icon fontSet=\"material\" name=\"first_page\"></igx-icon>\n    </button>\n    <button [disabled]=\"isFirst\" (click)=\"paginate(currentPage - 1)\" igxButton=\"icon\" igxRipple igxRippleCentered=\"true\">\n        <igx-icon fontSet=\"material\" name=\"chevron_left\"></igx-icon>\n    </button>\n    <span>{{ currentPage + 1}} of {{ totalPages }}</span>\n    <button (click)=\"paginate(currentPage + 1)\" igxRipple igxRippleCentered=\"true\" [disabled]=\"isLast\" igxButton=\"icon\">\n        <igx-icon fontSet=\"material\" name=\"chevron_right\"></igx-icon>\n    </button>\n    <button (click)=\"paginate(totalPages - 1)\" igxRipple igxRippleCentered=\"true\" [disabled]=\"isLast\" igxButton=\"icon\">\n        <igx-icon fontSet=\"material\" name=\"last_page\"></igx-icon>\n    </button>\n</div>"

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var base = [
    animations_1.style({
        opacity: "{{startOpacity}}"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.style({
        opacity: "{{endOpacity}}"
    }))
];
var baseParams = {
    delay: "0s",
    duration: "350ms",
    easing: easings_1.EaseOut.sine,
    endOpacity: 1,
    startOpacity: 0
};
var fadeIn = animations_1.animation(base, {
    params: baseParams
});
exports.fadeIn = fadeIn;
var fadeOut = animations_1.animation(base, {
    params: {
        delay: "0s",
        duration: "350ms",
        easing: easings_1.EaseOut.sine,
        endOpacity: 0,
        startOpacity: 1
    }
});
exports.fadeOut = fadeOut;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var baseRecipe = [
    animations_1.style({
        backfaceVisibility: "hidden",
        transformStyle: "preserve-3d"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.keyframes([
        animations_1.style({
            offset: 0,
            transform: "translateZ({{startDistance}})\n                rotate3d({{rotateX}}, {{rotateY}}, {{rotateZ}}, {{startAngle}}deg)"
        }),
        animations_1.style({
            offset: 1,
            transform: "translateZ({{endDistance}})\n                rotate3d({{rotateX}}, {{rotateY}}, {{rotateZ}}, {{endAngle}}deg)"
        })
    ]))
];
var baseParams = {
    delay: "0s",
    duration: "600ms",
    easing: easings_1.EaseOut.quad,
    endAngle: 180,
    endDistance: "0px",
    rotateX: 1,
    rotateY: 0,
    rotateZ: 0,
    startAngle: 0,
    startDistance: "0px"
};
var flipTop = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams)
});
exports.flipTop = flipTop;
var flipBottom = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endAngle: -180 })
});
exports.flipBottom = flipBottom;
var flipLeft = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { rotateX: 0, rotateY: 1 })
});
exports.flipLeft = flipLeft;
var flipRight = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endAngle: -180, rotateX: 0, rotateY: 1 })
});
exports.flipRight = flipRight;
var flipHorFwd = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endDistance: "170px" })
});
exports.flipHorFwd = flipHorFwd;
var flipHorBck = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endDistance: "-170px" })
});
exports.flipHorBck = flipHorBck;
var flipVerFwd = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endDistance: "170px", rotateX: 0, rotateY: 1 })
});
exports.flipVerFwd = flipVerFwd;
var flipVerBck = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endDistance: "-170px", rotateX: 0, rotateY: 1 })
});
exports.flipVerBck = flipVerBck;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var baseRecipe = [
    animations_1.style({
        opacity: "{{startOpacity}}",
        transform: "rotate3d({{rotateX}},{{rotateY}},{{rotateZ}},{{startAngle}}deg)",
        transformOrigin: "{{xPos}} {{yPos}}"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.style({
        offset: 0,
        opacity: "{{endOpacity}}",
        transform: "rotate3d({{rotateX}},{{rotateY}},{{rotateZ}},{{endAngle}}deg)",
        transformOrigin: "{{xPos}} {{yPos}}"
    }))
];
var baseInParams = {
    delay: "0s",
    duration: "600ms",
    easing: easings_1.EaseOut.quad,
    endAngle: 0,
    endOpacity: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 1,
    startAngle: -360,
    startOpacity: 0,
    xPos: "center",
    yPos: "center"
};
var baseOutParams = __assign({}, baseInParams, { easing: easings_1.EaseIn.quad, endOpacity: 0, startOpacity: 1 });
var rotateInCenter = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams)
});
exports.rotateInCenter = rotateInCenter;
var rotateOutCenter = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams)
});
exports.rotateOutCenter = rotateOutCenter;
var rotateInTop = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "top" })
});
exports.rotateInTop = rotateInTop;
var rotateOutTop = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "top" })
});
exports.rotateOutTop = rotateOutTop;
var rotateInRight = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "right" })
});
exports.rotateInRight = rotateInRight;
var rotateOutRight = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "right" })
});
exports.rotateOutRight = rotateOutRight;
var rotateInBottom = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "bottom" })
});
exports.rotateInBottom = rotateInBottom;
var rotateOutBottom = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "bottom" })
});
exports.rotateOutBottom = rotateOutBottom;
var rotateInLeft = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "left" })
});
exports.rotateInLeft = rotateInLeft;
var rotateOutLeft = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "left" })
});
exports.rotateOutLeft = rotateOutLeft;
var rotateInTr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "right", yPos: "top" })
});
exports.rotateInTr = rotateInTr;
var rotateOutTr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "right", yPos: "top" })
});
exports.rotateOutTr = rotateOutTr;
var rotateInBr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "right", yPos: "bottom" })
});
exports.rotateInBr = rotateInBr;
var rotateOutBr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "right", yPos: "bottom" })
});
exports.rotateOutBr = rotateOutBr;
var rotateInBl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "left", yPos: "bottom" })
});
exports.rotateInBl = rotateInBl;
var rotateOutBl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "left", yPos: "bottom" })
});
exports.rotateOutBl = rotateOutBl;
var rotateInTl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { xPos: "left", yPos: "top" })
});
exports.rotateInTl = rotateInTl;
var rotateOutTl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { xPos: "left", yPos: "top" })
});
exports.rotateOutTl = rotateOutTl;
var rotateInDiagonal1 = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { rotateX: 1, rotateY: 1, rotateZ: 0 })
});
exports.rotateInDiagonal1 = rotateInDiagonal1;
var rotateOutDiagonal1 = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { rotateX: 1, rotateY: 1, rotateZ: 0 })
});
exports.rotateOutDiagonal1 = rotateOutDiagonal1;
var rotateInDiagonal2 = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { rotateX: -1, rotateY: 1, rotateZ: 0 })
});
exports.rotateInDiagonal2 = rotateInDiagonal2;
var rotateOutDiagonal2 = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { rotateX: -1, rotateY: 1, rotateZ: 0 })
});
exports.rotateOutDiagonal2 = rotateOutDiagonal2;
var rotateInHor = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { rotateX: 0, rotateY: 1, rotateZ: 0 })
});
exports.rotateInHor = rotateInHor;
var rotateOutHor = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { rotateX: 0, rotateY: 1, rotateZ: 0 })
});
exports.rotateOutHor = rotateOutHor;
var rotateInVer = animations_1.animation(baseRecipe, {
    params: __assign({}, baseInParams, { rotateX: 1, rotateY: 0, rotateZ: 0 })
});
exports.rotateInVer = rotateInVer;
var rotateOutVer = animations_1.animation(baseRecipe, {
    params: __assign({}, baseOutParams, { rotateX: 1, rotateY: 0, rotateZ: 0 })
});
exports.rotateOutVer = rotateOutVer;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));
__export(__webpack_require__(47));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var baseRecipe = [
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.keyframes([
        animations_1.style({
            offset: 0,
            transform: "rotate(0deg) translate{{direction}}(0)",
            transformOrigin: "{{xPos}} {{yPos}}"
        }),
        animations_1.style({
            offset: 0.1,
            transform: "rotate({{endAngle}}deg) translate{{direction}}(-{{startDistance}})"
        }),
        animations_1.style({
            offset: 0.2,
            transform: "rotate(-{{startAngle}}deg) translate{{direction}}({{startDistance}})"
        }),
        animations_1.style({
            offset: 0.3,
            transform: "rotate({{startAngle}}deg) translate{{direction}}(-{{startDistance}})"
        }),
        animations_1.style({
            offset: 0.4,
            transform: "rotate(-{{startAngle}}deg) translate{{direction}}({{startDistance}})"
        }),
        animations_1.style({
            offset: 0.5,
            transform: "rotate({{startAngle}}deg) translate{{direction}}(-{{startDistance}})"
        }),
        animations_1.style({
            offset: 0.6,
            transform: "rotate(-{{startAngle}}deg) translate{{direction}}({{startDistance}})"
        }),
        animations_1.style({
            offset: 0.7,
            transform: "rotate({{startAngle}}deg) translate{{direction}}(-{{startDistance}})"
        }),
        animations_1.style({
            offset: 0.8,
            transform: "rotate(-{{endAngle}}deg) translate{{direction}}({{endDistance}})"
        }),
        animations_1.style({
            offset: 0.9,
            transform: "rotate({{endAngle}}deg) translate{{direction}}(-{{endDistance}})"
        }),
        animations_1.style({
            offset: 1,
            transform: "rotate(0deg) translate{{direction}}(0)",
            transformOrigin: "{{xPos}} {{yPos}}"
        })
    ]))
];
var baseParams = {
    delay: "0s",
    direction: "X",
    duration: "800ms",
    easing: easings_1.EaseInOut.quad,
    endAngle: 0,
    endDistance: "8px",
    startAngle: 0,
    startDistance: "10px",
    xPos: "center",
    yPos: "center"
};
var shakeHor = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "X" })
});
exports.shakeHor = shakeHor;
var shakeVer = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y" })
});
exports.shakeVer = shakeVer;
var shakeTop = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", yPos: "top" })
});
exports.shakeTop = shakeTop;
var shakeBottom = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", yPos: "bottom" })
});
exports.shakeBottom = shakeBottom;
var shakeRight = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "right", yPos: "center" })
});
exports.shakeRight = shakeRight;
var shakeLeft = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "left", yPos: "center" })
});
exports.shakeLeft = shakeLeft;
var shakeCenter = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 8, endDistance: "0", startAngle: 10, startDistance: "0", xPos: "center", yPos: "center" })
});
exports.shakeCenter = shakeCenter;
var shakeTr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "right", yPos: "top" })
});
exports.shakeTr = shakeTr;
var shakeBr = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "right", yPos: "bottom" })
});
exports.shakeBr = shakeBr;
var shakeBl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "left", yPos: "bottom" })
});
exports.shakeBl = shakeBl;
var shakeTl = animations_1.animation(baseRecipe, {
    params: __assign({}, baseParams, { direction: "Y", endAngle: 2, endDistance: "0", startAngle: 4, startDistance: "0", xPos: "left", yPos: "top" })
});
exports.shakeTl = shakeTl;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var heartbeatBase = [
    animations_1.style({
        animationTimingFunction: "ease-out",
        transform: "scale(1)",
        transformOrigin: "center center"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.keyframes([
        animations_1.style({
            animationTimingFunction: "ease-in",
            offset: 0.1,
            transform: "scale(0.91)"
        }),
        animations_1.style({
            animationTimingFunction: "ease-out",
            offset: 0.17,
            transform: "scale(0.98)"
        }),
        animations_1.style({
            animationTimingFunction: "ease-in",
            offset: 0.33,
            transform: "scale(0.87)"
        }),
        animations_1.style({
            animationTimingFunction: "ease-out",
            offset: 0.45,
            transform: "scale(1)"
        })
    ]))
];
var heartbeatParams = {
    delay: "0s",
    duration: "1.5s",
    easing: "ease-in-out"
};
var pulsateBase = [
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.keyframes([
        animations_1.style({
            offset: 0,
            transform: "scale({{fromScale}})"
        }),
        animations_1.style({
            offset: 0.5,
            transform: "scale({{toScale}})"
        }),
        animations_1.style({
            offset: 1,
            transform: "scale({{fromScale}})"
        })
    ]))
];
var pulsateParams = {
    delay: "0s",
    duration: ".5s",
    easing: "ease-in-out",
    fromScale: 1,
    toScale: 1.1
};
var blinkBase = [
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.keyframes([
        animations_1.style({
            offset: 0,
            opacity: .8,
            transform: "scale({{fromScale}})"
        }),
        animations_1.style({
            offset: 0.8,
            opacity: 0,
            transform: "scale({{midScale}})"
        }),
        animations_1.style({
            offset: 1,
            opacity: 0,
            transform: "scale({{toScale}})"
        })
    ]))
];
var blinkParams = {
    delay: "0s",
    duration: ".8s",
    easing: "ease-in-out",
    fromScale: .2,
    midScale: 1.2,
    toScale: 2.2
};
var pulsateFwd = animations_1.animation(pulsateBase, {
    params: __assign({}, pulsateParams)
});
exports.pulsateFwd = pulsateFwd;
var pulsateBck = animations_1.animation(pulsateBase, {
    params: __assign({}, pulsateParams, { toScale: .9 })
});
exports.pulsateBck = pulsateBck;
var heartbeat = animations_1.animation(heartbeatBase, {
    params: __assign({}, heartbeatParams)
});
exports.heartbeat = heartbeat;
var blink = animations_1.animation(blinkBase, {
    params: __assign({}, blinkParams)
});
exports.blink = blink;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var base = [
    animations_1.style({
        opacity: "{{startOpacity}}",
        transform: "scale{{direction}}({{fromScale}})",
        transformOrigin: "{{xPos}} {{yPos}}"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.style({
        opacity: "{{endOpacity}}",
        transform: "scale{{direction}}({{toScale}})",
        transformOrigin: "{{xPos}} {{yPos}}"
    }))
];
var baseInParams = {
    delay: "0s",
    direction: "",
    duration: "350ms",
    easing: easings_1.EaseOut.quad,
    endOpacity: 1,
    fromScale: .5,
    startOpacity: 0,
    toScale: 1,
    xPos: "50%",
    yPos: "50%"
};
var baseOutParams = __assign({}, baseInParams, { easing: easings_1.EaseOut.sine, endOpacity: 0, fromScale: 1, startOpacity: 1, toScale: .5 });
var scaleInCenter = animations_1.animation(base, { params: baseInParams });
exports.scaleInCenter = scaleInCenter;
var scaleInBl = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "0", yPos: "100%" })
});
exports.scaleInBl = scaleInBl;
var scaleInVerCenter = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "Y", fromScale: .4 })
});
exports.scaleInVerCenter = scaleInVerCenter;
var scaleInTop = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "50%", yPos: "0" })
});
exports.scaleInTop = scaleInTop;
var scaleInLeft = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "0", yPos: "50%" })
});
exports.scaleInLeft = scaleInLeft;
var scaleInVerTop = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "Y", fromScale: .4, xPos: "100%", yPos: "0" })
});
exports.scaleInVerTop = scaleInVerTop;
var scaleInTr = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "100%", yPos: "0" })
});
exports.scaleInTr = scaleInTr;
var scaleInTl = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "0", yPos: "0" })
});
exports.scaleInTl = scaleInTl;
var scaleInVerBottom = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "Y", fromScale: .4, xPos: "0", yPos: "100%" })
});
exports.scaleInVerBottom = scaleInVerBottom;
var scaleInRight = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "100%", yPos: "50%" })
});
exports.scaleInRight = scaleInRight;
var scaleInHorCenter = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "X", fromScale: .4 })
});
exports.scaleInHorCenter = scaleInHorCenter;
var scaleInBr = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "100%", yPos: "100%" })
});
exports.scaleInBr = scaleInBr;
var scaleInHorLeft = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "X", fromScale: .4, xPos: "0", yPos: "0" })
});
exports.scaleInHorLeft = scaleInHorLeft;
var scaleInBottom = animations_1.animation(base, {
    params: __assign({}, baseInParams, { xPos: "50%", yPos: "100%" })
});
exports.scaleInBottom = scaleInBottom;
var scaleInHorRight = animations_1.animation(base, {
    params: __assign({}, baseInParams, { direction: "X", fromScale: .4, xPos: "100%", yPos: "100%" })
});
exports.scaleInHorRight = scaleInHorRight;
var scaleOutCenter = animations_1.animation(base, { params: baseOutParams });
exports.scaleOutCenter = scaleOutCenter;
var scaleOutBl = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "0", yPos: "100%" })
});
exports.scaleOutBl = scaleOutBl;
var scaleOutBr = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "100%", yPos: "100%" })
});
exports.scaleOutBr = scaleOutBr;
var scaleOutVerCenter = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "Y", toScale: .3 })
});
exports.scaleOutVerCenter = scaleOutVerCenter;
var scaleOutVerTop = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "Y", toScale: .3, xPos: "100%", yPos: "0" })
});
exports.scaleOutVerTop = scaleOutVerTop;
var scaleOutVerBottom = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "Y", toScale: .3, xPos: "0", yPos: "100%" })
});
exports.scaleOutVerBottom = scaleOutVerBottom;
var scaleOutTop = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "50%", yPos: "0" })
});
exports.scaleOutTop = scaleOutTop;
var scaleOutLeft = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "0", yPos: "50%" })
});
exports.scaleOutLeft = scaleOutLeft;
var scaleOutTr = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "100%", yPos: "0" })
});
exports.scaleOutTr = scaleOutTr;
var scaleOutTl = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "0", yPos: "0" })
});
exports.scaleOutTl = scaleOutTl;
var scaleOutRight = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "100%", yPos: "50%" })
});
exports.scaleOutRight = scaleOutRight;
var scaleOutBottom = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { xPos: "50%", yPos: "100%" })
});
exports.scaleOutBottom = scaleOutBottom;
var scaleOutHorCenter = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "X", toScale: .3 })
});
exports.scaleOutHorCenter = scaleOutHorCenter;
var scaleOutHorLeft = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "X", toScale: .3, xPos: "0", yPos: "0" })
});
exports.scaleOutHorLeft = scaleOutHorLeft;
var scaleOutHorRight = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { direction: "X", toScale: .3, xPos: "100%", yPos: "100%" })
});
exports.scaleOutHorRight = scaleOutHorRight;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var base = [
    animations_1.style({
        opacity: "{{startOpacity}}",
        transform: "{{fromPosition}}"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.style({
        opacity: "{{endOpacity}}",
        transform: "{{toPosition}}"
    }))
];
var baseInParams = {
    delay: "0s",
    duration: "350ms",
    easing: easings_1.EaseOut.quad,
    endOpacity: 1,
    fromPosition: "translateY(-500px)",
    startOpacity: 0,
    toPosition: "translateY(0)"
};
var baseOutParams = {
    delay: "0s",
    duration: "350ms",
    easing: easings_1.EaseIn.quad,
    endOpacity: 0,
    fromPosition: "translateY(0)",
    startOpacity: 1,
    toPosition: "translateY(-500px)"
};
var slideInTop = animations_1.animation(base, { params: baseInParams });
exports.slideInTop = slideInTop;
var slideInLeft = animations_1.animation(base, {
    params: {
        delay: "0s",
        duration: "350ms",
        easing: easings_1.EaseOut.quad,
        endOpacity: 1,
        fromPosition: "translateX(-500px)",
        startOpacity: 0,
        toPosition: "translateY(0)"
    }
});
exports.slideInLeft = slideInLeft;
var slideInRight = animations_1.animation(base, {
    params: {
        delay: "0s",
        duration: "350ms",
        easing: easings_1.EaseOut.quad,
        endOpacity: 1,
        fromPosition: "translateX(500px)",
        startOpacity: 0,
        toPosition: "translateY(0)"
    }
});
exports.slideInRight = slideInRight;
var slideInBottom = animations_1.animation(base, {
    params: {
        delay: "0s",
        duration: "350ms",
        easing: easings_1.EaseOut.quad,
        endOpacity: 1,
        fromPosition: "translateY(500px)",
        startOpacity: 0,
        toPosition: "translateY(0)"
    }
});
exports.slideInBottom = slideInBottom;
var slideInTr = animations_1.animation(base, {
    params: __assign({}, baseInParams, { fromPosition: "translateY(-500px) translateX(500px)", toPosition: "translateY(0) translateX(0)" })
});
exports.slideInTr = slideInTr;
var slideInTl = animations_1.animation(base, {
    params: __assign({}, baseInParams, { fromPosition: "translateY(-500px) translateX(-500px)", toPosition: "translateY(0) translateX(0)" })
});
exports.slideInTl = slideInTl;
var slideInBr = animations_1.animation(base, {
    params: __assign({}, baseInParams, { fromPosition: "translateY(500px) translateX(500px)", toPosition: "translateY(0) translateX(0)" })
});
exports.slideInBr = slideInBr;
var slideInBl = animations_1.animation(base, {
    params: __assign({}, baseInParams, { fromPosition: "translateY(500px) translateX(-500px)", toPosition: "translateY(0) translateX(0)" })
});
exports.slideInBl = slideInBl;
var slideOutTop = animations_1.animation(base, { params: baseOutParams });
exports.slideOutTop = slideOutTop;
var slideOutRight = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { toPosition: "translateX(500px)" })
});
exports.slideOutRight = slideOutRight;
var slideOutBottom = animations_1.animation(base, {
    params: {
        delay: "0s",
        duration: "350ms",
        easing: easings_1.EaseIn.quad,
        endOpacity: 0,
        fromPosition: "translateY(0)",
        startOpacity: 1,
        toPosition: "translateY(500px)"
    }
});
exports.slideOutBottom = slideOutBottom;
var slideOutLeft = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { toPosition: "translateX(-500px)" })
});
exports.slideOutLeft = slideOutLeft;
var slideOutTr = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { fromPosition: "translateY(0) translateX(0)", toPosition: "translateY(-500px) translateX(500px)" })
});
exports.slideOutTr = slideOutTr;
var slideOutBr = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { fromPosition: "translateY(0) translateX(0)", toPosition: "translateY(500px) translateX(500px)" })
});
exports.slideOutBr = slideOutBr;
var slideOutBl = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { fromPosition: "translateY(0) translateX(0)", toPosition: "translateY(500px) translateX(-500px)" })
});
exports.slideOutBl = slideOutBl;
var slideOutTl = animations_1.animation(base, {
    params: __assign({}, baseOutParams, { fromPosition: "translateY(0) translateX(0)", toPosition: "translateY(-500px) translateX(-500px)" })
});
exports.slideOutTl = slideOutTl;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var easings_1 = __webpack_require__(7);
var swingBase = [
    animations_1.style({
        opacity: "{{startOpacity}}",
        transform: "rotate{{direction}}({{startAngle}}deg)",
        transformOrigin: "{{xPos}} {{yPos}}"
    }),
    animations_1.animate("{{duration}} {{delay}} {{easing}}", animations_1.style({
        opacity: "{{endOpacity}}",
        transform: "rotate{{direction}}({{endAngle}}deg)",
        transformOrigin: "{{xPos}} {{yPos}}"
    }))
];
var swingParams = {
    delay: "0s",
    direction: "X",
    duration: ".5s",
    easing: easings_1.EaseOut.back,
    endAngle: 0,
    endOpacity: 1,
    startAngle: -100,
    startOpacity: 0,
    xPos: "top",
    yPos: "center"
};
var swingOutParams = __assign({}, swingParams, { duration: ".55s", easing: easings_1.EaseIn.back, endAngle: 70, endOpacity: 0, startAngle: 0, startOpacity: 1 });
var swingInTopFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingParams)
});
exports.swingInTopFwd = swingInTopFwd;
var swingInRightFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { direction: "Y", xPos: "center", yPos: "right" })
});
exports.swingInRightFwd = swingInRightFwd;
var swingInBottomFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { startAngle: 100, xPos: "bottom" })
});
exports.swingInBottomFwd = swingInBottomFwd;
var swingInLeftFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { direction: "Y", startAngle: 100, xPos: "center", yPos: "left" })
});
exports.swingInLeftFwd = swingInLeftFwd;
var swingInTopBck = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { duration: ".6s", startAngle: 70 })
});
exports.swingInTopBck = swingInTopBck;
var swingInRightBck = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { direction: "Y", duration: ".6s", startAngle: 70, xPos: "center", yPos: "right" })
});
exports.swingInRightBck = swingInRightBck;
var swingInBottomBck = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { duration: ".6s", startAngle: -70, xPos: "bottom" })
});
exports.swingInBottomBck = swingInBottomBck;
var swingInLeftBck = animations_1.animation(swingBase, {
    params: __assign({}, swingParams, { direction: "Y", duration: ".6s", startAngle: -70, xPos: "center", yPos: "left" })
});
exports.swingInLeftBck = swingInLeftBck;
var swingOutTopFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams)
});
exports.swingOutTopFwd = swingOutTopFwd;
var swingOutRightFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { direction: "Y", xPos: "center", yPos: "right" })
});
exports.swingOutRightFwd = swingOutRightFwd;
var swingOutBottomFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { endAngle: -70, xPos: "bottom" })
});
exports.swingOutBottomFwd = swingOutBottomFwd;
var swingOutLefttFwd = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { direction: "Y", endAngle: -70, xPos: "center", yPos: "left" })
});
exports.swingOutLefttFwd = swingOutLefttFwd;
var swingOutTopBck = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { duration: ".45s", endAngle: -100 })
});
exports.swingOutTopBck = swingOutTopBck;
var swingOutRightBck = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { direction: "Y", duration: ".45s", endAngle: -100, xPos: "center", yPos: "right" })
});
exports.swingOutRightBck = swingOutRightBck;
var swingOutBottomBck = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { duration: ".45s", endAngle: 100, xPos: "bottom" })
});
exports.swingOutBottomBck = swingOutBottomBck;
var swingOutLeftBck = animations_1.animation(swingBase, {
    params: __assign({}, swingOutParams, { direction: "Y", duration: ".45s", endAngle: 100, xPos: "center", yPos: "left" })
});
exports.swingOutLeftBck = swingOutLeftBck;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(52);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-dialog{display:flex;position:fixed;align-items:center;justify-content:center;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.38);z-index:24}.igx-dialog--hidden{display:none}.igx-dialog__window{max-width:25em;min-width:17.5em;padding:.75em 1.5em;border-radius:2px;background:#fff;box-shadow:0 11px 15px -7px rgba(0,0,0,.26),0 24px 38px 3px rgba(0,0,0,.12),0 9px 46px 8px rgba(0,0,0,.08)}.igx-dialog__window-title{color:rgba(0,0,0,.74);font-size:1.25em;line-height:1em;padding-top:.75em;padding-bottom:.625em;font-weight:600}.igx-dialog__window-content{color:rgba(0,0,0,.54);font-size:1em;line-height:1.125em;padding-top:.625em;padding-bottom:.75em}.igx-dialog__window-actions{display:flex;margin:0 -1.5em -.75em;flex-flow:row nowrap;justify-content:flex-end;padding:.5em}.igx-dialog__window-actions button~button{margin-left:8px}", ""]);

// exports


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "<div #dialog tabindex=\"-1\" class=\"igx-dialog\" *ngIf=\"isOpen\" [@fadeInOut]=\"state\" (click)=\"onDialogSelected($event)\">\n    <div #dialogWindow class=\"igx-dialog__window\" [@slideIn]=\"state\" [attr.role]=\"role\" [attr.aria-labelledby]=\"titleId\">\n        <div [attr.id]=\"titleId\" class=\"igx-dialog__window-title\">\n            {{ title }}\n        </div>\n        <div class=\"igx-dialog__window-content\">\n            <div *ngIf=\"message\">{{ message }}</div>\n            <ng-content *ngIf=\"!message\"></ng-content>\n        </div>\n        <div class=\"igx-dialog__window-actions\">\n            <button *ngIf=\"leftButtonLabel\" igxButton=\"{{ leftButtonType }}\" igxButtonColor=\"{{ leftButtonColor }}\" igxButtonBackground=\"{{ leftButtonBackgroundColor }}\"\n                igxRipple=\"{{ leftButtonRipple }}\" (click)=\"onInternalLeftButtonSelect($event)\">\n                {{ leftButtonLabel }}\n            </button>\n            <button *ngIf=\"rightButtonLabel\" igxButton=\"{{ rightButtonType }}\" igxButtonColor=\"{{ rightButtonColor }}\" igxButtonBackground=\"{{ rightButtonBackgroundColor }}\"\n                igxRipple=\"{{ rightButtonRipple }}\" (click)=\"onInternalRightButtonSelect($event)\">\n                {{ rightButtonLabel }}\n            </button>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxDraggableDirective = (function () {
    function IgxDraggableDirective(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.effectAllowed = "move";
    }
    IgxDraggableDirective.prototype.ngOnInit = function () {
        this.draggable = true;
    };
    IgxDraggableDirective.prototype.ngOnDestroy = function () {
        this.draggable = false;
    };
    IgxDraggableDirective.prototype.onDragStart = function (event) {
        if (this.dragClass) {
            this._renderer.addClass(this._elementRef.nativeElement, this.dragClass);
        }
        event.dataTransfer.effectAllowed = this.effectAllowed;
        event.dataTransfer.setData("data", JSON.stringify(this.data));
    };
    IgxDraggableDirective.prototype.onDragEnd = function (event) {
        event.preventDefault();
        if (this.dragClass) {
            this._renderer.removeClass(this._elementRef.nativeElement, this.dragClass);
        }
    };
    __decorate([
        core_1.Input("igxDraggable"),
        __metadata("design:type", Object)
    ], IgxDraggableDirective.prototype, "data", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDraggableDirective.prototype, "dragClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDraggableDirective.prototype, "effectAllowed", void 0);
    __decorate([
        core_1.HostBinding("draggable"),
        __metadata("design:type", Boolean)
    ], IgxDraggableDirective.prototype, "draggable", void 0);
    __decorate([
        core_1.HostListener("dragstart", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxDraggableDirective.prototype, "onDragStart", null);
    __decorate([
        core_1.HostListener("dragend", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxDraggableDirective.prototype, "onDragEnd", null);
    IgxDraggableDirective = __decorate([
        core_1.Directive({
            selector: "[igxDraggable]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxDraggableDirective);
    return IgxDraggableDirective;
}());
exports.IgxDraggableDirective = IgxDraggableDirective;
var IgxDroppableDirective = (function () {
    function IgxDroppableDirective(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.dropEffect = "move";
        this.onDrop = new core_1.EventEmitter();
    }
    IgxDroppableDirective.prototype.onDragEnter = function (event) {
        if (this.dropClass) {
            this._renderer.addClass(this._elementRef.nativeElement, this.dropClass);
        }
    };
    IgxDroppableDirective.prototype.onDragLeave = function (event) {
        if (this.dropClass) {
            this._renderer.removeClass(this._elementRef.nativeElement, this.dropClass);
        }
    };
    IgxDroppableDirective.prototype.onDragOver = function (event) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        event.dataTransfer.dropEffect = this.dropEffect;
        return false;
    };
    IgxDroppableDirective.prototype.onDragDrop = function (event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        if (this.dropClass) {
            this._renderer.removeClass(this._elementRef.nativeElement, this.dropClass);
        }
        var eventData = JSON.parse(event.dataTransfer.getData("data"));
        var args = {
            dragData: eventData,
            dropData: this.data,
            event: event
        };
        this.onDrop.emit(args);
    };
    __decorate([
        core_1.Input("igxDroppable"),
        __metadata("design:type", Object)
    ], IgxDroppableDirective.prototype, "data", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDroppableDirective.prototype, "dropClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDroppableDirective.prototype, "dropEffect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDroppableDirective.prototype, "onDrop", void 0);
    __decorate([
        core_1.HostListener("dragenter", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxDroppableDirective.prototype, "onDragEnter", null);
    __decorate([
        core_1.HostListener("dragleave", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxDroppableDirective.prototype, "onDragLeave", null);
    __decorate([
        core_1.HostListener("dragover", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Boolean)
    ], IgxDroppableDirective.prototype, "onDragOver", null);
    __decorate([
        core_1.HostListener("drop", ["$event"]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IgxDroppableDirective.prototype, "onDragDrop", null);
    IgxDroppableDirective = __decorate([
        core_1.Directive({
            selector: "[igxDroppable]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxDroppableDirective);
    return IgxDroppableDirective;
}());
exports.IgxDroppableDirective = IgxDroppableDirective;
var IgxDragDropModule = (function () {
    function IgxDragDropModule() {
    }
    IgxDragDropModule = __decorate([
        core_1.NgModule({
            declarations: [IgxDraggableDirective, IgxDroppableDirective],
            exports: [IgxDraggableDirective, IgxDroppableDirective]
        })
    ], IgxDragDropModule);
    return IgxDragDropModule;
}());
exports.IgxDragDropModule = IgxDragDropModule;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(56);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-icon{display:flex;position:relative;font-size:1.5em;justify-content:center}.igx-icon--inactive{color:rgba(0,0,0,.38)}", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "<span class=\"igx-icon\" [class.igx-icon--inactive]=\"!getActive\">\n    <i #icon *ngIf=\"getFontSet == 'material'\" class=\"material-icons\">\n        {{ getIconName }}\n    </i>\n</span>"

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(59);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-grid{display:flex;flex-flow:column nowrap;width:100%;background:#fff;border-radius:.125em;box-shadow:0 1px 5px 0 rgba(0,0,0,.26),0 2px 2px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.08);overflow:hidden}.igx-grid__caption{display:flex;align-items:center;font-size:1.25em;line-height:2em;padding:1em 1.5em}.igx-grid__tfoot,.igx-grid__thead{display:block;flex:0 0 auto}.igx-grid__tbody{display:block;flex:1 1 auto;position:relative;overflow-y:auto}.igx-grid__tbody-empty{display:flex;justify-content:center;text-align:center}.igx-grid__tr{display:flex;flex:1;background:inherit;border-bottom:1px solid rgba(0,0,0,.12);transition:background .2s ease}.igx-grid__tr:last-of-type{border-bottom:0}.igx-grid__tr:hover{background:rgba(0,0,0,.04)}thead:first-of-type:hover{background:none}.igx-grid__tr--selected td{color:#fff;background-color:rgba(0,0,0,.54)}.igx-grid__td,.igx-grid__th{display:flex;flex-flow:column wrap;flex:1;justify-content:center;outline:none;padding:1.125em 1.5em;font-size:.8125em;line-height:1em;color:rgba(0,0,0,.74);text-align:left;word-wrap:break-word;overflow:hidden}.igx-grid__td--number,.igx-grid__th--number{text-align:right}.igx-grid__td--selected{color:#fff;background-color:#e41c77!important}.igx-grid__th{font-size:.75em;color:rgba(0,0,0,.54);position:relative;overflow:visible}.igx-grid__th-content{display:flex;align-items:center;overflow:hidden}.igx-grid__th-content .title{display:flex;align-items:center;flex-grow:1}.igx-grid__th-content .icon{font-size:1em;line-height:1em;padding:.5em}.igx-grid__th.asc,.igx-grid__th.desc{color:rgba(0,0,0,.74)}.igx-grid__th.desc .igx-grid__th-content>.title:before{position:relative;font-family:Material Icons;content:\"\\E5DB\";margin-right:8px}.igx-grid__th.asc .igx-grid__th-content>.title:before{position:relative;font-family:Material Icons;content:\"\\E5D8\";margin-right:8px}", ""]);

// exports


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "<table class=\"igx-grid\" [attr.id]=\"id\" role=\"grid\" [attr.aria-readonly]=\"!hasEditableColumns\">\n    <thead class=\"igx-grid__thead\" role=\"rowgroup\">\n        <tr class=\"igx-grid__tr\" role=\"rowheader\">\n            <ng-template ngFor let-col [ngForOf]=\"columnsToRender\" let-colIndex=\"index\">\n\n                <th (onSort)=\"processSort($event)\"\n                    role=\"columnheader\" tabindex=\"0\"\n                    class=\"igx-grid__th\"\n                    [attr.aria-label]=\"col.header || col.field\"\n                    [igxColumnSorting]=\"col\"\n                    [sortDirection]=\"getSortedExpression(col)\"\n                    [style.width]=\"col.width || ''\">\n                    <div class=\"igx-grid__th-content\">\n                        <span class=\"title\">\n                            <igx-cell-header *ngIf=\"col.headerTemplate\" [column]=\"col\" [colIndex]=\"index\"></igx-cell-header>\n                            {{ formatHeader(col) }}\n                        </span>\n                        <igx-col-filter\n                            (onFilter)=\"processFilter($event)\"\n                            *ngIf=\"col.filtering\"\n                            [value]=\"filteringExpressions[col.field]?.searchVal || ''\"\n                            [column]=\"col\">\n                        </igx-col-filter>\n                        <div *ngIf=\"col.movable\" (onDrop)=\"moveColumn($event)\" [igxDraggable]=\"col.index\" [igxDroppable]=\"col.index\">\n                            <igx-icon name=\"swap_horiz\"></igx-icon>\n                        </div>\n                    </div>\n                </th>\n            </ng-template>\n        </tr>\n    </thead>\n    <tbody class=\"igx-grid__tbody\" role=\"rowgroup\" (keydown)=\"navigate($event)\">\n        <div class=\"igx-grid__tbody-empty\" *ngIf=\"!dataContainer.transformedData || !dataContainer.transformedData.length || !columnsToRender || !columnsToRender.length\">\n            <h4>No data to display</h4>\n        </div>\n        <ng-template ngFor let-rowData [ngForOf]=\"dataContainer.transformedData\" let-rowIndex=\"index\">\n            <tr class=\"igx-grid__tr\" [attr.data-row]=\"rowIndex\" tabindex=\"0\" role=\"row\" (focus)=\"onRowFocus($event, rowIndex)\" (blur)=\"onRowBlur($event)\">\n                <ng-template ngFor let-col [ngForOf]=\"columnsToRender\" let-colIndex=\"index\">\n                    <td tabindex=\"0\" role=\"gridcell\" [attr.aria-readonly]=\"!col.editable\" [attr.aria-describedby]=\"id + '_' + col.field\"\n                        [attr.data-row]=\"rowIndex\" [attr.data-col]=\"colIndex\"\n                        class=\"igx-grid__td\"\n                        [style.width]=\"col.width || ''\"\n                        (focus)=\"onCellFocus($event, rowIndex, col.field)\"\n                        (blur)=\"onCellBlur($event)\"\n                        (dblclick)=\"editCell(rowIndex, rowData[col.field], rowData)\"\n                        (keyup.enter)=\"editCell(rowIndex, rowData[col.field], rowData)\">\n                        <igx-cell-body *ngIf=\"col.bodyTemplate\" [column]=\"col\" [row]=\"rowData\" [item]=\"rowData[col.field]\" [rowIndex]=\"rowIndex\"></igx-cell-body>\n                        {{ formatBody(rowData, col) }}\n                    </td>\n                </ng-template>\n            </tr>\n        </ng-template>\n    </tbody>\n    <tfoot class=\"igx-grid__tfoot\">\n        <igx-paginator *ngIf=\"paging\"\n            (onPageChange)=\"_paginate($event)\"\n            [currentPage]=\"dataContainer.state.paging?.index\"\n            [perPage]=\"perPage\"\n            [totalPages]=\"dataContainer.state.paging?.metadata?.countPages\">\n        </igx-paginator>\n    </tfoot>\n    <igx-dialog *ngIf=\"hasEditableColumns\"\n            title=\"Edit Record\"\n            leftButtonLabel=\"Cancel\"\n            (onLeftButtonSelect)=\"editingModal.close()\"\n            (onRightButtonSelect)=\"saveData()\"\n            (keyup.enter)=\"saveData()\"\n            (keyup.escape)=\"cancelEdit()\"\n            rightButtonLabel=\"Save\"\n            rightButtonBackgroundColor=\"#00BFB2\"\n            rightButtonColor=\"white\"\n            closeOnOutsideSelect=\"true\"\n        >\n        <div class=\"igx-form-group\" *ngFor=\"let col of editableColumns;\">\n            <input type=\"text\" igxInput [ngModel]=\"selectedRow?.row[col.field]\" (ngModelChange)=\"_setValue(col.field, $event)\" />\n            <label igxLabel>{{ col.header || col.field }}</label>\n        </div>\n    </igx-dialog>\n</table>\n"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
__webpack_require__(62);
__webpack_require__(63);
__webpack_require__(64);
var Observable_1 = __webpack_require__(65);
var base_1 = __webpack_require__(66);
var navigation_1 = __webpack_require__(17);
var touch_1 = __webpack_require__(26);
var NavigationDrawer = (function (_super) {
    __extends(NavigationDrawer, _super);
    function NavigationDrawer(elementRef, _state, renderer, _touchManager) {
        var _this = _super.call(this, renderer) || this;
        _this.elementRef = elementRef;
        _this._state = _state;
        _this.renderer = renderer;
        _this._touchManager = _touchManager;
        _this.position = "left";
        _this.enableGestures = true;
        _this.isOpen = false;
        _this.pin = false;
        _this.pinThreshold = 1024;
        _this.pinChange = new core_1.EventEmitter();
        _this.opening = new core_1.EventEmitter();
        _this.opened = new core_1.EventEmitter();
        _this.closing = new core_1.EventEmitter();
        _this.closed = new core_1.EventEmitter();
        _this._hasMimiTempl = false;
        _this._gesturesAttached = false;
        _this._widthCache = { width: null, miniWidth: null };
        _this.css = {
            drawer: "ig-nav-drawer",
            mini: "mini",
            miniProjection: ".ig-drawer-mini-content",
            overlay: "ig-nav-drawer-overlay",
            styleDummy: "style-dummy"
        };
        _this._panning = false;
        _this._maxEdgeZone = 50;
        _this.checkPinThreshold = function (evt) {
            var windowWidth;
            if (_this.pinThreshold) {
                windowWidth = _this.getWindowWidth();
                if (!_this.pin && windowWidth >= _this.pinThreshold) {
                    _this.pin = true;
                    _this.pinChange.emit(true);
                }
                else if (_this.pin && windowWidth < _this.pinThreshold) {
                    _this.pin = false;
                    _this.pinChange.emit(false);
                }
            }
        };
        _this.swipe = function (evt) {
            if (!_this.enableGestures || evt.pointerType !== "touch") {
                return;
            }
            var deltaX;
            var startPosition;
            if (_this.position === "right") {
                deltaX = -evt.deltaX;
                startPosition = _this.getWindowWidth() - (evt.center.x + evt.distance);
            }
            else {
                deltaX = evt.deltaX;
                startPosition = evt.center.x - evt.distance;
            }
            if ((_this.isOpen && deltaX < 0) ||
                (deltaX > 0 && startPosition < _this.maxEdgeZone)) {
                _this.toggle(true);
            }
        };
        _this.panstart = function (evt) {
            if (!_this.enableGestures || _this.pin || evt.pointerType !== "touch") {
                return;
            }
            var startPosition = _this.position === "right" ? _this.getWindowWidth() - (evt.center.x + evt.distance)
                : evt.center.x - evt.distance;
            if (_this.isOpen || (startPosition < _this.maxEdgeZone)) {
                _this._panning = true;
                _this._panStartWidth = _this.getExpectedWidth(!_this.isOpen);
                _this._panLimit = _this.getExpectedWidth(_this.isOpen);
                _this.renderer.setElementClass(_this.overlay, "panning", true);
                _this.renderer.setElementClass(_this.drawer, "panning", true);
            }
        };
        _this.pan = function (evt) {
            if (!_this._panning) {
                return;
            }
            var right = _this.position === "right";
            var deltaX = right ? -evt.deltaX : evt.deltaX;
            var visibleWidth;
            var newX;
            var percent;
            visibleWidth = _this._panStartWidth + deltaX;
            if (_this.isOpen && deltaX < 0) {
                if (visibleWidth <= _this._panLimit) {
                    return;
                }
                if (_this.hasAnimateWidth) {
                    percent = (visibleWidth - _this._panLimit) / (_this._panStartWidth - _this._panLimit);
                    newX = visibleWidth;
                }
                else {
                    percent = visibleWidth / _this._panStartWidth;
                    newX = evt.deltaX;
                }
                _this.setXSize(newX, percent.toPrecision(2));
            }
            else if (!_this.isOpen && deltaX > 0) {
                if (visibleWidth >= _this._panLimit) {
                    return;
                }
                if (_this.hasAnimateWidth) {
                    percent = (visibleWidth - _this._panStartWidth) / (_this._panLimit - _this._panStartWidth);
                    newX = visibleWidth;
                }
                else {
                    percent = visibleWidth / _this._panLimit;
                    newX = (_this._panLimit - visibleWidth) * (right ? 1 : -1);
                }
                _this.setXSize(newX, percent.toPrecision(2));
            }
        };
        _this.panEnd = function (evt) {
            if (_this._panning) {
                var deltaX = _this.position === "right" ? -evt.deltaX : evt.deltaX;
                var visibleWidth = _this._panStartWidth + deltaX;
                _this.resetPan();
                if (_this.isOpen && visibleWidth <= _this._panStartWidth / 2) {
                    _this.close(true);
                }
                else if (!_this.isOpen && visibleWidth >= _this._panLimit / 2) {
                    _this.open(true);
                }
                _this._panStartWidth = null;
            }
        };
        _this.toggleOpenedEvent = function (evt) {
            _this.elementRef.nativeElement.removeEventListener("transitionend", _this.toggleOpenedEvent, false);
            _this._resolveOpen("opened");
            delete _this._resolveClose;
        };
        _this.toggleClosedEvent = function (evt) {
            _this.elementRef.nativeElement.removeEventListener("transitionend", _this.toggleClosedEvent, false);
            _this._resolveClose("closed");
            delete _this._resolveClose;
        };
        return _this;
    }
    Object.defineProperty(NavigationDrawer.prototype, "drawer", {
        get: function () {
            if (!this._drawer) {
                this._drawer = this.getChild("." + this.css.drawer);
            }
            return this._drawer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "overlay", {
        get: function () {
            if (!this._overlay) {
                this._overlay = this.getChild("." + this.css.overlay);
            }
            return this._overlay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "styleDummy", {
        get: function () {
            if (!this._styleDummy) {
                this._styleDummy = this.getChild("." + this.css.styleDummy);
            }
            return this._styleDummy;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "hasAnimateWidth", {
        get: function () {
            return this.pin || this._hasMimiTempl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "maxEdgeZone", {
        get: function () {
            return this._maxEdgeZone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "expectedWidth", {
        get: function () {
            return this.getExpectedWidth(false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "expectedMiniWidth", {
        get: function () {
            return this.getExpectedWidth(true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "touchManager", {
        get: function () {
            return this._touchManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationDrawer.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    NavigationDrawer.prototype.ngOnInit = function () {
        if (this._state) {
            this._state.add(this.id, this);
        }
    };
    NavigationDrawer.prototype.ngAfterContentInit = function () {
        this._hasMimiTempl = this.getChild(this.css.miniProjection) !== null;
        this.updateEdgeZone();
        this.checkPinThreshold();
        this.ensureDrawerHeight();
        this.ensureEvents();
    };
    NavigationDrawer.prototype.ngOnDestroy = function () {
        this._touchManager.destroy();
        if (this._state) {
            this._state.remove(this.id);
        }
        this._resizeObserver.unsubscribe();
    };
    NavigationDrawer.prototype.ngOnChanges = function (changes) {
        if (changes.enableGestures && changes.enableGestures.currentValue !== undefined) {
            this.enableGestures = !!(this.enableGestures && this.enableGestures.toString() === "true");
            this.ensureEvents();
        }
        if (changes.pin && changes.pin.currentValue !== undefined) {
            this.pin = !!(this.pin && this.pin.toString() === "true");
            this.ensureDrawerHeight();
            if (this.pin) {
                this._touchManager.destroy();
                this._gesturesAttached = false;
            }
            else {
                this.ensureEvents();
            }
        }
        if (changes.pinThreshold) {
            if (this.pinThreshold) {
                this.ensureEvents();
                this.checkPinThreshold();
            }
            else {
                this._resizeObserver.unsubscribe();
                this._resizeObserver = null;
            }
        }
        if (changes.width && this.isOpen) {
            this.setDrawerWidth(changes.width.currentValue);
        }
        if (changes.miniWidth) {
            if (!this.isOpen) {
                this.setDrawerWidth(changes.miniWidth.currentValue);
            }
            this.updateEdgeZone();
        }
    };
    NavigationDrawer.prototype.toggle = function (fireEvents) {
        if (this.isOpen) {
            return this.close(fireEvents);
        }
        else {
            return this.open(fireEvents);
        }
    };
    NavigationDrawer.prototype.open = function (fireEvents) {
        var _this = this;
        if (this._panning) {
            this.resetPan();
        }
        if (this.isOpen) {
            return Promise.resolve();
        }
        if (fireEvents) {
            this.opening.emit("opening");
        }
        this.isOpen = true;
        this.elementRef.nativeElement.addEventListener("transitionend", this.toggleOpenedEvent, false);
        this.setDrawerWidth(this.width);
        return new Promise(function (resolve) {
            _this._resolveOpen = function (value) {
                resolve(value);
                if (fireEvents) {
                    _this.opened.emit("opened");
                }
            };
        });
    };
    NavigationDrawer.prototype.close = function (fireEvents) {
        var _this = this;
        if (this._panning) {
            this.resetPan();
        }
        if (!this.isOpen) {
            return Promise.resolve();
        }
        if (fireEvents) {
            this.closing.emit("closing");
        }
        this.isOpen = false;
        this.setDrawerWidth(this._hasMimiTempl ? this.miniWidth : "");
        this.elementRef.nativeElement.addEventListener("transitionend", this.toggleClosedEvent, false);
        return new Promise(function (resolve) {
            _this._resolveClose = function (value) {
                resolve(value);
                if (fireEvents) {
                    _this.closed.emit("closed");
                }
            };
        });
    };
    NavigationDrawer.prototype.set_maxEdgeZone = function (value) {
        this._maxEdgeZone = value;
    };
    NavigationDrawer.prototype.ensureDrawerHeight = function () {
        if (this.pin) {
            this.renderer.setElementStyle(this.drawer, "height", window.innerHeight + "px");
        }
    };
    NavigationDrawer.prototype.getExpectedWidth = function (mini) {
        if (mini) {
            if (!this._hasMimiTempl) {
                return 0;
            }
            if (this.miniWidth) {
                return parseFloat(this.miniWidth);
            }
            else {
                if (this._widthCache.miniWidth === null) {
                    this.renderer.setElementClass(this.styleDummy, this.css.drawer, true);
                    this.renderer.setElementClass(this.styleDummy, this.css.mini, true);
                    this._widthCache.miniWidth = this.styleDummy.offsetWidth;
                    this.renderer.setElementClass(this.styleDummy, this.css.drawer, false);
                    this.renderer.setElementClass(this.styleDummy, this.css.mini, false);
                }
                return this._widthCache.miniWidth;
            }
        }
        else {
            if (this.width) {
                return parseFloat(this.width);
            }
            else {
                if (this._widthCache.width === null) {
                    this.renderer.setElementClass(this.styleDummy, this.css.drawer, true);
                    this._widthCache.width = this.styleDummy.offsetWidth;
                    this.renderer.setElementClass(this.styleDummy, this.css.drawer, false);
                }
                return this._widthCache.width;
            }
        }
    };
    NavigationDrawer.prototype.getWindowWidth = function () {
        return (window.innerWidth > 0) ? window.innerWidth : screen.width;
    };
    NavigationDrawer.prototype.setDrawerWidth = function (width) {
        var _this = this;
        window.requestAnimationFrame(function () {
            if (_this.drawer) {
                _this.renderer.setElementStyle(_this.drawer, "width", width);
            }
        });
    };
    NavigationDrawer.prototype.getDrawerWidth = function () {
        return this.drawer.offsetWidth;
    };
    NavigationDrawer.prototype.ensureEvents = function () {
        var _this = this;
        if (this.enableGestures && !this.pin && !this._gesturesAttached) {
            this._touchManager.addGlobalEventListener("document", "swipe", this.swipe);
            this._gesturesAttached = true;
            this._touchManager.addGlobalEventListener("document", "panstart", this.panstart);
            this._touchManager.addGlobalEventListener("document", "panmove", this.pan);
            this._touchManager.addGlobalEventListener("document", "panend", this.panEnd);
        }
        if (this.pinThreshold && !this._resizeObserver) {
            this._resizeObserver = Observable_1.Observable.fromEvent(window, "resize").debounce(function () { return Observable_1.Observable.interval(150); })
                .subscribe(function (value) { _this.checkPinThreshold(); });
        }
    };
    NavigationDrawer.prototype.updateEdgeZone = function () {
        var maxValue;
        if (this._hasMimiTempl) {
            maxValue = Math.max(this._maxEdgeZone, this.getExpectedWidth(true) * 1.1);
            this.set_maxEdgeZone(maxValue);
        }
    };
    NavigationDrawer.prototype.resetPan = function () {
        this._panning = false;
        this.renderer.setElementClass(this.overlay, "panning", false);
        this.renderer.setElementClass(this.drawer, "panning", false);
        this.setXSize(0, "");
    };
    NavigationDrawer.prototype.setXSize = function (x, opacity) {
        var _this = this;
        window.requestAnimationFrame(function () {
            if (_this.hasAnimateWidth) {
                _this.renderer.setElementStyle(_this.drawer, "width", x ? Math.abs(x) + "px" : "");
            }
            else {
                _this.renderer.setElementStyle(_this.drawer, "transform", x ? "translate3d(" + x + "px,0,0)" : "");
                _this.renderer.setElementStyle(_this.drawer, "-webkit-transform", x ? "translate3d(" + x + "px,0,0)" : "");
            }
            if (opacity !== undefined) {
                _this.renderer.setElementStyle(_this.overlay, "opacity", opacity);
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NavigationDrawer.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NavigationDrawer.prototype, "position", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NavigationDrawer.prototype, "enableGestures", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NavigationDrawer.prototype, "isOpen", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NavigationDrawer.prototype, "pin", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], NavigationDrawer.prototype, "pinThreshold", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NavigationDrawer.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NavigationDrawer.prototype, "miniWidth", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NavigationDrawer.prototype, "pinChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NavigationDrawer.prototype, "opening", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NavigationDrawer.prototype, "opened", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NavigationDrawer.prototype, "closing", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NavigationDrawer.prototype, "closed", void 0);
    NavigationDrawer = __decorate([
        core_1.Component({
            providers: [touch_1.HammerGesturesManager],
            selector: "igx-nav-drawer",
            styles: [__webpack_require__(67)],
            template: __webpack_require__(69)
        }),
        __param(0, core_1.Inject(core_1.ElementRef)),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [core_1.ElementRef,
            navigation_1.NavigationService,
            core_1.Renderer,
            touch_1.HammerGesturesManager])
    ], NavigationDrawer);
    return NavigationDrawer;
}(base_1.BaseComponent));
exports.NavigationDrawer = NavigationDrawer;
var NavigationDrawerModule = (function () {
    function NavigationDrawerModule() {
    }
    NavigationDrawerModule = __decorate([
        core_1.NgModule({
            declarations: [NavigationDrawer],
            exports: [NavigationDrawer]
        })
    ], NavigationDrawerModule);
    return NavigationDrawerModule;
}());
exports.NavigationDrawerModule = NavigationDrawerModule;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_62__;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_63__;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_64__;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_65__;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent = (function () {
    function BaseComponent(renderer) {
        this.renderer = renderer;
    }
    BaseComponent.prototype.getChild = function (selector) {
        try {
            if (this.id) {
                selector = "#" + this.id + " " + selector;
            }
            return document.querySelector(selector);
        }
        catch (error) {
            return null;
        }
    };
    return BaseComponent;
}());
exports.BaseComponent = BaseComponent;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(68);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".ig-nav-drawer{position:fixed;width:15.125em;height:100%;max-width:90%;min-height:100%;overflow-x:hidden;background-color:#fff;top:0;bottom:0;left:0;z-index:999;transition-property:width,transform;transition-duration:.3s,.3s;transition-timing-function:cubic-bezier(.25,.46,.45,.94),cubic-bezier(.25,.46,.45,.94);transition-delay:0s,0s;box-shadow:0 8px 10px -5px rgba(0,0,0,.26),0 16px 24px 2px rgba(0,0,0,.12),0 6px 30px 5px rgba(0,0,0,.08)}.ig-nav-drawer.collapsed{transform:translate3d(-300px,0,0);box-shadow:none}.ig-nav-drawer.collapsed.right{transform:translate3d(300px,0,0);box-shadow:none}.ig-nav-drawer.right{left:auto;right:0}.ig-nav-drawer.mini{width:60px;transition-duration:.2s,.2s}.ig-nav-drawer.pinned{position:relative;max-width:100%;box-shadow:none;z-index:0}.ig-nav-drawer.pinned.collapsed{transform:none;width:0;padding:0;overflow:hidden}.ig-nav-drawer.panning{overflow-x:hidden;transition:none}.style-dummy{height:0;background:none;box-shadow:none;transition:none;visibility:hidden}.ig-nav-drawer-overlay{opacity:1;background-color:rgba(0,0,0,.38);transition-property:opacity,visibility;transition-duration:.25s,.25s;transition-timing-function:ease-in,step-start;transition-delay:0s,0s;position:absolute;left:0;top:0;width:100%;height:100%;visibility:visible;z-index:999}.ig-nav-drawer-overlay.hidden{transition-timing-function:ease-in-out,step-end;visibility:hidden;opacity:0}.ig-nav-drawer-overlay.pinned{display:none}.ig-nav-drawer-overlay.panning{transform:translateZ(0);transition:none}.ig-nav-drawer-overlay.panning.hidden{visibility:visible}", ""]);

// exports


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ig-nav-drawer-overlay\" [class.pinned]=\"pin\" [class.hidden]=\"!isOpen\" (click)=\"close(true)\"></div>\n<aside class=\"ig-nav-drawer\" role=\"navigation\" \n    [class.collapsed]=\"!_hasMimiTempl && !isOpen\" [class.mini]=\"_hasMimiTempl && !isOpen\" [class.pinned]=\"pin\" [class.right]=\"position == 'right'\">\n    \n    <div class=\"\" [hidden]=\"!isOpen && _hasMimiTempl\">\n        <ng-content select=\".ig-drawer-content\"></ng-content>\n    </div>                \n    <div class=\"\" [hidden]=\"isOpen\">\n        <ng-content select=\".ig-drawer-mini-content\"></ng-content>\n    </div>\n</aside>\n<div class=\"style-dummy\"></div>"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var button_directive_1 = __webpack_require__(6);
var ripple_directive_1 = __webpack_require__(10);
var icon_component_1 = __webpack_require__(4);
var ButtonGroupAlignment;
(function (ButtonGroupAlignment) {
    ButtonGroupAlignment[ButtonGroupAlignment["horizontal"] = 0] = "horizontal";
    ButtonGroupAlignment[ButtonGroupAlignment["vertical"] = 1] = "vertical";
})(ButtonGroupAlignment = exports.ButtonGroupAlignment || (exports.ButtonGroupAlignment = {}));
var IgxButtonGroup = (function () {
    function IgxButtonGroup(_el, _renderer, cdr) {
        this._el = _el;
        this._renderer = _renderer;
        this.multiSelection = false;
        this.disabled = false;
        this.selectedIndexes = [];
        this.onSelect = new core_1.EventEmitter();
        this.onUnselect = new core_1.EventEmitter();
    }
    Object.defineProperty(IgxButtonGroup.prototype, "itemContentCssClass", {
        get: function () {
            return this._itemContentCssClass;
        },
        set: function (value) {
            this._itemContentCssClass = value || this._itemContentCssClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButtonGroup.prototype, "alignment", {
        get: function () {
            return this._isVertical ? ButtonGroupAlignment.vertical : ButtonGroupAlignment.horizontal;
        },
        set: function (value) {
            this._isVertical = value === ButtonGroupAlignment.vertical;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButtonGroup.prototype, "isVertical", {
        get: function () {
            return this._isVertical;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxButtonGroup.prototype, "selectedButtons", {
        get: function () {
            var _this = this;
            return this.buttons.filter(function (b, i) {
                return _this.selectedIndexes.indexOf(i) !== -1;
            });
        },
        enumerable: true,
        configurable: true
    });
    IgxButtonGroup.prototype.selectButton = function (index) {
        var _this = this;
        if (this.buttons.toArray()[index]._el.nativeElement.getAttribute("data-togglable") === "false"
            || this.buttons.toArray()[index]._el.nativeElement.classList.contains("igx-button--disabled")) {
            return;
        }
        var buttonElement = this.buttons.toArray()[index]._el.nativeElement;
        this.selectedIndexes.push(index);
        buttonElement.setAttribute("data-selected", true);
        this.onSelect.emit({ button: this.buttons.toArray()[index], index: index });
        this.values[index].selected = true;
        if (!this.multiSelection && this.selectedIndexes.length > 0) {
            this.buttons.forEach(function (b, i) {
                if (i !== index && _this.selectedIndexes.indexOf(i) !== -1) {
                    _this.deselectButton(i);
                }
            });
        }
    };
    IgxButtonGroup.prototype.deselectButton = function (index) {
        if (this.buttons.toArray()[index]._el.nativeElement.getAttribute("data-togglable") === "false"
            || this.buttons.toArray()[index]._el.nativeElement.classList.contains("igx-button--disabled")) {
            return;
        }
        var buttonElement = this.buttons.toArray()[index]._el.nativeElement;
        this.selectedIndexes.splice(this.selectedIndexes.indexOf(index), 1);
        buttonElement.setAttribute("data-selected", false);
        this.onUnselect.emit({ button: this.buttons.toArray()[index], index: index });
        this.values[index].selected = false;
    };
    IgxButtonGroup.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.buttons.forEach(function (button, index) {
                if (!button.disabled && button._el.nativeElement.getAttribute("data-selected") === "true") {
                    _this.selectButton(index);
                }
            });
        }, 0);
    };
    IgxButtonGroup.prototype._clickHandler = function (event, i) {
        if (this.selectedIndexes.indexOf(i) !== -1) {
            this.deselectButton(i);
        }
        else {
            this.selectButton(i);
        }
    };
    __decorate([
        core_1.ViewChildren(button_directive_1.IgxButton),
        __metadata("design:type", core_1.QueryList)
    ], IgxButtonGroup.prototype, "buttons", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxButtonGroup.prototype, "itemContentCssClass", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxButtonGroup.prototype, "multiSelection", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxButtonGroup.prototype, "values", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxButtonGroup.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxButtonGroup.prototype, "alignment", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxButtonGroup.prototype, "onSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxButtonGroup.prototype, "onUnselect", void 0);
    IgxButtonGroup = __decorate([
        core_1.Component({
            selector: "igx-buttongroup",
            styles: [__webpack_require__(71)],
            template: __webpack_require__(73)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2, core_1.ChangeDetectorRef])
    ], IgxButtonGroup);
    return IgxButtonGroup;
}());
exports.IgxButtonGroup = IgxButtonGroup;
var IgxButtonGroupModule = (function () {
    function IgxButtonGroupModule() {
    }
    IgxButtonGroupModule = __decorate([
        core_1.NgModule({
            declarations: [IgxButtonGroup],
            exports: [IgxButtonGroup],
            imports: [button_directive_1.IgxButtonModule, common_1.CommonModule, ripple_directive_1.IgxRippleModule, icon_component_1.IgxIconModule]
        })
    ], IgxButtonGroupModule);
    return IgxButtonGroupModule;
}());
exports.IgxButtonGroupModule = IgxButtonGroupModule;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(72);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-button-group,.igx-button-group--vertical{display:flex;flex-flow:row nowrap;justify-content:center;border-radius:2px;box-shadow:0 1px 5px 0 rgba(0,0,0,.26),0 2px 2px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.08);transition:box-shadow .2s ease;overflow:hidden}.igx-button-group--vertical{flex-flow:column nowrap}.igx-button-group--vertical .igx-button-group__item,.igx-button-group--vertical .igx-button-group__item--selected,.igx-button-group__item,.igx-button-group__item--selected{box-sizing:content-box;flex-grow:1;flex-basis:0;border:initial;border-left:1px solid;border-right:1px solid;border-color:transparent;min-width:24px;min-height:24px;border-radius:0;color:rgba(0,0,0,.38);font-weight:600;background:#fff}.igx-button-group__item--selected:first-child,.igx-button-group__item:first-child{border-left:0}.igx-button-group__item--selected:last-child,.igx-button-group__item:last-child{border-right:0}.igx-button-group__item--selected,.igx-button-group__item--selected:hover,.igx-button-group__item:hover{color:rgba(0,0,0,.54)!important;background:rgba(0,0,0,.26)!important;border-color:rgba(0,0,0,.08)}.igx-button-group--vertical .igx-button-group__item{border-left:0;border-right:0;border-bottom:1px solid;border-top:1px solid;border-color:transparent}.igx-button-group--vertical .igx-button-group__item:first-child{border-top:0}.igx-button-group--vertical .igx-button-group__item:last-child{border-bottom:0}.igx-button-group--vertical .igx-button-group__item--selected{color:rgba(0,0,0,.54)!important;background:rgba(0,0,0,.26)!important;border-color:rgba(0,0,0,.08)}.igx-button-group__item-content{display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;text-align:center}.igx-button-group__item-content *~*{margin-left:.625em}", ""]);

// exports


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-button-group\" role=\"group\" [class.igx-button-group--vertical]=\"isVertical\">\n\n    <span class=\"igx-button-group__item\" *ngFor=\"let button of values; let i = 'index'\" type=\"button\" (click)=\"_clickHandler($event, i)\"\n        igxButton=\"flat\" [attr.data-selected]=\"button.selected\" [attr.data-togglable]=\"button.togglable\" [attr.aria-pressed]=\"button.selected\"\n        [disabled]=\"disabled || button.disabled\" [igxButtonColor]=\"button.color\" [igxButtonBackground]=\"button.bgcolor\" [igxLabel]=\"button.label\"\n        [igxRipple]=\"button.ripple\" [class.igx-button-group__item--selected]=\"button.selected\">\n        <div class=\"igx-button-group__item-content {{ itemContentCssClass }}\">\n            <igx-icon *ngIf=\"button.icon\" fontSet=\"material\" [name]=\"button.icon\"></igx-icon>\n            <span *ngIf=\"button.label\">{{button.label}}</span>\n</div>\n</span>\n\n</div>\n"

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var button_directive_1 = __webpack_require__(6);
var touch_1 = __webpack_require__(26);
var ripple_directive_1 = __webpack_require__(10);
var IgxListPanState;
(function (IgxListPanState) {
    IgxListPanState[IgxListPanState["NONE"] = 0] = "NONE";
    IgxListPanState[IgxListPanState["LEFT"] = 1] = "LEFT";
    IgxListPanState[IgxListPanState["RIGHT"] = 2] = "RIGHT";
})(IgxListPanState = exports.IgxListPanState || (exports.IgxListPanState = {}));
var IgxList = (function () {
    function IgxList(element) {
        this.element = element;
        this.allowLeftPanning = false;
        this.allowRightPanning = false;
        this.hasNoItemsTemplate = false;
        this.emptyListMessage = "No items";
        this.emptyListButtonText = "Add";
        this.emptyListButtonClick = new core_1.EventEmitter();
        this.onLeftPan = new core_1.EventEmitter();
        this.onRightPan = new core_1.EventEmitter();
        this.onPanStateChange = new core_1.EventEmitter();
        this._innerStyle = "igx-list";
    }
    Object.defineProperty(IgxList.prototype, "innerStyle", {
        get: function () {
            return this._innerStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxList.prototype, "items", {
        get: function () {
            var items = [];
            if (this.children !== undefined) {
                for (var _i = 0, _a = this.children.toArray(); _i < _a.length; _i++) {
                    var child = _a[_i];
                    if (!child.isHeader) {
                        items.push(child);
                    }
                }
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxList.prototype, "headers", {
        get: function () {
            var headers = [];
            if (this.children !== undefined) {
                for (var _i = 0, _a = this.children.toArray(); _i < _a.length; _i++) {
                    var child = _a[_i];
                    if (child.isHeader) {
                        headers.push(child);
                    }
                }
            }
            return headers;
        },
        enumerable: true,
        configurable: true
    });
    IgxList.prototype.onEmptyListButtonClicked = function (event) {
        this.emptyListButtonClick.emit({ list: this, event: event });
    };
    __decorate([
        core_1.ContentChildren(core_1.forwardRef(function () { return IgxListItem; })),
        __metadata("design:type", core_1.QueryList)
    ], IgxList.prototype, "children", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxList.prototype, "allowLeftPanning", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxList.prototype, "allowRightPanning", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxList.prototype, "hasNoItemsTemplate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxList.prototype, "emptyListImage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxList.prototype, "emptyListMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxList.prototype, "emptyListButtonText", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxList.prototype, "emptyListButtonClick", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxList.prototype, "onLeftPan", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxList.prototype, "onRightPan", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxList.prototype, "onPanStateChange", void 0);
    IgxList = __decorate([
        core_1.Component({
            host: {
                role: "list"
            },
            selector: "igx-list",
            styles: [__webpack_require__(28)],
            template: __webpack_require__(76)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], IgxList);
    return IgxList;
}());
exports.IgxList = IgxList;
var IgxListItem = (function () {
    function IgxListItem(list, _renderer) {
        this.list = list;
        this._renderer = _renderer;
        this.hidden = false;
        this.isHeader = false;
        this._panState = IgxListPanState.NONE;
        this._FRACTION_OF_WIDTH_TO_TRIGGER_GRIP = 0.5;
        this._innerStyle = "";
        this._previousPanDeltaX = 0;
    }
    Object.defineProperty(IgxListItem.prototype, "innerStyle", {
        get: function () {
            return this._innerStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "panState", {
        get: function () {
            return this._panState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "index", {
        get: function () {
            return this.list.children.toArray().indexOf(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "width", {
        get: function () {
            if (this.element && this.element.nativeElement) {
                return this.element.nativeElement.offsetWidth;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "left", {
        get: function () {
            return this.element.nativeElement.offsetLeft;
        },
        set: function (value) {
            var val = value + "";
            if (val.indexOf("px") === -1) {
                val += "px";
            }
            this.element.nativeElement.style.left = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "maxLeft", {
        get: function () {
            return -this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxListItem.prototype, "maxRight", {
        get: function () {
            return this.width;
        },
        enumerable: true,
        configurable: true
    });
    IgxListItem.prototype.ngOnInit = function () {
        if (this.isHeader) {
            this._innerStyle = "igx-list__header";
            this.role = "separator";
        }
        else {
            this._innerStyle = "igx-list__item";
            this.role = "listitem";
            this._addEventListeners();
            this.element.nativeElement.style.touchAction = "pan-y";
        }
        this.element.nativeElement.setAttribute("aria-label", this.element.nativeElement.textContent.trim());
    };
    IgxListItem.prototype.ngOnDestroy = function () {
    };
    IgxListItem.prototype._addEventListeners = function () {
        var _this = this;
        if (this._renderer && this.options && (this.list.allowLeftPanning || this.list.allowRightPanning)) {
            this._renderer.listen(this.element.nativeElement, "panstart", function (event) { _this.panStart(event); });
            this._renderer.listen(this.element.nativeElement, "panmove", function (event) { _this.panMove(event); });
            this._renderer.listen(this.element.nativeElement, "panend", function (event) { _this.panEnd(event); });
        }
    };
    IgxListItem.prototype.panStart = function (ev) {
        this._previousPanDeltaX = 0;
    };
    IgxListItem.prototype.panMove = function (ev) {
        var isPanningToLeft = this.left + ev.deltaX < this.left;
        if (isPanningToLeft) {
            this.left += ev.deltaX - this._previousPanDeltaX;
            if (this.list.allowRightPanning && !this.list.allowLeftPanning && this.left < 0) {
                this.left = 0;
            }
            else if (this.left < this.maxLeft) {
                this.left = this.maxLeft;
            }
        }
        else if (!isPanningToLeft) {
            this.left += ev.deltaX - this._previousPanDeltaX;
            if (this.list.allowLeftPanning && !this.list.allowRightPanning && this.left > 0) {
                this.left = 0;
            }
            else if (this.left > this.maxRight) {
                this.left = this.maxRight;
            }
        }
        this._previousPanDeltaX = ev.deltaX;
    };
    IgxListItem.prototype.panEnd = function (ev) {
        var oldPanState = this._panState;
        this.performMagneticGrip();
        if (oldPanState !== this._panState) {
            this.list.onPanStateChange.emit({ oldState: oldPanState, newState: this._panState, item: this });
            if (this._panState === IgxListPanState.LEFT) {
                this.list.onLeftPan.emit(this);
            }
            else if (this._panState === IgxListPanState.RIGHT) {
                this.list.onRightPan.emit(this);
            }
        }
        this._previousPanDeltaX = 0;
    };
    IgxListItem.prototype.performMagneticGrip = function () {
        var widthTriggeringGrip = this.width * this._FRACTION_OF_WIDTH_TO_TRIGGER_GRIP;
        if (this.left > 0) {
            if (this.left > widthTriggeringGrip) {
                this.left = this.maxRight;
                this._panState = IgxListPanState.RIGHT;
            }
            else {
                this.left = 0;
                this._panState = IgxListPanState.NONE;
            }
        }
        else {
            if (-this.left > widthTriggeringGrip) {
                this.left = this.maxLeft;
                this._panState = IgxListPanState.LEFT;
            }
            else {
                this.left = 0;
                this._panState = IgxListPanState.NONE;
            }
        }
    };
    __decorate([
        core_1.ViewChild("wrapper"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxListItem.prototype, "element", void 0);
    __decorate([
        core_1.HostBinding("attr.role"),
        __metadata("design:type", Object)
    ], IgxListItem.prototype, "role", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxListItem.prototype, "isHeader", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxListItem.prototype, "href", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], IgxListItem.prototype, "options", void 0);
    IgxListItem = __decorate([
        core_1.Component({
            providers: [touch_1.HammerGesturesManager],
            selector: "igx-list-item",
            styles: [__webpack_require__(28)],
            template: __webpack_require__(77)
        }),
        __param(0, core_1.Inject(core_1.forwardRef(function () { return IgxList; }))),
        __metadata("design:paramtypes", [IgxList,
            core_1.Renderer2])
    ], IgxListItem);
    return IgxListItem;
}());
exports.IgxListItem = IgxListItem;
var IgxListModule = (function () {
    function IgxListModule() {
    }
    IgxListModule = __decorate([
        core_1.NgModule({
            declarations: [IgxList, IgxListItem],
            exports: [IgxList, IgxListItem],
            imports: [common_1.CommonModule, button_directive_1.IgxButtonModule, ripple_directive_1.IgxRippleModule]
        })
    ], IgxListModule);
    return IgxListModule;
}());
exports.IgxListModule = IgxListModule;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-list{background-color:#fff;height:100%;overflow:hidden}.igx-list__empty,.igx-list__empty--custom{display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;height:inherit}.image{width:auto;max-height:120px}.message{text-align:center;color:#333;padding:1em;z-index:1}igx-list-item{display:block;position:relative;list-style-type:none;user-select:none}.igx-list__header{align-items:center;color:#e41c77;font-size:.8125em;font-weight:400;height:3em;line-height:3em;user-select:none}.igx-list__header,.igx-list__item{display:flex;background-color:#fff;padding:.5em 1em}.igx-list__item{position:relative;flex-flow:column wrap;justify-content:center;min-height:3em;font-size:1em;color:rgba(0,0,0,.74);z-index:2}.igx-list__item:active{background-color:rgba(0,0,0,.04);z-index:3}", ""]);

// exports


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<div class=\"{{innerStyle}}\">\n  <ng-content></ng-content>\n\n  <section *ngIf=\"children.length === 0 && !hasNoItemsTemplate\" class=\"igx-list__empty\">\n    <img class=\"image\" alt=\"{{ emptyListMessage }} image.\" src=\"{{ emptyListImage }}\" />\n\n    <article class=\"message\">\n      <p>{{ emptyListMessage }}</p>\n      <button igxButton=\"raised\" igxRipple=\"white\" (click)=\"onEmptyListButtonClicked($event)\">{{ emptyListButtonText }}</button>\n    </article>\n  </section>\n\n  <ng-content *ngIf=\"children.length === 0 && hasNoItemsTemplate\" select=\".igx-list__empty--custom\">\n  </ng-content>\n\n</div>\n"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<div #wrapper class=\"{{innerStyle}}\" [hidden]=\"hidden\">\n  <ng-content></ng-content>\n</div>\n"

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var badge_component_1 = __webpack_require__(29);
var icon_component_1 = __webpack_require__(4);
var IgxTabBar = (function () {
    function IgxTabBar(_element) {
        this._element = _element;
        this.onTabSelected = new core_1.EventEmitter();
        this.onTabDeselected = new core_1.EventEmitter();
        this.selectedIndex = -1;
        this._itemStyle = "igx-tab-bar";
    }
    Object.defineProperty(IgxTabBar.prototype, "itemStyle", {
        get: function () {
            return this._itemStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxTabBar.prototype, "selectedTab", {
        get: function () {
            if (this.tabs && this.selectedIndex !== undefined) {
                return this.tabs.toArray()[this.selectedIndex];
            }
        },
        enumerable: true,
        configurable: true
    });
    IgxTabBar.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.selectedIndex === -1) {
                var selectablePanels = _this.panels.filter(function (p) { return !p.isDisabled; });
                var panel = selectablePanels[0];
                if (panel) {
                    panel.select();
                }
            }
        }, 0);
    };
    IgxTabBar.prototype._selectedPanelHandler = function (args) {
        var _this = this;
        this.selectedIndex = args.panel.index;
        this.panels.forEach(function (p) {
            if (p.index !== _this.selectedIndex) {
                _this._deselectPanel(p);
            }
        });
    };
    IgxTabBar.prototype._deselectPanel = function (panel) {
        if (panel.isDisabled || this.selectedTab.index === panel.index) {
            return;
        }
        panel.isSelected = false;
        this.onTabDeselected.emit({ tab: this.tabs[panel.index], panel: panel });
    };
    __decorate([
        core_1.ViewChildren(core_1.forwardRef(function () { return IgxTab; })),
        __metadata("design:type", core_1.QueryList)
    ], IgxTabBar.prototype, "tabs", void 0);
    __decorate([
        core_1.ContentChildren(core_1.forwardRef(function () { return IgxTabPanel; })),
        __metadata("design:type", core_1.QueryList)
    ], IgxTabBar.prototype, "panels", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxTabBar.prototype, "onTabSelected", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxTabBar.prototype, "onTabDeselected", void 0);
    IgxTabBar = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            host: {
                "(onTabSelected)": "_selectedPanelHandler($event)"
            },
            selector: "igx-tab-bar",
            styles: [__webpack_require__(82)],
            template: __webpack_require__(84)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], IgxTabBar);
    return IgxTabBar;
}());
exports.IgxTabBar = IgxTabBar;
var IgxTabPanel = (function () {
    function IgxTabPanel(_tabBar) {
        this._tabBar = _tabBar;
        this.isSelected = false;
        this._itemStyle = "igx-tab-panel";
    }
    Object.defineProperty(IgxTabPanel.prototype, "itemStyle", {
        get: function () {
            return this._itemStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxTabPanel.prototype, "relatedTab", {
        get: function () {
            if (this._tabBar.tabs) {
                return this._tabBar.tabs.toArray()[this.index];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxTabPanel.prototype, "index", {
        get: function () {
            return this._tabBar.panels.toArray().indexOf(this);
        },
        enumerable: true,
        configurable: true
    });
    IgxTabPanel.prototype.select = function () {
        if (this.isDisabled || this._tabBar.selectedIndex === this.index) {
            return;
        }
        this.isSelected = true;
        this._tabBar.onTabSelected.emit({ tab: this._tabBar.tabs.toArray()[this.index], panel: this });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxTabPanel.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxTabPanel.prototype, "icon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxTabPanel.prototype, "isDisabled", void 0);
    IgxTabPanel = __decorate([
        core_1.Component({
            host: {
                "[attr.aria-labelledby]": "'igx-tab-' + index",
                "[class.igx-tab-bar__panel--selected]": "isSelected",
                "[class.igx-tab-bar__panel]": "!isSelected",
                "[id]": "'igx-tab-bar__panel-' + index",
                "role": "tabpanel"
            },
            selector: "igx-tab-panel",
            template: __webpack_require__(85)
        }),
        __metadata("design:paramtypes", [IgxTabBar])
    ], IgxTabPanel);
    return IgxTabPanel;
}());
exports.IgxTabPanel = IgxTabPanel;
var IgxTab = (function () {
    function IgxTab(_tabBar, _element) {
        this._tabBar = _tabBar;
        this._element = _element;
        this._changesCount = 0;
    }
    Object.defineProperty(IgxTab.prototype, "isDisabled", {
        get: function () {
            var panel = this.relatedPanel;
            if (panel) {
                return panel.isDisabled;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxTab.prototype, "isSelected", {
        get: function () {
            var panel = this.relatedPanel;
            if (panel) {
                return panel.isSelected;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxTab.prototype, "index", {
        get: function () {
            return this._tabBar.tabs.toArray().indexOf(this);
        },
        enumerable: true,
        configurable: true
    });
    IgxTab.prototype.select = function () {
        this.relatedPanel.select();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", IgxTabPanel)
    ], IgxTab.prototype, "relatedPanel", void 0);
    IgxTab = __decorate([
        core_1.Component({
            host: {
                class: "igx-tab-bar__menu-item",
                role: "tab"
            },
            selector: "igx-tab",
            template: __webpack_require__(86)
        }),
        __metadata("design:paramtypes", [IgxTabBar, core_1.ElementRef])
    ], IgxTab);
    return IgxTab;
}());
exports.IgxTab = IgxTab;
var IgxTabBarModule = (function () {
    function IgxTabBarModule() {
    }
    IgxTabBarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxTabBar, IgxTabPanel, IgxTab],
            exports: [IgxTabBar, IgxTabPanel, IgxTab],
            imports: [common_1.CommonModule, badge_component_1.IgxBadgeModule, icon_component_1.IgxIconModule]
        })
    ], IgxTabBarModule);
    return IgxTabBarModule;
}());
exports.IgxTabBarModule = IgxTabBarModule;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(80);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-badge,.igx-badge--bottom-left,.igx-badge--bottom-right,.igx-badge--top-left,.igx-badge--top-right{position:absolute;max-width:100%}.igx-badge__circle{display:flex;justify-content:center;align-items:center;min-width:22px;height:22px;font-size:.625em;font-weight:600;color:#fff;background-color:#e41c77;border:0 solid #fff;line-height:2px;border-radius:4px;box-shadow:0 1px 3px 0 rgba(0,0,0,.26),0 1px 1px 0 rgba(0,0,0,.12),0 2px 1px -1px rgba(0,0,0,.08);overflow:hidden}.igx-badge__circle i{font-size:.6875em;font-weight:600}.igx-badge__circle-value{white-space:nowrap;padding:4px}.igx-badge__circle{border-radius:11px}.igx-badge__circle--success{background-color:#4caf50}.igx-badge__circle--info{background-color:#0375be}.igx-badge__circle--warning{background-color:#fbb13c}.igx-badge__circle--error{background-color:#f44336}.igx-badge--hidden{visibility:hidden}.igx-badge--top-left{top:-5px;left:-5px}.igx-badge--top-right{top:-5px;right:-5px}.igx-badge--bottom-left{bottom:-5px;left:-5px}.igx-badge--bottom-right{bottom:-5px;right:-5px}@keyframes scale-in{0%{transform:scale(0)}}", ""]);

// exports


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<div [ngClass]=\"setPosition()\" aria-label=\"badge\" role=\"img\">\n\t<div class=\"igx-badge__circle\" [ngClass]=\"setClasses()\" [attr.aria-roledescription]=\"roleDescription\">\n\t\t<span *ngIf=\"!iconBdg\" class=\"igx-badge__circle-value\">{{value}}</span>\n\t\t<igx-icon *ngIf=\"iconBdg\" fontSet=\"material\" [name]=\"iconBdg\"></igx-icon>\n\t\t<!-- <i *ngIf=\"iconBdg\" class=\"material-icons igx-badge__circle-value\" >{{iconBdg}}</i> -->\n\t</div>\n</div>"

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(83);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-tab-bar__panel,.igx-tab-bar__panel--selected{display:none}.igx-tab-bar__panel--selected{display:block}.igx-tab-bar__menu,.igx-tab-bar__menu--bottom,.igx-tab-bar__menu--top{display:flex;position:fixed;width:100%;justify-content:center;align-items:center;height:3.5em;background:#fff;color:#333;overflow:hidden;z-index:8}.igx-tab-bar__menu--top{bottom:inherit;top:0;box-shadow:0 5px 5px -3px rgba(0,0,0,.26),0 8px 10px 1px rgba(0,0,0,.12),0 3px 14px 2px rgba(0,0,0,.08)}.igx-tab-bar__menu--bottom{top:inherit;bottom:0;box-shadow:0 -2px 4px -1px rgba(0,0,0,.26),0 -4px 5px 0 rgba(0,0,0,.12),0 -1px 10px 0 rgba(0,0,0,.08)}.igx-tab-bar__menu-item{display:flex;position:relative;flex-flow:column nowrap;align-items:center;justify-content:center;min-width:80px;max-width:168px;height:100%;flex:1;cursor:pointer;text-transform:uppercase;white-space:nowrap;text-overflow:ellipsis;user-select:none;overflow:hidden;padding:0 .75em;-webkit-tap-highlight-color:transparent}.igx-tab-bar__menu-item--disabled{opacity:.5;cursor:default}.igx-tab-bar__menu-item--selected .tab-icon,.igx-tab-bar__menu-item--selected .tab-label{opacity:1;color:#0375be;transition:color .25s ease-out,opacity .25s ease-out}.igx-tab-bar__menu-item .tab-label{padding-top:5px;font-size:.75em;line-height:.75em;max-width:80px;text-transform:uppercase;text-overflow:ellipsis;overflow:hidden;z-index:1;opacity:.75}.igx-tab-bar__menu-item .tab-icon{display:flex;position:relative;justify-content:center;height:24px;z-index:1;opacity:.75;padding:0 8px}.igx-tab-bar__menu-item .tab-icon i{width:24px;height:24px}", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <ng-content></ng-content>\n</div>\n<div #tablist class=\"{{itemStyle}}__menu {{itemStyle}}__menu--bottom\" role=\"tablist\" aria-orientation=\"horizontal\">\n    <igx-tab *ngFor=\"let panel of panels\"\n             [id]=\"'igx-tab-' + panel.index\"\n             [attr.aria-label]= \"panel.label\"\n             [attr.aria-disabled]=\"panel.isDisabled\"\n             [attr.aria-selected]=\"panel.isSelected\"\n             [attr.aria-controls]=\"'igx-tab-panel-'+ panel.index\"\n             [class.igx-tab-bar__menu-item--selected]=\"panel.isSelected\"\n             [class.igx-tab-bar__menu-item--disabled]=\"panel.isDisabled\"\n             [relatedPanel]=\"panel\"\n             (click)= \"panel.select()\"\n             role=\"tab\" >\n    </igx-tab>\n</div>\n"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<ng-content></ng-content>\n"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"relatedPanel.icon\" ngClass=\"tab-icon\">\n    <igx-icon fontSet=\"material\" [name]=\"relatedPanel.icon\"></igx-icon>\n    <igx-badge [value]=\"_changesCount\" [hidden]=\"_changesCount == 0\"></igx-badge>\n</div>\n<div *ngIf=\"relatedPanel.label\" ngClass=\"tab-label\">{{relatedPanel.label}}</div>"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_87__;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(89);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-calendar,.igx-calendar--vertical{display:flex;flex-flow:column nowrap;width:100%;overflow:hidden;outline:none}.igx-calendar--vertical{flex-flow:row nowrap}.igx-calendar--vertical .igx-calendar__header{width:168px}.igx-calendar__header{background-color:#e41c77;color:#fff;padding:1.5em 1em}.igx-calendar__header-year{margin:0;color:hsla(0,0%,100%,.8);font-size:1.125em}.igx-calendar--vertical .igx-calendar__header-date,.igx-calendar__header-date{display:flex;margin:0;font-size:2.375em;line-height:1em}.igx-calendar--vertical .igx-calendar__header-date{flex-flow:column nowrap}.igx-calendar__body-picker .date__el:focus,.igx-calendar__body-picker .date__el:hover{color:#e41c77;cursor:pointer}.igx-calendar__body-picker{display:flex;height:56px;justify-content:space-between;align-items:center;padding-bottom:1.5em;padding-left:1.5em;padding-right:1.5em}.igx-calendar__body-picker .next,.igx-calendar__body-picker .prev{color:rgba(0,0,0,.74);user-select:none;cursor:pointer}.igx-calendar__body-picker .next:hover,.igx-calendar__body-picker .prev:hover{color:#e41c77}.igx-calendar__body-picker .date{font-size:1.125em;line-height:1.375em;font-weight:600;text-align:center}.igx-calendar__body{padding-top:1.5em;padding-bottom:1.5em;overflow:hidden}.igx-calendar__body-row,.igx-calendar__body-row--wrap{display:flex;justify-content:space-between;padding:0 1em}.igx-calendar__body-row--wrap{flex-wrap:wrap}.igx-calendar__body-column{display:flex;flex-flow:column nowrap;justify-content:space-between;align-items:center}.igx-calendar__date,.igx-calendar__date--current,.igx-calendar__date--inactive,.igx-calendar__date--selected,.igx-calendar__date--weekend,.igx-calendar__label,.igx-calendar__month,.igx-calendar__month--current,.igx-calendar__year,.igx-calendar__year--current{display:flex;margin:.125em;justify-content:center;align-items:center;width:2.5em;height:2.5em;font-size:1em;line-height:1.375em;border-radius:1.25em;color:rgba(0,0,0,.87);cursor:pointer;outline:none;transition:background .15s ease-out}.igx-calendar__label{cursor:default}.igx-calendar__date--weekend,.igx-calendar__label{color:rgba(0,0,0,.26)}.igx-calendar__year,.igx-calendar__year--current{font-size:1.125em}.igx-calendar__year--current{font-size:1.5em;color:#e41c77}.igx-calendar__month:focus,.igx-calendar__month:hover,.igx-calendar__year:focus,.igx-calendar__year:hover{color:#e41c77}.igx-calendar__month,.igx-calendar__month--current{display:flex;margin:0 .75em;flex:1 0 25%;justify-content:center;align-items:center;height:91px}.igx-calendar__month--current{color:#e41c77}.igx-calendar__date--inactive{color:rgba(0,0,0,.26)}.igx-calendar__date--selected{position:relative;color:#fff;background-color:#e41c77!important;font-weight:600}.igx-calendar__date--current{color:#e41c77;font-weight:600}.igx-calendar__date--current:focus,.igx-calendar__date--current:hover,.igx-calendar__date--inactive:focus,.igx-calendar__date--inactive:hover,.igx-calendar__date--weekend:focus,.igx-calendar__date--weekend:hover,.igx-calendar__date:focus,.igx-calendar__date:hover{background-color:rgba(0,0,0,.04)}.igx-calendar__date--inactive{cursor:pointer}:host{flex:1 0 100%}", ""]);

// exports


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<div tabindex=\"0\" (keydown)=\"handleKeyDown($event)\" class=\"igx-calendar\" role=\"grid\" aria-labelledby=\"calendar\">\n\n    <div class=\"igx-calendar__header\" *ngIf=\"selection === 'single'\">\n        <h5 class=\"igx-calendar__header-year\">{{ getHeaderYear() }}</h5>\n        <h2 class=\"igx-calendar__header-date\">\n            <span>\n                {{ getFormattedDate().weekday }},&nbsp;\n            </span>\n            <span>\n                {{ getFormattedDate().monthday }}\n            </span>\n        </h2>\n    </div>\n\n\n    <div *ngIf=\"isDefaultView\" class=\"igx-calendar__body\" [@animateView]=\"activeView\" (swiperight)=\"prevMonth()\" (swipeleft)=\"nextMonth()\">\n        <div class=\"igx-calendar__body-picker\">\n            <div class=\"prev\" (click)=\"prevMonth()\">\n                <igx-icon fontSet=\"material\" name=\"keyboard_arrow_left\"></igx-icon>\n            </div>\n            <div class=\"date\">\n                <span (click)=\"activeViewYear()\" class=\"date__el\">{{ getMonthName(viewDate) }}</span>\n                <span (click)=\"activeViewDecade()\" class=\"date__el\">{{ viewDate.getFullYear() }}</span>\n            </div>\n            <div class=\"next\" (click)=\"nextMonth()\">\n                <igx-icon fontSet=\"material\" name=\"keyboard_arrow_right\"></igx-icon>\n            </div>\n        </div>\n\n        <div class=\"igx-calendar__body-row\">\n            <span *ngFor=\"let dayName of generateWeekHeader()\" class=\"igx-calendar__label\">\n                {{ dayName }}\n            </span>\n        </div>\n        <div *ngFor=\"let week of getCalendarMonth; trackBy: rowTracker\" class=\"igx-calendar__body-row\" (click)=\"onDateClick($event)\"\n            [@animateChange]=\"monthAction\">\n            <span tabindex=\"0\" *ngFor=\"let day of week; trackBy: dateTracker\" [attr.data-prevmonth]=\"day.isPrevMonth ? true : null\" [attr.data-nextmonth]=\"day.isNextMonth ? true : null\"\n                [attr.data-curmonth]=\"day.isCurrentMonth ? true : null\" [class.igx-calendar__date--inactive]=\"isInactive(day)\"\n                [class.igx-calendar__date]=\"day.isCurrentMonth && !isWeekend(day) && !isSelected(day)\" [class.igx-calendar__date--weekend]=\"isWeekend(day)\"\n                [class.igx-calendar__date--current]=\"isToday(day) && !isSelected(day)\" [class.igx-calendar__date--selected]=\"isSelected(day)\">\n                {{ day.date.getDate() }}\n            </span>\n        </div>\n\n    </div>\n\n    <div *ngIf=\"isYearView\" class=\"igx-calendar__body\" [@animateView]=\"activeView\">\n        <div class=\"igx-calendar__body-row--wrap\" (click)=\"changeMonth($event)\">\n            <div [attr.data-index]=\"i\" *ngFor=\"let month of getYear(); trackBy: monthTracker; let i = index;\" [class.igx-calendar__month]=\"!isCurrentMonth(month)\"\n                [class.igx-calendar__month--current]=\"isCurrentMonth(month)\">\n                {{ getMonthName(month) }}\n            </div>\n        </div>\n    </div>\n\n    <div *ngIf=\"isDecadeView\" class=\"igx-calendar__body\" [@animateView]=\"activeView\">\n        <div class=\"igx-calendar__body-column\" (click)=\"changeYear($event)\" (wheel)=\"handleScroll($event)\">\n            <span *ngFor=\"let year of getDecade()\" [class.igx-calendar__year]=\"!isCurrentYear(year)\" [class.igx-calendar__year--current]=\"isCurrentYear(year)\">\n                {{ year }}\n            </span>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var icon_component_1 = __webpack_require__(4);
var Direction;
(function (Direction) {
    Direction[Direction["NONE"] = 0] = "NONE";
    Direction[Direction["NEXT"] = 1] = "NEXT";
    Direction[Direction["PREV"] = 2] = "PREV";
})(Direction = exports.Direction || (exports.Direction = {}));
var IgxCarousel = (function () {
    function IgxCarousel() {
        this.loop = true;
        this.pause = true;
        this.navigation = true;
        this.onSlideChanged = new core_1.EventEmitter();
        this.onSlideAdded = new core_1.EventEmitter();
        this.onSlideRemoved = new core_1.EventEmitter();
        this.onCarouselPaused = new core_1.EventEmitter();
        this.onCarouselPlaying = new core_1.EventEmitter();
        this.slides = [];
        this._total = 0;
    }
    Object.defineProperty(IgxCarousel.prototype, "interval", {
        get: function () {
            return this._interval;
        },
        set: function (value) {
            this._interval = +value;
            this._restartInterval();
        },
        enumerable: true,
        configurable: true
    });
    IgxCarousel.prototype.ngOnDestroy = function () {
        this._destroyed = true;
        if (this._lastInterval) {
            clearInterval(this._lastInterval);
        }
    };
    IgxCarousel.prototype.setAriaLabel = function (slide) {
        return "Item " + (slide.index + 1) + " of " + this.total;
    };
    Object.defineProperty(IgxCarousel.prototype, "total", {
        get: function () {
            return this._total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCarousel.prototype, "current", {
        get: function () {
            return !this._currentSlide ? 0 : this._currentSlide.index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCarousel.prototype, "isPlaying", {
        get: function () {
            return this._playing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxCarousel.prototype, "isDestroyed", {
        get: function () {
            return this._destroyed;
        },
        enumerable: true,
        configurable: true
    });
    IgxCarousel.prototype.get = function (index) {
        for (var _i = 0, _a = this.slides; _i < _a.length; _i++) {
            var each = _a[_i];
            if (each.index === index) {
                return each;
            }
        }
    };
    IgxCarousel.prototype.add = function (slide) {
        slide.index = this.total;
        this.slides.push(slide);
        this._total += 1;
        if (this.total === 1 || slide.active) {
            this.select(slide);
            if (this.total === 1) {
                this.play();
            }
        }
        else {
            slide.active = false;
        }
        this.onSlideAdded.emit(this);
    };
    IgxCarousel.prototype.remove = function (slide) {
        this.slides.splice(slide.index, 1);
        this._total -= 1;
        if (!this.total) {
            this._currentSlide = null;
            return;
        }
        for (var i = 0; i < this.total; i++) {
            this.slides[i].index = i;
        }
        this.onSlideRemoved.emit(this);
    };
    IgxCarousel.prototype.select = function (slide, direction) {
        if (direction === void 0) { direction = Direction.NONE; }
        var newIndex = slide.index;
        if (direction === Direction.NONE) {
            direction = newIndex > this.current ? Direction.NEXT : Direction.PREV;
        }
        if (slide && slide !== this._currentSlide) {
            this._moveTo(slide, direction);
        }
    };
    IgxCarousel.prototype.next = function () {
        var index = (this.current + 1) % this.total;
        if (index === 0 && !this.loop) {
            this.stop();
            return;
        }
        return this.select(this.get(index), Direction.NEXT);
    };
    IgxCarousel.prototype.prev = function () {
        var index = this.current - 1 < 0 ?
            this.total - 1 : this.current - 1;
        if (!this.loop && index === this.total - 1) {
            this.stop();
            return;
        }
        return this.select(this.get(index), Direction.PREV);
    };
    IgxCarousel.prototype.play = function () {
        if (!this._playing) {
            this._playing = true;
            this.onCarouselPlaying.emit(this);
            this._restartInterval();
        }
    };
    IgxCarousel.prototype.stop = function () {
        if (this.pause) {
            this._playing = false;
            this.onCarouselPaused.emit(this);
            this._resetInterval();
        }
    };
    IgxCarousel.prototype.onKeydown = function (event) {
        switch (event.key) {
            case "ArrowLeft":
                this.prev();
                break;
            case "ArrowRight":
                this.next();
                break;
            default:
                return;
        }
    };
    IgxCarousel.prototype._moveTo = function (slide, direction) {
        if (this._destroyed) {
            return;
        }
        slide.direction = direction;
        slide.active = true;
        if (this._currentSlide) {
            this._currentSlide.direction = direction;
            this._currentSlide.active = false;
        }
        this._currentSlide = slide;
        this.onSlideChanged.emit(this);
        this._restartInterval();
    };
    IgxCarousel.prototype._resetInterval = function () {
        if (this._lastInterval) {
            clearInterval(this._lastInterval);
            this._lastInterval = null;
        }
    };
    IgxCarousel.prototype._restartInterval = function () {
        var _this = this;
        this._resetInterval();
        if (!isNaN(this.interval) && this.interval > 0) {
            this._lastInterval = setInterval(function () {
                var tick = +_this.interval;
                if (_this._playing && _this.total && !isNaN(tick) && tick > 0) {
                    _this.next();
                }
                else {
                    _this.stop();
                }
            }, this.interval);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxCarousel.prototype, "loop", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxCarousel.prototype, "pause", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxCarousel.prototype, "interval", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxCarousel.prototype, "navigation", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCarousel.prototype, "onSlideChanged", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCarousel.prototype, "onSlideAdded", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCarousel.prototype, "onSlideRemoved", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCarousel.prototype, "onCarouselPaused", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCarousel.prototype, "onCarouselPlaying", void 0);
    IgxCarousel = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            host: {
                role: "region"
            },
            selector: "igx-carousel",
            styles: [__webpack_require__(92)],
            template: __webpack_require__(94)
        })
    ], IgxCarousel);
    return IgxCarousel;
}());
exports.IgxCarousel = IgxCarousel;
var IgxSlide = (function () {
    function IgxSlide(carousel) {
        this.carousel = carousel;
    }
    IgxSlide.prototype.ngOnInit = function () {
        this.carousel.add(this);
    };
    IgxSlide.prototype.ngOnDestroy = function () {
        this.carousel.remove(this);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSlide.prototype, "index", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSlide.prototype, "direction", void 0);
    __decorate([
        core_1.HostBinding("class.active"),
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSlide.prototype, "active", void 0);
    IgxSlide = __decorate([
        core_1.Component({
            selector: "igx-slide",
            template: __webpack_require__(95)
        }),
        __metadata("design:paramtypes", [IgxCarousel])
    ], IgxSlide);
    return IgxSlide;
}());
exports.IgxSlide = IgxSlide;
var IgxCarouselModule = (function () {
    function IgxCarouselModule() {
    }
    IgxCarouselModule = __decorate([
        core_1.NgModule({
            declarations: [IgxCarousel, IgxSlide],
            exports: [IgxCarousel, IgxSlide],
            imports: [common_1.CommonModule, icon_component_1.IgxIconModule]
        })
    ], IgxCarouselModule);
    return IgxCarouselModule;
}());
exports.IgxCarouselModule = IgxCarouselModule;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(93);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-carousel{display:flex;position:relative;justify-content:center;align-items:center;flex-flow:column nowrap;transform-style:preserve-3d;outline:none}.igx-carousel__inner{position:relative;width:100%;height:inherit;overflow:hidden}.igx-carousel__inner .active{display:block}.igx-carousel__arrow,.igx-carousel__arrow--next,.igx-carousel__arrow--prev{display:flex;margin:0 1em;position:absolute;justify-content:center;align-items:center;width:46px;height:46px;top:50%;transform:translateY(-50%);color:#fff;cursor:pointer;background-color:hsla(0,0%,100%,.3);border-radius:50%;box-shadow:0 1px 3px 0 rgba(0,0,0,.26),0 1px 1px 0 rgba(0,0,0,.12),0 2px 1px -1px rgba(0,0,0,.08);transition:opacity .25s ease-out}.igx-carousel__arrow--next span,.igx-carousel__arrow--prev span,.igx-carousel__arrow span{display:flex;align-items:center}.igx-carousel__arrow--next:hover,.igx-carousel__arrow--prev:hover{opacity:.7}.igx-carousel__arrow--next{right:0}.igx-carousel__arrow--prev{left:0}.igx-carousel__indicators{display:flex;margin:1em 0;justify-content:center;align-items:center;position:absolute;list-style:none;z-index:10;bottom:0;left:50%;transform:translateX(-50%);padding:0;opacity:.85}.igx-carousel__indicators li{margin:0 .3125em;position:relative;width:12px;height:12px;text-indent:-9999px;cursor:pointer;border:1px solid #fff;border-radius:50%;background-color:hsla(0,0%,100%,.2);transition:transform .25s cubic-bezier(.55,.085,.68,.53);box-shadow:0 1px 3px 0 rgba(0,0,0,.26),0 1px 1px 0 rgba(0,0,0,.12),0 2px 1px -1px rgba(0,0,0,.08)}.igx-carousel__indicators li:after{content:\"\";position:absolute;top:-1px;bottom:0;left:-1px;right:0;width:inherit;height:inherit;border-radius:inherit;background:#fff;transform:scale(0)}.igx-carousel__indicators li:hover{transform:scale(1.2)}.igx-carousel__indicators .active:after{animation:scale-in .3s cubic-bezier(.25,.46,.45,.94) forwards}.igx-slide{display:none;width:100%;height:100%;position:relative;transition:left .5s ease-in-out;backface-visibility:hidden;perspective:1000px}.igx-slide img{width:inherit;height:inherit;transform:scale(1.01)}@keyframes goUp{0%{transform:translateY(100%)}}@keyframes goDown{0%{transform:translateY(-100%)}}@keyframes goLeft{0%{transform:translateX(-100%)}}@keyframes goRight{0%{transform:translateX(100%)}}@keyframes scale-in{80%{transform:scale(1.2)}to{transform:scale(1)}}@keyframes fade{0%{opacity:.25}50%{opacity:1}to{opacity:0}}", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<div tabindex=\"0\" aria-label=\"carousel\" class=\"igx-carousel\"\n        (mouseenter)=\"stop()\"\n        (mouseleave)=\"play()\"\n        (swipeleft)=\"next()\"\n        (swiperight)=\"prev()\"\n        (keydown)=\"onKeydown($event)\"\n        (tap)=\"isPlaying ? stop() : play()\">\n    <ul class=\"igx-carousel__indicators\" [hidden]=\"slides.length <= 1\">\n        <li *ngFor=\"let slide of slides\" [attr.aria-label]=\"setAriaLabel(slide)\" [attr.aria-selected]=\"slide.active\" [class.active]=\"slide.active === true\"\n            (click)=\"select(slide)\"></li>\n    </ul>\n    <div class=\"igx-carousel__inner\" role=\"list\">\n        <ng-content></ng-content>\n    </div>\n    <div ng-template=\"ngIf navigation\">\n        <a role=\"button\" tabindex=\"0\" class=\"igx-carousel__arrow--prev\" (click)=\"prev()\" [hidden]=\"!slides.length\">\n            <igx-icon fontSet=\"material\" name=\"arrow_back\"></igx-icon>\n        </a>\n        <a role=\"button\" tabindex=\"0\" class=\"igx-carousel__arrow--next\" (click)=\"next()\" [hidden]=\"!slides.length\">\n            <igx-icon fontSet=\"material\" name=\"arrow_forward\"></igx-icon>\n        </a>\n    </div>\n</div>\n"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<div\n    role=\"listitem\"\n    [class.active]=\"active\"\n    class=\"igx-slide\"\n    [attr.aria-selected]=\"active\"\n    [attr.aria-live]=\"active ? 'polite' : null\"\n    [attr.tabIndex]=\"active ? 0 : null\"\n>\n    <ng-content></ng-content>\n</div>\n"

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var noop = function () { };
var nextId = 0;
var IgxCheckbox = (function () {
    function IgxCheckbox() {
        this.focused = false;
        this.id = "igx-checkbox-" + nextId++;
        this.disabled = false;
        this.tabindex = null;
        this.checked = false;
        this.change = new core_1.EventEmitter();
        this._onTouchedCallback = noop;
        this._onChangeCallback = noop;
    }
    IgxCheckbox_1 = IgxCheckbox;
    IgxCheckbox.prototype.onChange = function (event) {
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;
        this._onChangeCallback(this.checked);
        this.change.emit(event);
    };
    IgxCheckbox.prototype.onFocus = function (event) {
        this.focused = true;
    };
    IgxCheckbox.prototype.onBlur = function (event) {
        this.focused = false;
        this._onTouchedCallback();
    };
    IgxCheckbox.prototype.writeValue = function (value) {
        if (this.disabled) {
            return;
        }
        this._value = value;
        this.checked = !!this._value;
    };
    IgxCheckbox.prototype.registerOnChange = function (fn) { this._onChangeCallback = fn; };
    IgxCheckbox.prototype.registerOnTouched = function (fn) { this._onTouchedCallback = fn; };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxCheckbox.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxCheckbox.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxCheckbox.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxCheckbox.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCheckbox.prototype, "tabindex", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxCheckbox.prototype, "checked", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCheckbox.prototype, "change", void 0);
    __decorate([
        core_1.ViewChild("checkbox"),
        __metadata("design:type", Object)
    ], IgxCheckbox.prototype, "nativeCheckbox", void 0);
    IgxCheckbox = IgxCheckbox_1 = __decorate([
        core_1.Component({
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxCheckbox_1, multi: true }],
            selector: "igx-checkbox",
            styles: [__webpack_require__(97)],
            template: __webpack_require__(99)
        })
    ], IgxCheckbox);
    return IgxCheckbox;
    var IgxCheckbox_1;
}());
exports.IgxCheckbox = IgxCheckbox;
var IgxCheckboxModule = (function () {
    function IgxCheckboxModule() {
    }
    IgxCheckboxModule = __decorate([
        core_1.NgModule({
            declarations: [IgxCheckbox],
            exports: [IgxCheckbox]
        })
    ], IgxCheckboxModule);
    return IgxCheckboxModule;
}());
exports.IgxCheckboxModule = IgxCheckboxModule;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(98);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, "@keyframes scale-in-center{0%{transform:scale(0);opacity:1}to{transform:scale(1);opacity:1}}.igx-control__cbx~.igx-control__label{display:inline-block;position:relative;cursor:pointer;min-height:20px;line-height:20px;font-size:1em;font-weight:400;color:rgba(0,0,0,.87);padding-left:1.5em;user-select:none;-webkit-tap-highlight-color:transparent;overflow:hidden}.igx-control__cbx~.igx-control__label:after{position:absolute;content:\"\";top:0;left:0;border-radius:2px}.igx-control__cbx:checked~.igx-control__label:after,.igx-control__cbx:not(:checked)~.igx-control__label:after,.tick{width:20px;height:20px}.tick{position:absolute;top:0;left:0;padding:3px 2px 2px;stroke:none;stroke-linecap:round;stroke-width:3px;fill:none;z-index:1}.igx-control__cbx:checked~.igx-control__label .tick{animation:\"scale-in-center\" .3s cubic-bezier(.175,.885,.32,1.275) both;stroke:#fff}.igx-control__cbx:not(:checked)~.igx-control__label:after{border:2px solid rgba(0,0,0,.54)}.igx-control__cbx:checked~.igx-control__label:after{background-color:#e41c77;border:2px solid #e41c77}.igx-control__cbx:disabled~.igx-control__label{color:rgba(0,0,0,.38);pointer-events:none}.igx-control__cbx:disabled:checked~.igx-control__label:after{background-color:rgba(0,0,0,.38);border-color:rgba(0,0,0,.38)}.igx-control__cbx:disabled:not(:checked)~.igx-control__label:after{border-color:rgba(0,0,0,.38)}.igx-control{display:flex;align-items:center;justify-content:space-between;padding:8px 0}.igx-control__cbx{margin:0;position:absolute;opacity:0;z-index:-1;width:0;height:0;left:0;overflow:hidden;pointer-events:none}", ""]);

// exports


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-control\">\n    <input class=\"igx-control__cbx\" #checkbox type=\"checkbox\"\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [attr.tabindex]=\"tabindex\"\n        [attr.disabled]=\"disabled ? true : null\"\n        [checked]=\"checked\"\n        [attr.aria-checked]=\"checked\"\n        (change)=\"onChange($event)\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\">\n    <label class=\"igx-control__label\" [attr.for]=\"id\">\n        <svg class=\"tick\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path class=\"tick__mark\" d=\"M2 10.8l5 5L18.8 4\"/>\n            </g>\n        </svg>\n        <ng-content></ng-content>\n    </label>\n</div>"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var nextId = 0;
var noop = function () { };
var IgxRadio = (function () {
    function IgxRadio() {
        this.id = "igx-radio-" + nextId++;
        this.tabindex = null;
        this.change = new core_1.EventEmitter();
        this._onTouchedCallback = noop;
        this._onChangeCallback = noop;
    }
    IgxRadio_1 = IgxRadio;
    Object.defineProperty(IgxRadio.prototype, "checked", {
        get: function () {
            return this._checked;
        },
        set: function (value) {
            this._checked = value;
        },
        enumerable: true,
        configurable: true
    });
    IgxRadio.prototype.onChange = function (event) {
        this.select();
        this.change.emit(event);
    };
    IgxRadio.prototype.select = function () {
        this.checked = true;
        this._onChangeCallback(this.value);
    };
    IgxRadio.prototype.writeValue = function (value) {
        this._value = value;
        this.checked = (this._value === this.value);
    };
    IgxRadio.prototype.onFocus = function (event) {
        this.focused = true;
    };
    IgxRadio.prototype.onBlur = function (event) {
        this.focused = false;
        this._onTouchedCallback();
    };
    IgxRadio.prototype.registerOnChange = function (fn) { this._onChangeCallback = fn; };
    IgxRadio.prototype.registerOnTouched = function (fn) { this._onTouchedCallback = fn; };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxRadio.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxRadio.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxRadio.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxRadio.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxRadio.prototype, "tabindex", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], IgxRadio.prototype, "change", void 0);
    __decorate([
        core_1.ViewChild("radio"),
        __metadata("design:type", Object)
    ], IgxRadio.prototype, "nativeRadio", void 0);
    IgxRadio = IgxRadio_1 = __decorate([
        core_1.Component({
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxRadio_1, multi: true }],
            selector: "igx-radio",
            styles: [__webpack_require__(101)],
            template: __webpack_require__(103)
        })
    ], IgxRadio);
    return IgxRadio;
    var IgxRadio_1;
}());
exports.IgxRadio = IgxRadio;
var IgxRadioModule = (function () {
    function IgxRadioModule() {
    }
    IgxRadioModule = __decorate([
        core_1.NgModule({
            declarations: [IgxRadio],
            exports: [IgxRadio]
        })
    ], IgxRadioModule);
    return IgxRadioModule;
}());
exports.IgxRadioModule = IgxRadioModule;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(102);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-control__radio~.igx-control__label{display:inline-block;position:relative;cursor:pointer;height:20px;line-height:20px;font-size:1em;color:rgba(0,0,0,.87);padding-left:1.5em;user-select:none}.igx-control__radio~.igx-control__label:after,.igx-control__radio~.igx-control__label:before{position:absolute;content:\"\";width:20px;height:20px;left:0;border-radius:50% 50%}.igx-control__radio~.igx-control__label:before{backface-visibility:hidden;transform:translateZ(0);transition:all .2s ease-in}.igx-control__radio:not(:checked)~.igx-control__label:before{transform:scale3d(0,0,0)}.igx-control__radio:not(:checked)~.igx-control__label:after{border:2px solid rgba(0,0,0,.54)}.igx-control__radio:checked~.igx-control__label:before{border:2px solid #e41c77;background-color:#e41c77;transform:scale3d(.5,.5,.5)}.igx-control__radio:checked~.igx-control__label:after{border:2px solid #e41c77}.igx-control__radio:disabled~.igx-control__label{pointer-events:none;color:rgba(0,0,0,.38)}.igx-control__radio:disabled:not(:checked)~.igx-control__label:after{border:2px solid rgba(0,0,0,.38)}.igx-control__radio:disabled:checked~.igx-control__label:before{background-color:rgba(0,0,0,.38);border:2px solid transparent}.igx-control__radio:disabled:checked~.igx-control__label:after{border:2px solid rgba(0,0,0,.38)}.igx-control{display:flex;align-items:center;justify-content:space-between;padding:8px 0}.igx-control__radio{margin:0;position:absolute;opacity:0;z-index:-1;width:0;height:0;left:0;overflow:hidden;pointer-events:none}", ""]);

// exports


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-control\">\n    <input class=\"igx-control__radio\" type=\"radio\" #radio\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [attr.tabindex]=\"tabindex\"\n        [attr.aria-checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [checked]=\"checked\"\n        (change)=\"onChange($event)\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"/>\n    <label class =\"igx-control__label\" [attr.for]=\"id\"><ng-content></ng-content></label>\n</div>"

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxLabel = (function () {
    function IgxLabel(el, renderer) {
        renderer.addClass(el.nativeElement, "igx-form-group__label");
    }
    IgxLabel = __decorate([
        core_1.Directive({
            selector: "[igxLabel]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxLabel);
    return IgxLabel;
}());
exports.IgxLabel = IgxLabel;
var IgxLabelModule = (function () {
    function IgxLabelModule() {
    }
    IgxLabelModule = __decorate([
        core_1.NgModule({
            declarations: [IgxLabel],
            exports: [IgxLabel]
        })
    ], IgxLabelModule);
    return IgxLabelModule;
}());
exports.IgxLabelModule = IgxLabelModule;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var noop = function () { };
var nextId = 0;
var IgxSwitch = (function () {
    function IgxSwitch() {
        this.id = "igx-switch-" + nextId++;
        this.disabled = false;
        this.tabindex = null;
        this.checked = false;
        this.change = new core_1.EventEmitter();
        this.focused = false;
        this._onTouchedCallback = noop;
        this._onChangeCallback = noop;
    }
    IgxSwitch_1 = IgxSwitch;
    Object.defineProperty(IgxSwitch.prototype, "labelId", {
        get: function () {
            return this.id + "_label";
        },
        enumerable: true,
        configurable: true
    });
    IgxSwitch.prototype.onChange = function (event) {
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;
        this._onChangeCallback(this.checked);
        this.change.emit(event);
    };
    IgxSwitch.prototype.onFocus = function (event) {
        this.focused = true;
    };
    IgxSwitch.prototype.onBlur = function (event) {
        this.focused = false;
        this._onTouchedCallback();
    };
    IgxSwitch.prototype.writeValue = function (value) {
        if (this.disabled) {
            return;
        }
        this._value = value;
        this.checked = this._value;
    };
    IgxSwitch.prototype.registerOnChange = function (fn) { this._onChangeCallback = fn; };
    IgxSwitch.prototype.registerOnTouched = function (fn) { this._onTouchedCallback = fn; };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxSwitch.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxSwitch.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxSwitch.prototype, "labelId", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxSwitch.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSwitch.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSwitch.prototype, "tabindex", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSwitch.prototype, "checked", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxSwitch.prototype, "change", void 0);
    __decorate([
        core_1.ViewChild("checkbox"),
        __metadata("design:type", Object)
    ], IgxSwitch.prototype, "nativeCheckbox", void 0);
    IgxSwitch = IgxSwitch_1 = __decorate([
        core_1.Component({
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxSwitch_1, multi: true }],
            selector: "igx-switch",
            styles: [__webpack_require__(106)],
            template: __webpack_require__(108)
        })
    ], IgxSwitch);
    return IgxSwitch;
    var IgxSwitch_1;
}());
exports.IgxSwitch = IgxSwitch;
var IgxSwitchModule = (function () {
    function IgxSwitchModule() {
    }
    IgxSwitchModule = __decorate([
        core_1.NgModule({
            declarations: [IgxSwitch],
            exports: [IgxSwitch]
        })
    ], IgxSwitchModule);
    return IgxSwitchModule;
}());
exports.IgxSwitchModule = IgxSwitchModule;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(107);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-control__switch~.igx-control__label{display:inline-block;position:relative;width:35px;height:14px;background-color:rgba(0,0,0,.54);color:transparent;border-radius:100px;cursor:pointer;transition:all .2s ease-in;user-select:none}.igx-control__switch~.igx-control__label:after{display:block;position:absolute;content:\"\";width:20px;height:20px;top:-3px;left:-1px;border-radius:100px;background:#fff;box-shadow:0 1px 3px 0 rgba(0,0,0,.26),0 1px 1px 0 rgba(0,0,0,.12),0 2px 1px -1px rgba(0,0,0,.08);transition:all .2s ease-in}.igx-control__switch:checked~.igx-control__label{background-color:rgba(228,28,119,.5)}.igx-control__switch:checked~.igx-control__label:after{left:16px;background:#e41c77}.igx-control__switch:disabled~.igx-control__label{background:rgba(0,0,0,.04);pointer-events:none}.igx-control__switch:disabled~.igx-control__label:after{background:rgba(0,0,0,.26);box-shadow:0 1px 3px 0 rgba(0,0,0,.26),0 1px 1px 0 rgba(0,0,0,.12),0 2px 1px -1px rgba(0,0,0,.08)}.igx-control{display:flex;align-items:center;justify-content:space-between;padding:8px 0}.igx-control__switch{margin:0;position:absolute;opacity:0;z-index:-1;width:0;height:0;left:0;overflow:hidden;pointer-events:none}.igx-control__switch-text{padding-right:1em}", ""]);

// exports


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-control\">\n    <input class=\"igx-control__switch\" #checkbox type=\"checkbox\" role=\"checkbox\"\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [attr.tabindex]=\"tabindex\"\n        [disabled]=\"disabled\"\n        [checked]=\"checked\"\n        [attr.aria-checked]=\"checked\"\n        [attr.aria-labelledby]=\"labelId\"\n        (change)=\"onChange($event)\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\">\n    <span class=\"igx-control__text\" [attr.id]=\"labelId\"><ng-content></ng-content>\n    </span>\n    <label class =\"igx-control__label\" [attr.for]=\"id\"></label>\n</div>"

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var icon_component_1 = __webpack_require__(4);
var Size;
(function (Size) {
    Size[Size["SMALL"] = 0] = "SMALL";
    Size[Size["MEDIUM"] = 1] = "MEDIUM";
    Size[Size["LARGE"] = 2] = "LARGE";
})(Size = exports.Size || (exports.Size = {}));
var IgxAvatar = (function () {
    function IgxAvatar(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.roundShape = "false";
        this.color = "white";
        this.sizeEnum = Size;
        this.fontName = "Titillium Web";
        this._icon = "android";
        this._addEventListeners(renderer);
    }
    Object.defineProperty(IgxAvatar.prototype, "size", {
        get: function () {
            return this._size === undefined ? "small" : this._size;
        },
        set: function (value) {
            var sizeType = this.sizeEnum[value.toUpperCase()];
            this._size = sizeType === undefined ? "small" : value.toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxAvatar.prototype, "bgColor", {
        get: function () {
            return this._bgColor;
        },
        set: function (value) {
            var color = value === "" ? "lightgrey" : value;
            this._bgColor = color;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxAvatar.prototype, "srcImage", {
        get: function () {
            return this.image ? this.image.nativeElement.src : "";
        },
        set: function (value) {
            this.image.nativeElement.src = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxAvatar.prototype, "isRounded", {
        get: function () {
            return this.roundShape.toUpperCase() === "TRUE" ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxAvatar.prototype, "icon", {
        get: function () {
            return this._icon;
        },
        set: function (value) {
            this._icon = value;
        },
        enumerable: true,
        configurable: true
    });
    IgxAvatar.prototype.ngAfterViewInit = function () {
        if (this.initials && this.image) {
            var src = this.generateInitials(parseInt(this.image.nativeElement.width, 10));
            this.image.nativeElement.src = src;
        }
    };
    IgxAvatar.prototype.ngAfterContentChecked = function () {
        this.roleDescription = this.getRole();
    };
    IgxAvatar.prototype.getRole = function () {
        if (this.initials) {
            return "initials type avatar";
        }
        else if (this.src) {
            return "image type avatar";
        }
        else {
            return "icon type avatar";
        }
    };
    IgxAvatar.prototype.generateInitials = function (size) {
        var canvas = document.createElement("canvas");
        var fontSize = size / 2;
        var ctx;
        canvas.width = size;
        canvas.height = size;
        ctx = canvas.getContext("2d");
        ctx.fillStyle = this.bgColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.textAlign = "center";
        ctx.fillStyle = this.color;
        ctx.font = fontSize + ("px " + this.fontName);
        ctx.fillText(this.initials.toUpperCase(), size / 2, size - size / 2 + fontSize / 3);
        return canvas.toDataURL("image/png");
    };
    IgxAvatar.prototype._addEventListeners = function (renderer) { };
    __decorate([
        core_1.ViewChild("image"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxAvatar.prototype, "image", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxAvatar.prototype, "initials", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxAvatar.prototype, "src", void 0);
    __decorate([
        core_1.Input("roundShape"),
        __metadata("design:type", String)
    ], IgxAvatar.prototype, "roundShape", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxAvatar.prototype, "color", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxAvatar.prototype, "size", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxAvatar.prototype, "bgColor", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], IgxAvatar.prototype, "icon", null);
    IgxAvatar = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-avatar",
            styles: [__webpack_require__(110)],
            template: __webpack_require__(112)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxAvatar);
    return IgxAvatar;
}());
exports.IgxAvatar = IgxAvatar;
var IgxAvatarModule = (function () {
    function IgxAvatarModule() {
    }
    IgxAvatarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxAvatar],
            exports: [IgxAvatar],
            imports: [common_1.CommonModule, icon_component_1.IgxIconModule]
        })
    ], IgxAvatarModule);
    return IgxAvatarModule;
}());
exports.IgxAvatarModule = IgxAvatarModule;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(111);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-avatar,.igx-avatar--icon,.igx-avatar--image,.igx-avatar--large,.igx-avatar--medium,.igx-avatar--rounded,.igx-avatar--small{display:flex;justify-content:center;align-items:center;position:relative;pointer-events:none}.igx-avatar--rounded{border-radius:50%}.igx-avatar--small{width:2.5em;height:2.5em}.igx-avatar--medium{width:4em;height:4em}.igx-avatar--large{width:5.5em;height:5.5em}.igx-avatar--icon{background-color:rgba(0,0,0,.26)}.igx-avatar--image{background-color:transparent!important}", ""]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-avatar igx-avatar--{{size}}\" aria-label=\"avatar\" role=\"img\">\n    <img #image *ngIf=\"src || initials\" src=\"{{src}}\" class=\"igx-avatar--image igx-avatar--{{size}}\" [class.igx-avatar--rounded]=\"isRounded\"\n        [style.backgroundColor]=\"bgColor\" [attr.aria-roledescription]=\"roleDescription\" />\n    <span *ngIf=\"!src && !initials\" class=\"igx-avatar--{{size}} igx-avatar--icon\" [class.igx-avatar--rounded]=\"isRounded\" [style.backgroundColor]=\"bgColor\"\n        [style.color]=\"color\" [attr.aria-roledescription]=\"roleDescription\">\n        <igx-icon fontSet=\"material\" [name]=\"icon\"></igx-icon>\n    </span>\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var IgxLayoutDirective = (function () {
    function IgxLayoutDirective() {
        this.dir = "row";
        this.reverse = false;
        this.wrap = "nowrap";
        this.justify = "flex-start";
        this.itemAlign = "flex-start";
        this.display = "flex";
    }
    Object.defineProperty(IgxLayoutDirective.prototype, "flexwrap", {
        get: function () { return this.wrap; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxLayoutDirective.prototype, "justifycontent", {
        get: function () { return this.justify; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxLayoutDirective.prototype, "align", {
        get: function () { return this.itemAlign; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxLayoutDirective.prototype, "direction", {
        get: function () {
            if (this.reverse) {
                return (this.dir === "row") ? "row-reverse" : "column-reverse";
            }
            return (this.dir === "row") ? "row" : "column";
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input("igxLayoutDir"),
        __metadata("design:type", String)
    ], IgxLayoutDirective.prototype, "dir", void 0);
    __decorate([
        core_1.Input("igxLayoutReverse"),
        __metadata("design:type", Boolean)
    ], IgxLayoutDirective.prototype, "reverse", void 0);
    __decorate([
        core_1.Input("igxLayoutWrap"),
        __metadata("design:type", String)
    ], IgxLayoutDirective.prototype, "wrap", void 0);
    __decorate([
        core_1.Input("igxLayoutJustify"),
        __metadata("design:type", String)
    ], IgxLayoutDirective.prototype, "justify", void 0);
    __decorate([
        core_1.Input("igxLayoutItemAlign"),
        __metadata("design:type", String)
    ], IgxLayoutDirective.prototype, "itemAlign", void 0);
    __decorate([
        core_1.HostBinding("style.display"),
        __metadata("design:type", Object)
    ], IgxLayoutDirective.prototype, "display", void 0);
    __decorate([
        core_1.HostBinding("style.flex-wrap"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxLayoutDirective.prototype, "flexwrap", null);
    __decorate([
        core_1.HostBinding("style.justify-content"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxLayoutDirective.prototype, "justifycontent", null);
    __decorate([
        core_1.HostBinding("style.align-items"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxLayoutDirective.prototype, "align", null);
    __decorate([
        core_1.HostBinding("style.flex-direction"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxLayoutDirective.prototype, "direction", null);
    IgxLayoutDirective = __decorate([
        core_1.Directive({
            selector: "[igxLayout]"
        })
    ], IgxLayoutDirective);
    return IgxLayoutDirective;
}());
exports.IgxLayoutDirective = IgxLayoutDirective;
var IgxFlexDirective = (function () {
    function IgxFlexDirective() {
        this.grow = 1;
        this.shrink = 1;
        this.flex = "";
        this.order = 0;
    }
    Object.defineProperty(IgxFlexDirective.prototype, "style", {
        get: function () {
            if (this.flex) {
                return "" + this.flex;
            }
            return this.grow + " " + this.shrink + " auto";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxFlexDirective.prototype, "itemorder", {
        get: function () {
            return this.order || 0;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input("igxFlexGrow"),
        __metadata("design:type", Number)
    ], IgxFlexDirective.prototype, "grow", void 0);
    __decorate([
        core_1.Input("igxFlexShrink"),
        __metadata("design:type", Number)
    ], IgxFlexDirective.prototype, "shrink", void 0);
    __decorate([
        core_1.Input("igxFlex"),
        __metadata("design:type", String)
    ], IgxFlexDirective.prototype, "flex", void 0);
    __decorate([
        core_1.Input("igxFlexOrder"),
        __metadata("design:type", Number)
    ], IgxFlexDirective.prototype, "order", void 0);
    __decorate([
        core_1.HostBinding("style.flex"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxFlexDirective.prototype, "style", null);
    __decorate([
        core_1.HostBinding("style.order"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxFlexDirective.prototype, "itemorder", null);
    IgxFlexDirective = __decorate([
        core_1.Directive({
            selector: "[igxFlex]"
        })
    ], IgxFlexDirective);
    return IgxFlexDirective;
}());
exports.IgxFlexDirective = IgxFlexDirective;
var IgxLayout = (function () {
    function IgxLayout() {
    }
    IgxLayout = __decorate([
        core_1.NgModule({
            declarations: [IgxLayoutDirective, IgxFlexDirective],
            exports: [IgxFlexDirective, IgxLayoutDirective]
        })
    ], IgxLayout);
    return IgxLayout;
}());
exports.IgxLayout = IgxLayout;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var BaseProgress = (function () {
    function BaseProgress() {
    }
    Object.defineProperty(BaseProgress.prototype, "valueInPercent", {
        get: function () {
            return this._valueInPercent;
        },
        enumerable: true,
        configurable: true
    });
    BaseProgress.prototype.getValue = function () {
        return getValueInRange(this.value, this.max);
    };
    BaseProgress.prototype.getPercentValue = function () {
        return convertValueInPercent(this.getValue(), this.max);
    };
    BaseProgress.prototype.instantiateValAnimation = function (prevVal, currVal, max) {
        var validatePrevValue = getValueInRange(prevVal, max) || 0;
        var validateCurrValue = getValueInRange(currVal, max) || 0;
        this._valueInPercent = convertValueInPercent(validatePrevValue, max);
        this._prevValue = convertValueInPercent(validatePrevValue, max);
        this._currValue = convertValueInPercent(validateCurrValue, max);
    };
    BaseProgress.prototype.startAnimation = function (interval, circular, percentage) {
        if (circular === void 0) { circular = null; }
        if (percentage === void 0) { percentage = 0; }
        var timer = setInterval(function animateBar() {
            if (this._valueInPercent >= this._currValue) {
                clearInterval(timer);
                var changedValues = {
                    currentValue: this._currValue,
                    previousValue: this._prevValue
                };
                this.onProgressChanged.emit(changedValues);
                if (circular) {
                    this.renderer.setStyle(circular.nativeElement, "strokeDashoffset", percentage);
                }
            }
            else {
                this._valueInPercent++;
            }
        }.bind(this), interval);
    };
    return BaseProgress;
}());
exports.BaseProgress = BaseProgress;
var IgxLinearProgressBar = (function (_super) {
    __extends(IgxLinearProgressBar, _super);
    function IgxLinearProgressBar(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.max = 100;
        _this.striped = false;
        _this.type = "default";
        _this.value = 0;
        _this.onProgressChanged = new core_1.EventEmitter();
        _this._valueInPercent = 0;
        _this._interval = 15;
        return _this;
    }
    IgxLinearProgressBar.prototype.ngOnChanges = function (changes) {
        if (this._linearBar) {
            if (changes.value) {
                _super.prototype.instantiateValAnimation.call(this, changes.value.previousValue, changes.value.currentValue, this.max);
                _super.prototype.startAnimation.call(this, this._interval);
            }
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxLinearProgressBar.prototype, "max", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxLinearProgressBar.prototype, "striped", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxLinearProgressBar.prototype, "type", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxLinearProgressBar.prototype, "value", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxLinearProgressBar.prototype, "onProgressChanged", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxLinearProgressBar.prototype, "_valueInPercent", void 0);
    __decorate([
        core_1.ViewChild("linearBar"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxLinearProgressBar.prototype, "_linearBar", void 0);
    IgxLinearProgressBar = __decorate([
        core_1.Component({
            selector: "igx-linear-bar",
            styles: [__webpack_require__(32)],
            template: __webpack_require__(116)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxLinearProgressBar);
    return IgxLinearProgressBar;
}(BaseProgress));
exports.IgxLinearProgressBar = IgxLinearProgressBar;
var IgxCircularProgressBar = (function (_super) {
    __extends(IgxCircularProgressBar, _super);
    function IgxCircularProgressBar(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.max = 100;
        _this.value = 0;
        _this.onProgressChanged = new core_1.EventEmitter();
        _this._valueInPercent = 0;
        _this._radius = 0;
        _this._circumference = 289;
        _this._interval = 15;
        _this._percentage = 0;
        _this._progress = 0;
        return _this;
    }
    IgxCircularProgressBar.prototype.ngOnChanges = function (changes) {
        if (this._svgCircle) {
            this._percentage = getValueInRange(_super.prototype.getPercentValue.call(this), 100);
            if (changes.value) {
                _super.prototype.instantiateValAnimation.call(this, changes.value.previousValue, changes.value.currentValue, this.max);
                _super.prototype.startAnimation.call(this, this._interval, this._svgCircle, this._percentage);
                var FRAMES = [{
                        strokeDashoffset: this.getProgress(this._prevValue),
                        strokeOpacity: (this._prevValue / 100) + .2
                    }, {
                        strokeDashoffset: this.getProgress(this._percentage),
                        strokeOpacity: (this._percentage / 100) + .2
                    }];
                this._svgCircle.nativeElement.animate(FRAMES, {
                    duration: (this._percentage * this._interval) + 400,
                    easing: "ease-out",
                    fill: "forwards"
                });
            }
        }
    };
    IgxCircularProgressBar.prototype.ngAfterViewInit = function () {
        if (this._svgCircle) {
            this._radius = parseInt(this._svgCircle.nativeElement.getAttribute("r"), 10);
            this._circumference = 2 * Math.PI * this._radius;
        }
    };
    IgxCircularProgressBar.prototype.getProgress = function (percentage) {
        return this._circumference - (percentage * this._circumference / 100);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCircularProgressBar.prototype, "max", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCircularProgressBar.prototype, "value", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxCircularProgressBar.prototype, "onProgressChanged", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxCircularProgressBar.prototype, "_valueInPercent", void 0);
    __decorate([
        core_1.ViewChild("circle"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxCircularProgressBar.prototype, "_svgCircle", void 0);
    __decorate([
        core_1.ViewChild("text"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxCircularProgressBar.prototype, "_svgText", void 0);
    IgxCircularProgressBar = __decorate([
        core_1.Component({
            selector: "igx-circular-bar",
            styles: [__webpack_require__(32)],
            template: __webpack_require__(117)
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxCircularProgressBar);
    return IgxCircularProgressBar;
}(BaseProgress));
exports.IgxCircularProgressBar = IgxCircularProgressBar;
function getValueInRange(value, max, min) {
    if (min === void 0) { min = 0; }
    return Math.max(Math.min(value, max), min);
}
exports.getValueInRange = getValueInRange;
function convertValueInPercent(value, max) {
    return Math.floor(100 * value / max);
}
exports.convertValueInPercent = convertValueInPercent;
var IgxProgressBarModule = (function () {
    function IgxProgressBarModule() {
    }
    IgxProgressBarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxLinearProgressBar, IgxCircularProgressBar],
            exports: [IgxLinearProgressBar, IgxCircularProgressBar],
            imports: [common_1.CommonModule]
        })
    ], IgxProgressBarModule);
    return IgxProgressBarModule;
}());
exports.IgxProgressBarModule = IgxProgressBarModule;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".progress-linear{display:flex;position:relative;align-items:center;justify-content:flex-start;flex-flow:column nowrap;width:100%;height:5px;margin-bottom:32px;background:rgba(3,117,190,.1)}.progress-linear__bar,.progress-linear__bar--danger,.progress-linear__bar--default,.progress-linear__bar--info,.progress-linear__bar--success,.progress-linear__bar--warning{width:inherit;height:inherit;align-self:flex-start}.progress-linear--striped>div{background-image:linear-gradient(45deg,hsla(0,0%,100%,.5) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,.5) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-linear__value{margin:10px 5px;position:absolute;color:rgba(0,0,0,.74);font-size:.875em;align-self:flex-start;font-weight:600}.progress-linear__bar--default{background-color:#0375be}.progress-linear__bar--danger{background-color:#f44336}.progress-linear__bar--warning{background-color:#fbb13c}.progress-linear__bar--info{background-color:#e41c77}.progress-linear__bar--success{background-color:#4caf50}.progress-circular{width:100%;height:100%}.progress-circular__innercircle{stroke-width:4;fill:transparent;stroke:#0375be;stroke-opacity:.1}.progress-circular__circle{fill:transparent;stroke:url(\"#linear\");stroke-width:6;stroke-linecap:round;stroke-dashoffset:289;stroke-dasharray:289;transform-origin:50% 50%;transform:rotate(-90deg)}.progress-circular__text{font-family:Titillium Web,sans-serif;font-size:2em;fill:rgba(0,0,0,.74)}", ""]);

// exports


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "<div class=\"progress-linear\"\n    [class.progress-linear--striped]=\"striped\">\n    <div #linearBar role=\"progressbar\" class=\"progress-linear__bar{{type ? '--' + type : ''}}\"\n        aria-valuemin=\"0\"\n        [attr.aria-valuemax]=\"max\"\n        [attr.aria-valuenow]=\"getValue()\"\n        [style.width.%]=\"valueInPercent || getPercentValue()\">\n        <ng-content></ng-content>\n    </div>\n    <span class=\"progress-linear__value\">{{valueInPercent || getPercentValue()}}%</span>\n</div>\n"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "<svg #svg class=\"progress-circular\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"none\"\n    role=\"progressbar\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuemax]=\"max\"\n    [attr.aria-valuenow]=\"getValue()\">\n    <defs>\n        <linearGradient id=\"linear\" x1=\"-10%\" y1=\"0%\" x2=\"50%\" y2=\"150%\">\n        <stop offset=\"0%\"   stop-color=\"#0375BE\"/>\n        <stop offset=\"100%\" stop-color=\"cyan\"/>\n        </linearGradient>\n    </defs>\n    <circle class=\"progress-circular__innercircle\" cx=\"50\" cy=\"50\" r=\"46\"/>\n    <circle #circle class=\"progress-circular__circle\" cx=\"50\" cy=\"50\" r=\"46\"/>\n    <text #text class=\"progress-circular__text\" id=\"myTimer\" text-anchor=\"middle\" x=\"50\" y=\"60\">{{valueInPercent}}%</text>\n</svg>\n"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var button_directive_1 = __webpack_require__(6);
var icon_component_1 = __webpack_require__(4);
var IgxNavbar = (function () {
    function IgxNavbar() {
        this.isActionButtonVisible = false;
        this.onAction = new core_1.EventEmitter();
    }
    IgxNavbar_1 = IgxNavbar;
    IgxNavbar.prototype.ngAfterContentChecked = function () {
        this._titleId = "igx-navbar-" + IgxNavbar_1.NEXT_ID++;
    };
    Object.defineProperty(IgxNavbar.prototype, "titleId", {
        get: function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    IgxNavbar.prototype._triggerAction = function () {
        this.onAction.emit(this);
    };
    IgxNavbar.NEXT_ID = 1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxNavbar.prototype, "isActionButtonVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxNavbar.prototype, "actionButtonIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxNavbar.prototype, "title", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxNavbar.prototype, "onAction", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IgxNavbar.prototype, "titleId", null);
    IgxNavbar = IgxNavbar_1 = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-navbar",
            styles: [__webpack_require__(119)],
            template: __webpack_require__(121)
        })
    ], IgxNavbar);
    return IgxNavbar;
    var IgxNavbar_1;
}());
exports.IgxNavbar = IgxNavbar;
var IgxNavbarModule = (function () {
    function IgxNavbarModule() {
    }
    IgxNavbarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxNavbar],
            exports: [IgxNavbar],
            imports: [button_directive_1.IgxButtonModule, icon_component_1.IgxIconModule, common_1.CommonModule]
        })
    ], IgxNavbarModule);
    return IgxNavbarModule;
}());
exports.IgxNavbarModule = IgxNavbarModule;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(120);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-navbar{position:relative;flex-flow:row nowrap;justify-content:space-between;width:100%;height:56px;padding:0 1em;background:#0375be;color:#fff;box-shadow:0 2px 4px -1px rgba(0,0,0,.26),0 4px 5px 0 rgba(0,0,0,.12),0 1px 10px 0 rgba(0,0,0,.08);z-index:4}.igx-navbar,.igx-navbar__left,.igx-navbar__right{display:flex;align-items:center}.igx-navbar__left *+*,.igx-navbar__right *+*{margin-left:16px}.igx-navbar__title{margin:0;font-size:1.125em;line-height:1.125em}", ""]);

// exports


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"igx-navbar\" role=”navigation” [attr.aria-labelledby]=\"titleId\">\n    <div class=\"igx-navbar__left\">\n        <span class=\"igx-navbar__left-btn\" *ngIf=\"!isActionButtonVisible\">\n            <button igxButton=\"navbar\" (click)=\"_triggerAction()\">\n                <igx-icon fontSet=\"material\" [name]=\"actionButtonIcon\"></igx-icon>\n            </button>\n        </span>\n        <span>\n            <h1 class=\"igx-navbar__title\" [attr.id]=\"titleId\">{{ title }}</h1>\n        </span>\n    </div>\n    <div class=\"igx-navbar__right\">\n        <ng-content></ng-content>\n    </div>\n</nav>"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var IgxFilterDirective = (function () {
    function IgxFilterDirective(element, renderer) {
        this.element = element;
        this.filtering = new core_1.EventEmitter(false);
        this.filtered = new core_1.EventEmitter();
    }
    IgxFilterDirective.prototype.ngOnChanges = function (changes) {
        if (changes.filterOptions &&
            changes.filterOptions.currentValue &&
            changes.filterOptions.currentValue.inputValue !== undefined &&
            changes.filterOptions.previousValue &&
            changes.filterOptions.currentValue.inputValue !== changes.filterOptions.previousValue.inputValue) {
            this.filter();
        }
    };
    IgxFilterDirective.prototype.filter = function () {
        if (!this.filterOptions.items) {
            return;
        }
        var args = { cancel: false, items: this.filterOptions.items };
        this.filtering.emit(args);
        if (args.cancel) {
            return;
        }
        var pipe = new IgxFilterPipe();
        var filtered = pipe.transform(this.filterOptions.items, this.filterOptions);
        this.filtered.emit({ filteredItems: filtered });
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxFilterDirective.prototype, "filtering", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxFilterDirective.prototype, "filtered", void 0);
    __decorate([
        core_1.Input("igxFilter"),
        __metadata("design:type", IgxFilterOptions)
    ], IgxFilterDirective.prototype, "filterOptions", void 0);
    IgxFilterDirective = __decorate([
        core_1.Directive({
            selector: "[igxFilter]"
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
    ], IgxFilterDirective);
    return IgxFilterDirective;
}());
exports.IgxFilterDirective = IgxFilterDirective;
var IgxFilterPipe = (function () {
    function IgxFilterPipe() {
    }
    IgxFilterPipe.prototype.transform = function (items, options) {
        var result = [];
        if (!items || !items.length || !options) {
            return;
        }
        if (options.items) {
            items = options.items;
        }
        result = items.filter(function (item) {
            var match = options.matchFn(options.formatter(options.get_value(item, options.key)), options.inputValue);
            if (match) {
                if (options.metConditionFn) {
                    options.metConditionFn(item);
                }
            }
            else {
                if (options.overdueConditionFn) {
                    options.overdueConditionFn(item);
                }
            }
            return match;
        });
        return result;
    };
    IgxFilterPipe = __decorate([
        core_1.Pipe({
            name: "igxFilter",
            pure: false
        })
    ], IgxFilterPipe);
    return IgxFilterPipe;
}());
exports.IgxFilterPipe = IgxFilterPipe;
var IgxFilterOptions = (function () {
    function IgxFilterOptions() {
        this.inputValue = "";
    }
    IgxFilterOptions.prototype.get_value = function (item, key) {
        var result = "";
        if (key) {
            result = item[key].toString();
        }
        else if (item.element && item.element.nativeElement) {
            result = item.element.nativeElement.textContent.trim();
        }
        return result;
    };
    IgxFilterOptions.prototype.formatter = function (valueToTest) {
        return valueToTest.toLowerCase();
    };
    IgxFilterOptions.prototype.matchFn = function (valueToTest, inputValue) {
        return valueToTest.indexOf(inputValue && inputValue.toLowerCase() || "") > -1;
    };
    IgxFilterOptions.prototype.metConditionFn = function (item) {
        if (item.hasOwnProperty("hidden")) {
            item.hidden = false;
        }
    };
    IgxFilterOptions.prototype.overdueConditionFn = function (item) {
        if (item.hasOwnProperty("hidden")) {
            item.hidden = true;
        }
    };
    return IgxFilterOptions;
}());
exports.IgxFilterOptions = IgxFilterOptions;
var IgxFilterModule = (function () {
    function IgxFilterModule() {
    }
    IgxFilterModule = __decorate([
        core_1.NgModule({
            declarations: [IgxFilterDirective, IgxFilterPipe],
            exports: [IgxFilterDirective, IgxFilterPipe],
            imports: [common_1.CommonModule]
        })
    ], IgxFilterModule);
    return IgxFilterModule;
}());
exports.IgxFilterModule = IgxFilterModule;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var main_1 = __webpack_require__(15);
var IgxSnackbar = (function () {
    function IgxSnackbar(zone) {
        this.zone = zone;
        this.isVisible = false;
        this.autoHide = true;
        this.displayTime = 4000;
        this.onAction = new core_1.EventEmitter();
        this.animationStarted = new core_1.EventEmitter();
        this.animationDone = new core_1.EventEmitter();
    }
    IgxSnackbar.prototype.show = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        setTimeout(this.timeoutId);
        this.isVisible = true;
        if (this.autoHide) {
            this.timeoutId = setTimeout(function () {
                _this.hide();
            }, this.displayTime);
        }
    };
    IgxSnackbar.prototype.hide = function () {
        this.isVisible = false;
        clearTimeout(this.timeoutId);
    };
    IgxSnackbar.prototype.triggerAction = function () {
        this.onAction.emit(this);
    };
    IgxSnackbar.prototype.snackbarAnimationStarted = function (evt) {
        if (evt.fromState === "void") {
            this.animationStarted.emit(evt);
        }
    };
    IgxSnackbar.prototype.snackbarAnimationDone = function (evt) {
        if (evt.fromState === "show") {
            this.animationDone.emit(evt);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxSnackbar.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSnackbar.prototype, "isVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSnackbar.prototype, "autoHide", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSnackbar.prototype, "displayTime", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxSnackbar.prototype, "actionText", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxSnackbar.prototype, "onAction", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxSnackbar.prototype, "animationStarted", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxSnackbar.prototype, "animationDone", void 0);
    IgxSnackbar = __decorate([
        core_1.Component({
            animations: [
                animations_1.trigger("slideInOut", [
                    animations_1.transition("void => *", [
                        animations_1.useAnimation(main_1.slideInBottom, {
                            params: {
                                duration: ".35s",
                                easing: "cubic-bezier(0.0, 0.0, 0.2, 1)",
                                fromPosition: "translateY(100%)",
                                toPosition: "translateY(0)"
                            }
                        })
                    ]),
                    animations_1.transition("* => void", [
                        animations_1.useAnimation(main_1.slideOutBottom, {
                            params: {
                                duration: ".2s",
                                easing: "cubic-bezier(0.4, 0.0, 1, 1)",
                                fromPosition: "translateY(0)",
                                toOpacity: 1,
                                toPosition: "translateY(100%)"
                            }
                        })
                    ])
                ]),
                animations_1.trigger("fadeInOut", [
                    animations_1.transition("void => *", [
                        animations_1.useAnimation(main_1.fadeIn, {
                            params: {
                                duration: ".35s",
                                easing: "ease-out"
                            }
                        })
                    ]),
                    animations_1.transition("* => void", [
                        animations_1.useAnimation(main_1.fadeOut, {
                            params: {
                                duration: ".2s",
                                easing: "ease-out"
                            }
                        })
                    ])
                ])
            ],
            selector: "igx-snackbar",
            styles: [__webpack_require__(124)],
            template: __webpack_require__(126)
        }),
        __metadata("design:paramtypes", [core_1.NgZone])
    ], IgxSnackbar);
    return IgxSnackbar;
}());
exports.IgxSnackbar = IgxSnackbar;
var IgxSnackbarModule = (function () {
    function IgxSnackbarModule() {
    }
    IgxSnackbarModule = __decorate([
        core_1.NgModule({
            declarations: [IgxSnackbar],
            exports: [IgxSnackbar],
            imports: [common_1.CommonModule]
        })
    ], IgxSnackbarModule);
    return IgxSnackbarModule;
}());
exports.IgxSnackbarModule = IgxSnackbarModule;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(125);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-snackbar{display:flex;position:relative;flex-flow:row nowrap;align-items:center;justify-content:space-between;min-height:3em;padding:.4375em 1.5em;background:rgba(0,0,0,.74);color:#fff;backface-visibility:hidden}.igx-snackbar__message{font-size:.875em}.igx-snackbar__button{background:transparent;color:#e41c77;border:0;line-height:1em;margin-left:1.5em;text-transform:uppercase;user-select:none;font-weight:600;-webkit-tap-highlight-color:transparent;outline:none;transition:color .2s ease}.igx-snackbar__button:hover{color:#e41c77}", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-snackbar\" *ngIf=\"isVisible\" (@slideInOut.start)=\"snackbarAnimationStarted($event)\" (@slideInOut.done)=\"snackbarAnimationDone($event)\"\n    [@slideInOut]=\"isVisible\">\n    <span class=\"igx-snackbar__message\" [@fadeInOut]=\"isVisible\">{{ message }}</span>\n    <button class=\"igx-snackbar__button\" igxRipple=\"white\" *ngIf=\"actionText\" [@fadeInOut] (click)=\"triggerAction(snackbar)\">\n            {{ actionText }}\n    </button>\n</div>"

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var button_directive_1 = __webpack_require__(6);
var IgxCardHeader = (function () {
    function IgxCardHeader() {
    }
    IgxCardHeader = __decorate([
        core_1.Directive({
            selector: "igx-card-header"
        })
    ], IgxCardHeader);
    return IgxCardHeader;
}());
exports.IgxCardHeader = IgxCardHeader;
var IgxCardContent = (function () {
    function IgxCardContent() {
    }
    IgxCardContent = __decorate([
        core_1.Directive({
            selector: "igx-card-content"
        })
    ], IgxCardContent);
    return IgxCardContent;
}());
exports.IgxCardContent = IgxCardContent;
var IgxCardActions = (function () {
    function IgxCardActions() {
    }
    IgxCardActions = __decorate([
        core_1.Directive({
            selector: "igx-card-actions"
        })
    ], IgxCardActions);
    return IgxCardActions;
}());
exports.IgxCardActions = IgxCardActions;
var IgxCardFooter = (function () {
    function IgxCardFooter() {
    }
    IgxCardFooter = __decorate([
        core_1.Directive({
            host: {
                role: "footer"
            },
            selector: "igx-card-footer"
        })
    ], IgxCardFooter);
    return IgxCardFooter;
}());
exports.IgxCardFooter = IgxCardFooter;
var IgxCardComponent = (function () {
    function IgxCardComponent() {
    }
    IgxCardComponent = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            selector: "igx-card",
            styles: [__webpack_require__(128)],
            template: __webpack_require__(130)
        })
    ], IgxCardComponent);
    return IgxCardComponent;
}());
exports.IgxCardComponent = IgxCardComponent;
var IgxCardModule = (function () {
    function IgxCardModule() {
    }
    IgxCardModule = __decorate([
        core_1.NgModule({
            declarations: [IgxCardComponent, IgxCardHeader, IgxCardContent, IgxCardActions, IgxCardFooter],
            exports: [IgxCardComponent, IgxCardHeader, IgxCardContent, IgxCardActions, IgxCardFooter],
            imports: [button_directive_1.IgxButtonModule]
        })
    ], IgxCardModule);
    return IgxCardModule;
}());
exports.IgxCardModule = IgxCardModule;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(129);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-card{display:flex;flex-flow:row wrap;box-shadow:0 1px 5px 0 rgba(0,0,0,.26),0 2px 2px 0 rgba(0,0,0,.12),0 3px 1px -2px rgba(0,0,0,.08);overflow:hidden;border-radius:2px;background:#fff;transition:box-shadow .3s cubic-bezier(.25,.8,.25,1);backface-visibility:hidden}.igx-card:hover{box-shadow:0 5px 5px -3px rgba(0,0,0,.26),0 8px 10px 1px rgba(0,0,0,.12),0 3px 14px 2px rgba(0,0,0,.08)}.igx-card igx-card-header{display:flex;flex-flow:row wrap;align-items:center;flex-basis:100%;padding:1.5em 1em 1em}.igx-card-header--compact,.igx-card igx-card-header.compact{padding:1em}.igx-card-header__title,.igx-card-header__title--small{margin:0;flex-basis:100%;font-size:1.5em;line-height:1.5em}.igx-card-header__title--small{font-size:.875em}.igx-card-header__subtitle{margin:0;color:rgba(0,0,0,.54);font-size:.875em;line-height:1.5em}.igx-card igx-card-content{flex-basis:100%;padding:1em}.igx-card-content__text{margin:0;color:rgba(0,0,0,.54);font-size:.875em;line-height:20px,16px}.igx-card__media{width:auto;margin-right:auto;order:-1}.igx-card__media--right{width:auto;margin-left:auto;order:9999}.igx-card igx-card-actions{display:flex;flex-flow:row wrap;flex:1 0 auto;align-items:center;padding:.5em;max-height:56px}.igx-card-actions__bgroup{display:flex;flex-flow:row nowrap}.igx-card-actions__bgroup [igxButton]~[igxButton]{margin-left:8px}.igx-card-actions__igroup,.igx-card-actions__igroup--end,.igx-card-actions__igroup--start{display:flex;flex-flow:row nowrap;color:rgba(0,0,0,.54)}.igx-card-actions__igroup--start{margin-right:auto}.igx-card-actions__igroup--end{margin-left:auto}.igx-card-header__tgroup{margin:0 1em}", ""]);

// exports


/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-card\" role=\"group\">\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(3);
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var IgxToast = (function () {
    function IgxToast() {
        this.CSS_CLASSES = {
            IGX_TOAST_BOTTOM: "igx-toast--bottom",
            IGX_TOAST_MIDDLE: "igx-toast--middle",
            IGX_TOAST_TOP: "igx-toast--top"
        };
        this.onShowing = new core_1.EventEmitter();
        this.onShown = new core_1.EventEmitter();
        this.onHiding = new core_1.EventEmitter();
        this.onHidden = new core_1.EventEmitter();
        this.autoHide = true;
        this.displayTime = 4000;
        this.isVisible = false;
        this.position = IgxToastPosition.Bottom;
    }
    IgxToast.prototype.show = function () {
        var _this = this;
        clearInterval(this.timeoutId);
        this.onShowing.emit(this);
        this.isVisible = true;
        if (this.autoHide) {
            this.timeoutId = setTimeout(function () {
                _this.hide();
            }, this.displayTime);
        }
        this.onShown.emit(this);
    };
    IgxToast.prototype.hide = function () {
        this.onHiding.emit(this);
        this.isVisible = false;
        this.onHidden.emit(this);
        clearInterval(this.timeoutId);
    };
    IgxToast.prototype.mapPositionToClassName = function () {
        if (this.position === IgxToastPosition.Top) {
            return this.CSS_CLASSES.IGX_TOAST_TOP;
        }
        if (this.position === IgxToastPosition.Middle) {
            return this.CSS_CLASSES.IGX_TOAST_MIDDLE;
        }
        if (this.position === IgxToastPosition.Bottom) {
            return this.CSS_CLASSES.IGX_TOAST_BOTTOM;
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxToast.prototype, "onShowing", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxToast.prototype, "onShown", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxToast.prototype, "onHiding", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxToast.prototype, "onHidden", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxToast.prototype, "autoHide", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxToast.prototype, "displayTime", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxToast.prototype, "isVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxToast.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxToast.prototype, "position", void 0);
    IgxToast = __decorate([
        core_1.Component({
            animations: [
                animations_1.trigger("animate", [
                    animations_1.state("show", animations_1.style({
                        opacity: 1
                    })),
                    animations_1.transition("* => show", animations_1.animate(".20s ease")),
                    animations_1.transition("show => *", animations_1.animate(".40s ease-out"))
                ])
            ],
            host: {
                role: "alert"
            },
            selector: "igx-toast",
            styles: [__webpack_require__(132)],
            template: __webpack_require__(134)
        })
    ], IgxToast);
    return IgxToast;
}());
exports.IgxToast = IgxToast;
var IgxToastPosition;
(function (IgxToastPosition) {
    IgxToastPosition[IgxToastPosition["Bottom"] = 0] = "Bottom";
    IgxToastPosition[IgxToastPosition["Middle"] = 1] = "Middle";
    IgxToastPosition[IgxToastPosition["Top"] = 2] = "Top";
})(IgxToastPosition = exports.IgxToastPosition || (exports.IgxToastPosition = {}));
var IgxToastModule = (function () {
    function IgxToastModule() {
    }
    IgxToastModule = __decorate([
        core_1.NgModule({
            declarations: [IgxToast],
            exports: [IgxToast],
            imports: [common_1.CommonModule]
        })
    ], IgxToastModule);
    return IgxToastModule;
}());
exports.IgxToastModule = IgxToastModule;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(133);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-toast,.igx-toast--bottom,.igx-toast--middle,.igx-toast--top{display:block;margin:2.625em auto;position:fixed;text-align:center;left:50%;transform:translate3d(-50%,0,0);min-width:52px;padding:1em 1.5em;background-color:rgba(0,0,0,.54);border-radius:26px;color:#fff;font-size:.875em;line-height:1.5em;opacity:0;z-index:999999}.igx-toast--top{top:0}.igx-toast--middle{top:50%;transform:translate3d(-50%,-50%,0)}.igx-toast--bottom{bottom:0}", ""]);

// exports


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = "<div [ngClass]=\"mapPositionToClassName(position)\" *ngIf=\"this.isVisible\" [@animate]=\"'show'\">\n    {{ message }}\n</div>"

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var SliderType;
(function (SliderType) {
    SliderType[SliderType["SLIDER"] = 0] = "SLIDER";
    SliderType[SliderType["RANGE"] = 1] = "RANGE";
})(SliderType = exports.SliderType || (exports.SliderType = {}));
var SliderHandle;
(function (SliderHandle) {
    SliderHandle[SliderHandle["FROM"] = 0] = "FROM";
    SliderHandle[SliderHandle["TO"] = 1] = "TO";
})(SliderHandle || (SliderHandle = {}));
var noop = function () {
};
var IgxSlider = (function () {
    function IgxSlider(renderer) {
        this.renderer = renderer;
        this.isContinuous = false;
        this.type = SliderType.SLIDER;
        this.thumbLabelVisibilityDuration = 750;
        this.step = 1;
        this.onValueChange = new core_1.EventEmitter();
        this.isActiveLabel = false;
        this.activeHandle = SliderHandle.TO;
        this._minValue = 0;
        this.width = 0;
        this.xOffset = 0;
        this.xPointer = 0;
        this.pPointer = 0;
        this.pMin = 0;
        this.pMax = 1;
        this.hasViewInit = false;
        this._maxValue = 100;
        this._onChangeCallback = noop;
        this._onTouchedCallback = noop;
    }
    IgxSlider_1 = IgxSlider;
    Object.defineProperty(IgxSlider.prototype, "isRange", {
        get: function () {
            var isRange = this.type === SliderType.RANGE;
            return isRange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "minValue", {
        get: function () {
            return this._minValue;
        },
        set: function (value) {
            if (value >= this.maxValue) {
                this._minValue = this.maxValue - 1;
                return;
            }
            this._minValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "maxValue", {
        get: function () {
            return this._maxValue;
        },
        set: function (value) {
            if (value <= this._minValue) {
                this._maxValue = this._minValue + 1;
                return;
            }
            this._maxValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "lowerBound", {
        get: function () {
            return this._lowerBound;
        },
        set: function (value) {
            if (value >= this.upperBound) {
                this._lowerBound = this.minValue;
                return;
            }
            this._lowerBound = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "upperBound", {
        get: function () {
            return this._upperBound;
        },
        set: function (value) {
            if (value <= this.lowerBound) {
                this._upperBound = this.maxValue;
                return;
            }
            this._upperBound = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "lowerValue", {
        get: function () {
            return this._lowerValue;
        },
        set: function (value) {
            if (value < this.lowerBound || this.upperBound < value) {
                return;
            }
            if (this.isRange && value > this.upperValue) {
                return;
            }
            this._lowerValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "upperValue", {
        get: function () {
            return this._upperValue;
        },
        set: function (value) {
            if (value < this.lowerBound || this.upperBound < value) {
                return;
            }
            if (this.isRange && value < this.lowerValue) {
                return;
            }
            this._upperValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxSlider.prototype, "value", {
        get: function () {
            if (this.isRange) {
                return {
                    lower: this.snapValueToStep(this.lowerValue),
                    upper: this.snapValueToStep(this.upperValue)
                };
            }
            else {
                var val = this.snapValueToStep(this.upperValue);
                return val;
            }
        },
        set: function (value) {
            if (!this.isRange) {
                this.upperValue = this.snapValueToStep(value);
            }
            else {
                this.upperValue =
                    this.snapValueToStep(value == null ? null : value.upper);
                this.lowerValue =
                    this.snapValueToStep(value == null ? null : value.lower);
            }
            this._onChangeCallback(this.value);
            if (this.hasViewInit) {
                this.positionHandlesAndUpdateTrack();
            }
        },
        enumerable: true,
        configurable: true
    });
    IgxSlider.prototype.ngOnInit = function () {
        if (this.lowerBound === undefined) {
            this.lowerBound = this.minValue;
        }
        if (this.upperBound === undefined) {
            this.upperBound = this.maxValue;
        }
        if (this.isRange) {
            if (Number.isNaN(this.value.lower)) {
                this.value = {
                    lower: this.lowerBound,
                    upper: this.value.upper
                };
            }
            if (Number.isNaN(this.value.upper)) {
                this.value = {
                    lower: this.value.lower,
                    upper: this.upperBound
                };
            }
        }
        else {
            if (Number.isNaN(this.value)) {
                this.value = this.lowerBound;
            }
        }
        this.pMin = this.valueToFraction(this.lowerBound) || 0;
        this.pMax = this.valueToFraction(this.upperBound) || 1;
    };
    IgxSlider.prototype.ngAfterViewInit = function () {
        this.hasViewInit = true;
        this.positionHandlesAndUpdateTrack();
        this.setTickInterval();
    };
    IgxSlider.prototype.writeValue = function (value) {
        this.value = value;
    };
    IgxSlider.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    IgxSlider.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    IgxSlider.prototype.showThumbsLabels = function () {
        if (this.disabled) {
            return;
        }
        if (this.isContinuous) {
            return;
        }
        if (this.timer !== null) {
            clearInterval(this.timer);
        }
        this.isActiveLabel = true;
    };
    IgxSlider.prototype.onFocus = function ($event) {
        if (this.isRange && $event.target === this.thumbFrom.nativeElement) {
            this.activeHandle = SliderHandle.FROM;
        }
        if ($event.target === this.thumbTo.nativeElement) {
            this.activeHandle = SliderHandle.TO;
        }
        this.toggleThumbLabel();
    };
    IgxSlider.prototype.onPanEnd = function ($event) {
        this.hideThumbsLabels();
        this.emitValueChanged();
    };
    IgxSlider.prototype.hideThumbLabelsOnBlur = function () {
        if (this.timer !== null) {
            clearInterval(this.timer);
        }
        this.isActiveLabel = false;
    };
    IgxSlider.prototype.onKeyDown = function ($event) {
        if (this.disabled) {
            return true;
        }
        var incrementSign;
        if ($event.key.endsWith("Left")) {
            incrementSign = -1;
        }
        else if ($event.key.endsWith("Right")) {
            incrementSign = 1;
        }
        else {
            return;
        }
        var value = this.value;
        if (this.isRange) {
            if (this.activeHandle === SliderHandle.FROM) {
                var newLower = this.value.lower + incrementSign * this.step;
                if (newLower >= this.value.upper) {
                    this.thumbTo.nativeElement.focus();
                    return;
                }
                this.value = {
                    lower: newLower,
                    upper: this.value.upper
                };
            }
            else {
                var newUpper = this.value.upper + incrementSign * this.step;
                if (newUpper <= this.value.lower) {
                    this.thumbFrom.nativeElement.focus();
                    return;
                }
                this.value = {
                    lower: this.value.lower,
                    upper: this.value.upper + incrementSign * this.step
                };
            }
        }
        else {
            this.value = this.value + incrementSign * this.step;
        }
        if (this.hasValueChanged(value)) {
            this.emitValueChanged();
        }
        this.showThumbsLabels();
    };
    IgxSlider.prototype.onTap = function ($event) {
        var value = this.value;
        this.update($event);
        if (this.hasValueChanged(value)) {
            this.emitValueChanged();
        }
    };
    IgxSlider.prototype.update = function ($event) {
        if (this.disabled) {
            return;
        }
        if ($event.type === "tap") {
            this.toggleThumbLabel();
        }
        this.setSliderWidth();
        this.setSliderOffset();
        this.setPointerPosition($event);
        this.setPointerPercent();
        if (this.isRange) {
            this.closestHandle();
        }
        this.setValues();
        this.positionHandlesAndUpdateTrack();
        this._onTouchedCallback();
    };
    IgxSlider.prototype.hideThumbsLabels = function () {
        var _this = this;
        if (this.disabled) {
            return;
        }
        if (this.isContinuous) {
            return;
        }
        this.timer = setTimeout(function () { return _this.isActiveLabel = false; }, this.thumbLabelVisibilityDuration);
    };
    IgxSlider.prototype.generateTickMarks = function (color, interval) {
        return "repeating-linear-gradient(\n            " + "to left" + ",\n            " + color + ",\n            " + color + " 1.5px,\n            transparent 1.5px,\n            transparent " + interval + "%\n        ), repeating-linear-gradient(\n            " + "to right" + ",\n            " + color + ",\n            " + color + " 1.5px,\n            transparent 1.5px,\n            transparent " + interval + "%\n        )";
    };
    IgxSlider.prototype.toggleThumbLabel = function () {
        this.showThumbsLabels();
        this.hideThumbsLabels();
    };
    IgxSlider.prototype.getSliderOffset = function () {
        return this.xOffset;
    };
    IgxSlider.prototype.toFixed = function (num) {
        num = parseFloat(num.toFixed(20));
        return num;
    };
    IgxSlider.prototype.positionHandle = function (handle, position) {
        handle.nativeElement.style.left = this.valueToFraction(position) * 100 + "%";
    };
    IgxSlider.prototype.positionHandlesAndUpdateTrack = function () {
        if (!this.isRange) {
            this.positionHandle(this.thumbTo, this.value);
        }
        else {
            this.positionHandle(this.thumbTo, this.value.upper);
            this.positionHandle(this.thumbFrom, this.value.lower);
        }
        this.updateTrack();
    };
    IgxSlider.prototype.closestHandle = function () {
        var fromOffset = this.thumbFrom.nativeElement.offsetLeft + this.thumbFrom.nativeElement.offsetWidth / 2;
        var toOffset = this.thumbTo.nativeElement.offsetLeft + this.thumbTo.nativeElement.offsetWidth / 2;
        var match = this.closestTo(this.xPointer, [fromOffset, toOffset]);
        if (match === toOffset) {
            this.thumbTo.nativeElement.focus();
        }
        else if (match === fromOffset) {
            this.thumbFrom.nativeElement.focus();
        }
    };
    IgxSlider.prototype.setTickInterval = function () {
        if (this.isContinuous) {
            return;
        }
        var interval = this.step > 1 ? this.step : null;
        this.renderer.setStyle(this.ticks.nativeElement, "background", this.generateTickMarks("white", interval));
    };
    IgxSlider.prototype.snapValueToStep = function (value) {
        var valueModStep = (value - this.minValue) % this.step;
        var snapValue = value - valueModStep;
        if (Math.abs(valueModStep) * 2 >= this.step) {
            snapValue += (valueModStep > 0) ? this.step : (-this.step);
        }
        return parseFloat(snapValue.toFixed(20));
    };
    IgxSlider.prototype.closestTo = function (goal, positions) {
        return positions.reduce(function (previous, current) {
            return (Math.abs(goal - current) < Math.abs(goal - previous) ? current : previous);
        });
    };
    IgxSlider.prototype.setValues = function () {
        if (this.activeHandle === SliderHandle.TO) {
            if (this.isRange) {
                this.value = {
                    lower: this.value.lower,
                    upper: this.fractionToValue(this.pPointer)
                };
            }
            else {
                this.value = this.fractionToValue(this.pPointer);
            }
        }
        if (this.activeHandle === SliderHandle.FROM) {
            this.value = {
                lower: this.fractionToValue(this.pPointer),
                upper: this.value.upper
            };
        }
    };
    IgxSlider.prototype.setSliderWidth = function () {
        this.width = this.slider.nativeElement.offsetWidth;
    };
    IgxSlider.prototype.setPointerPosition = function (e) {
        this.xPointer = e.center.x - this.getSliderOffset();
    };
    IgxSlider.prototype.setSliderOffset = function () {
        var rect = this.slider.nativeElement.getBoundingClientRect();
        this.xOffset = rect.left;
    };
    IgxSlider.prototype.setPointerPercent = function () {
        this.pPointer = this.limit(this.toFixed(this.xPointer / this.width));
    };
    IgxSlider.prototype.valueToFraction = function (value) {
        return this.limit((value - this.minValue) / (this.maxValue - this.minValue));
    };
    IgxSlider.prototype.fractionToValue = function (fraction) {
        var max = this.maxValue;
        var min = this.minValue;
        return (max - min) * fraction + min;
    };
    IgxSlider.prototype.fractionToPercent = function (fraction) {
        return this.toFixed(fraction * 100);
    };
    IgxSlider.prototype.limit = function (num) {
        return Math.max(this.pMin, Math.min(num, this.pMax));
    };
    IgxSlider.prototype.updateTrack = function () {
        var fromPosition = this.valueToFraction(this.lowerValue);
        var toPosition = this.valueToFraction(this.upperValue);
        var positionGap = (this.valueToFraction(this.upperValue) - this.valueToFraction(this.lowerValue));
        if (!this.isRange) {
            this.track.nativeElement.style.transform = "scaleX(" + toPosition + ")";
        }
        if (this.isRange) {
            this.track.nativeElement.style.transform = "scaleX(" + 1 + ")";
            this.track.nativeElement.style.left = fromPosition * 100 + "%";
            this.track.nativeElement.style.width = positionGap * 100 + "%";
        }
    };
    IgxSlider.prototype.hasValueChanged = function (oldValue) {
        var isSliderWithDifferentValue = !this.isRange && oldValue !== this.value;
        var isRangeWithOneDifferentValue = this.isRange &&
            (oldValue.lower !== this.value.lower ||
                oldValue.upper !== this.value.upper);
        return isSliderWithDifferentValue || isRangeWithOneDifferentValue;
    };
    IgxSlider.prototype.emitValueChanged = function () {
        this.onValueChange.emit({ value: this.value });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSlider.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxSlider.prototype, "isContinuous", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSlider.prototype, "type", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSlider.prototype, "thumbLabelVisibilityDuration", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxSlider.prototype, "step", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxSlider.prototype, "onValueChange", void 0);
    __decorate([
        core_1.ViewChild("slider"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxSlider.prototype, "slider", void 0);
    __decorate([
        core_1.ViewChild("track"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxSlider.prototype, "track", void 0);
    __decorate([
        core_1.ViewChild("ticks"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxSlider.prototype, "ticks", void 0);
    __decorate([
        core_1.ViewChild("thumbFrom"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxSlider.prototype, "thumbFrom", void 0);
    __decorate([
        core_1.ViewChild("thumbTo"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxSlider.prototype, "thumbTo", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxSlider.prototype, "minValue", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxSlider.prototype, "maxValue", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxSlider.prototype, "lowerBound", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], IgxSlider.prototype, "upperBound", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], IgxSlider.prototype, "value", null);
    IgxSlider = IgxSlider_1 = __decorate([
        core_1.Component({
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxSlider_1, multi: true }],
            selector: "igx-slider",
            styles: [__webpack_require__(136)],
            template: __webpack_require__(138)
        }),
        __metadata("design:paramtypes", [core_1.Renderer2])
    ], IgxSlider);
    return IgxSlider;
    var IgxSlider_1;
}());
exports.IgxSlider = IgxSlider;
var IgxSliderModule = (function () {
    function IgxSliderModule() {
    }
    IgxSliderModule = __decorate([
        core_1.NgModule({
            declarations: [IgxSlider],
            exports: [IgxSlider],
            imports: [common_1.CommonModule]
        })
    ], IgxSliderModule);
    return IgxSliderModule;
}());
exports.IgxSliderModule = IgxSliderModule;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(137);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-slider,.igx-slider--disabled{display:flex;position:relative;height:48px;align-items:center}.igx-slider__thumbs{position:absolute;width:100%;height:0;cursor:default;z-index:1}.igx-slider--disabled .igx-slider__track,.igx-slider__track{position:absolute;width:100%;height:2px;background:rgba(0,0,0,.38);transition:background .2s ease}.igx-slider--disabled .igx-slider__track{background:#bcbcbc}.igx-slider__track-ticks{position:absolute;width:100%;height:2px;background-size:100% 2px;opacity:.85;transition:opacity .2s ease;z-index:1}.igx-slider--disabled .igx-slider__track-fill,.igx-slider__track-fill{position:absolute;width:100%;height:inherit;background:#0375be;transform-origin:0 0 0;transform:scaleX(0)}.igx-slider--disabled .igx-slider__track-fill{background:#bcbcbc}.igx-slider--disabled .igx-slider__thumb-from,.igx-slider--disabled .igx-slider__thumb-to,.igx-slider__thumb-from,.igx-slider__thumb-to{display:flex;position:absolute;justify-content:center;flex-flow:row nowrap;width:14px;height:14px;margin-left:-7px;top:-7px;outline:none}.igx-slider--disabled .igx-slider__thumb-from .label,.igx-slider--disabled .igx-slider__thumb-to .label,.igx-slider__thumb-from .label,.igx-slider__thumb-to .label{display:flex;position:relative;align-items:center;justify-content:center;flex:0 0 auto;min-width:28px;height:28px;padding:0 2px;border-radius:14px;top:-36px;font-size:.6875em;font-weight:600;line-height:.6875em;color:rgba(0,0,0,.74);background:#fbb13c;opacity:.5;transform:scale(0);border-color:#fbb13c transparent transparent;transform-origin:50% 150% 0;transition:transform .2s ease-out;z-index:-1}.igx-slider--disabled .igx-slider__thumb-from .label:after,.igx-slider--disabled .igx-slider__thumb-to .label:after,.igx-slider__thumb-from .label:after,.igx-slider__thumb-to .label:after{content:\"\";position:absolute;left:50%;width:0;height:0;transform:translateX(-50%);border-left:10px solid;border-right:10px solid;border-top:12px solid;border-color:inherit;top:24px;z-index:-1}.igx-slider__thumb-from .dot,.igx-slider__thumb-to .dot{position:absolute;left:0;width:inherit;height:inherit;border-radius:7px;background:#fbb13c;transform:scale(1);transform-origin:50% 50% 0;opacity:1;transition:transform .2s ease-out}.igx-slider--disabled .igx-slider__thumb-from .dot,.igx-slider--disabled .igx-slider__thumb-to .dot{background:#bcbcbc;transform:scale(.9);border:2px solid #fff}.igx-slider__thumb-from--active .dot,.igx-slider__thumb-to--active .dot{opacity:0;transform:scale(0)}.igx-slider__thumb-from--active .label,.igx-slider__thumb-to--active .label{opacity:.85;transform:scale(1.2)}.igx-slider__thumb-from--active,.igx-slider__thumb-to--active{z-index:1}", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-slider\" [class.igx-slider--disabled]=\"disabled\" #slider (panstart)=\"showThumbsLabels()\" (panend)=\"onPanEnd($event)\"\n    (pan)=\"update($event)\" (tap)=\"onTap($event)\">\n    <div class=\"igx-slider__track\">\n        <div #track class=\"igx-slider__track-fill\"></div>\n        <div #ticks class=\"igx-slider__track-ticks\"></div>\n    </div>\n    <div class=\"igx-slider__thumbs\">\n        <div (keydown)=\"onKeyDown($event);\" (keyup)=\"hideThumbsLabels()\" (blur)=\"hideThumbLabelsOnBlur()\" (focus)=\"onFocus($event);\"\n            *ngIf=\"isRange\" class=\"igx-slider__thumb-from\" tabindex=\"1\" [ngClass]=\"{ 'igx-slider__thumb-from--active': isActiveLabel }\"\n            #thumbFrom>\n            <span class=\"label\">{{ value.lower }}</span>\n            <span class=\"dot\"></span>\n        </div>\n        <div (keydown)=\"onKeyDown($event);\" (keyup)=\"hideThumbsLabels()\" (blur)=\"hideThumbLabelsOnBlur()\" (focus)=\"onFocus($event);\"\n            class=\"igx-slider__thumb-to\" tabindex=\"1\" [ngClass]=\"{ 'igx-slider__thumb-to--active': isActiveLabel }\" #thumbTo>\n            <span *ngIf=\"isRange\" class=\"label\">{{ value.upper }}</span>\n            <span *ngIf=\"!isRange\" class=\"label\">{{ value }}</span>\n            <span class=\"dot\"></span>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(27);
var ScrollHammerGestureManager = (function (_super) {
    __extends(ScrollHammerGestureManager, _super);
    function ScrollHammerGestureManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overrides = {
            pan: { threshold: 0, direction: Hammer.DIRECTION_VERTICAL }
        };
        return _this;
    }
    return ScrollHammerGestureManager;
}(platform_browser_1.HammerGestureConfig));
exports.ScrollHammerGestureManager = ScrollHammerGestureManager;
var IgxScroll = (function () {
    function IgxScroll() {
        this.onScroll = new core_1.EventEmitter();
    }
    Object.defineProperty(IgxScroll.prototype, "scrollTop", {
        get: function () {
            return this.verticalScroll.nativeElement.scrollTop;
        },
        enumerable: true,
        configurable: true
    });
    IgxScroll.prototype.scrollVertically = function (delta) {
        this.verticalScroll.nativeElement.scrollTop += delta;
        if (this.verticalScroll.nativeElement.scrollTop < 0) {
            return;
        }
        this.emitScroll();
    };
    Object.defineProperty(IgxScroll.prototype, "totalHeight", {
        get: function () {
            return this.itemHeight * this.visibleItemsCount + "px";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxScroll.prototype, "innerHeight", {
        get: function () {
            return this.totalItemsCount * this.itemHeight + "px";
        },
        enumerable: true,
        configurable: true
    });
    IgxScroll.prototype.onMouseWheel = function ($event) {
        this.scrollVertically($event.deltaY);
        $event.preventDefault();
    };
    IgxScroll.prototype.onPan = function ($event) {
        var _this = this;
        if ($event.pointerType !== "touch") {
            return;
        }
        this.amplitude = 0.8 * $event.velocityY;
        this.timestamp = $event.timeStamp;
        this.target = Math.round($event.deltaY + this.amplitude);
        this.animationFrameId = requestAnimationFrame(function (timestamp) { return _this.run(timestamp); });
    };
    IgxScroll.prototype.onScrolled = function ($event) {
        this.emitScroll();
    };
    IgxScroll.prototype.run = function (timeStamp) {
        var _this = this;
        var elapsed;
        var delta;
        elapsed = Date.now() - this.timestamp;
        delta = this.amplitude * Math.exp(-elapsed / 325);
        if (delta > 0.5 || delta < -0.5) {
            this.scrollVertically((this.target + delta) * -1);
            requestAnimationFrame(function (timestamp) { return _this.run(timestamp); });
        }
        else {
            this.scrollVertically(this.target * -1);
        }
    };
    IgxScroll.prototype.emitScroll = function () {
        var currentTop = this.verticalScroll.nativeElement.scrollTop / this.itemHeight;
        if (this.verticalScroll.nativeElement.scrollTop % this.itemHeight !== 0) {
            currentTop = Math.round(currentTop);
        }
        this.onScroll.emit({ currentTop: currentTop });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxScroll.prototype, "visibleItemsCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxScroll.prototype, "totalItemsCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxScroll.prototype, "itemHeight", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxScroll.prototype, "onScroll", void 0);
    __decorate([
        core_1.ViewChild("verticalScroll"),
        __metadata("design:type", core_1.ElementRef)
    ], IgxScroll.prototype, "verticalScroll", void 0);
    IgxScroll = __decorate([
        core_1.Component({
            selector: "igx-scroll",
            styles: [__webpack_require__(140)],
            template: __webpack_require__(142)
        })
    ], IgxScroll);
    return IgxScroll;
}());
exports.IgxScroll = IgxScroll;
var IgxScrollModule = (function () {
    function IgxScrollModule() {
    }
    IgxScrollModule = __decorate([
        core_1.NgModule({
            declarations: [IgxScroll],
            exports: [IgxScroll],
            imports: [common_1.CommonModule],
            providers: [{
                    provide: platform_browser_1.HAMMER_GESTURE_CONFIG,
                    useClass: ScrollHammerGestureManager
                }]
        })
    ], IgxScrollModule);
    return IgxScrollModule;
}());
exports.IgxScrollModule = IgxScrollModule;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(141);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-scroll__viewport{display:inline-block;overflow-y:hidden}.igx-scroll__vertical{display:inline-block;width:20px;overflow-y:auto}", ""]);

// exports


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-scroll\"\n     #scroll>\n    <div class=\"igx-scroll__viewport\" [ngStyle]=\"{ 'height': totalHeight }\"\n         (pan)=\"onPan($event)\"\n         (wheel)=\"onMouseWheel($event)\">\n        <ng-content>\n        </ng-content>\n    </div>\n    <div (scroll)=\"onScrolled($event)\"\n         #verticalScroll class=\"igx-scroll__vertical\" [ngStyle]=\"{ 'height': totalHeight }\">\n        <div [ngStyle]=\"{ 'height': innerHeight }\">\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var calendar_1 = __webpack_require__(31);
var calendar_component_1 = __webpack_require__(30);
var dialog_component_1 = __webpack_require__(14);
var input_directive_1 = __webpack_require__(16);
var IgxDatePickerComponent = (function () {
    function IgxDatePickerComponent(resolver) {
        this.resolver = resolver;
        this.locale = Constants.DEFAULT_LOCALE_DATE;
        this.weekStart = calendar_1.WEEKDAYS.SUNDAY;
        this.formatOptions = {
            day: "numeric",
            month: "short",
            weekday: "short",
            year: "numeric"
        };
        this.onOpen = new core_1.EventEmitter();
        this.onSelection = new core_1.EventEmitter();
        this._onTouchedCallback = function () { };
        this._onChangeCallback = function () { };
    }
    IgxDatePickerComponent_1 = IgxDatePickerComponent;
    Object.defineProperty(IgxDatePickerComponent.prototype, "displayData", {
        get: function () {
            if (this.value) {
                return this._customFormatChecker(this.formatter, this.value);
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgxDatePickerComponent.prototype, "calendar", {
        get: function () {
            return this.calendarRef.instance;
        },
        enumerable: true,
        configurable: true
    });
    IgxDatePickerComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    IgxDatePickerComponent.prototype.registerOnChange = function (fn) { this._onChangeCallback = fn; };
    IgxDatePickerComponent.prototype.registerOnTouched = function (fn) { this._onTouchedCallback = fn; };
    IgxDatePickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.alert.onOpen.subscribe(function (ev) { return _this._focusTheDialog(); });
        this.alert.onClose.subscribe(function (ev) { return _this.handleDialogCloseAction(); });
    };
    IgxDatePickerComponent.prototype.ngOnDestroy = function () {
        this.alert.onClose.unsubscribe();
        this.alert.onOpen.unsubscribe();
    };
    IgxDatePickerComponent.prototype.triggerTodaySelection = function () {
        var today = new Date(Date.now());
        this.handleSelection(today);
    };
    IgxDatePickerComponent.prototype.selectDate = function (date) {
        this.value = date;
        this.onSelection.emit(date);
    };
    IgxDatePickerComponent.prototype.onOpenEvent = function (event) {
        var factory = this.resolver.resolveComponentFactory(calendar_component_1.IgxCalendarComponent);
        this.calendarRef = this.container.createComponent(factory);
        this.calendarRef.changeDetectorRef.detach();
        this.updateCalendarInstance();
        this.calendarRef.location.nativeElement.classList.add("igx-date-picker__date--opened");
        this.calendarRef.changeDetectorRef.reattach();
        this.alert.open();
        this._onTouchedCallback();
        this.onOpen.emit(this);
    };
    IgxDatePickerComponent.prototype.handleDialogCloseAction = function () {
        var _this = this;
        setTimeout(function () { return _this.calendarRef.destroy(); }, 350);
    };
    IgxDatePickerComponent.prototype.handleSelection = function (event) {
        this.value = event;
        this.calendar.viewDate = event;
        this._onChangeCallback(event);
        this.alert.close();
        this.onSelection.emit(event);
    };
    IgxDatePickerComponent.prototype.updateCalendarInstance = function () {
        var _this = this;
        this.calendar.formatOptions = this.formatOptions;
        this.calendar.locale = this.locale;
        if (this.value) {
            this.calendar.value = this.value;
            this.calendar.viewDate = this.value;
        }
        this.calendar.weekStart = this.weekStart;
        this.calendar.onSelection.subscribe(function (ev) { return _this.handleSelection(ev); });
    };
    IgxDatePickerComponent.prototype._focusTheDialog = function () {
        var _this = this;
        requestAnimationFrame(function () { return _this.alert.dialogEl.nativeElement.focus(); });
    };
    IgxDatePickerComponent.prototype._setLocaleToDate = function (value, locale) {
        if (locale === void 0) { locale = Constants.DEFAULT_LOCALE_DATE; }
        return value.toLocaleDateString(locale);
    };
    IgxDatePickerComponent.prototype._customFormatChecker = function (formatter, date) {
        return this.formatter ? this.formatter(date) : this._setLocaleToDate(date, this.locale);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], IgxDatePickerComponent.prototype, "formatter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IgxDatePickerComponent.prototype, "isDisabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Date)
    ], IgxDatePickerComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDatePickerComponent.prototype, "locale", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], IgxDatePickerComponent.prototype, "weekStart", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], IgxDatePickerComponent.prototype, "formatOptions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDatePickerComponent.prototype, "todayButtonLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], IgxDatePickerComponent.prototype, "cancelButtonLabel", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDatePickerComponent.prototype, "onOpen", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], IgxDatePickerComponent.prototype, "onSelection", void 0);
    __decorate([
        core_1.ViewChild("container", { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.ViewContainerRef)
    ], IgxDatePickerComponent.prototype, "container", void 0);
    __decorate([
        core_1.ViewChild(dialog_component_1.IgxDialog),
        __metadata("design:type", dialog_component_1.IgxDialog)
    ], IgxDatePickerComponent.prototype, "alert", void 0);
    IgxDatePickerComponent = IgxDatePickerComponent_1 = __decorate([
        core_1.Component({
            encapsulation: core_1.ViewEncapsulation.None,
            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: IgxDatePickerComponent_1, multi: true }],
            selector: "igx-datePicker",
            styles: [__webpack_require__(144)],
            template: __webpack_require__(146)
        }),
        __metadata("design:paramtypes", [core_1.ComponentFactoryResolver])
    ], IgxDatePickerComponent);
    return IgxDatePickerComponent;
    var IgxDatePickerComponent_1;
}());
exports.IgxDatePickerComponent = IgxDatePickerComponent;
var Constants = (function () {
    function Constants() {
    }
    Constants.DEFAULT_LOCALE_DATE = "en";
    return Constants;
}());
var IgxDatePickerModule = (function () {
    function IgxDatePickerModule() {
    }
    IgxDatePickerModule = __decorate([
        core_1.NgModule({
            declarations: [IgxDatePickerComponent],
            entryComponents: [calendar_component_1.IgxCalendarComponent],
            exports: [IgxDatePickerComponent],
            imports: [common_1.CommonModule, input_directive_1.IgxInput, dialog_component_1.IgxDialogModule, calendar_component_1.IgxCalendarModule]
        })
    ], IgxDatePickerModule);
    return IgxDatePickerModule;
}());
exports.IgxDatePickerModule = IgxDatePickerModule;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(145);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".igx-date-picker .igx-dialog__window{max-width:340px;min-width:320px;padding:0}.igx-date-picker .igx-dialog__window,.igx-date-picker .igx-dialog__window-content{width:100%;padding:0;color:inherit;font-size:medium;line-height:normal}.igx-date-picker .igx-dialog__window-title{display:none}.igx-date-picker .igx-dialog__window-actions{margin:0}.igx-date-picker .igx-calendar__body{padding-bottom:0!important}", ""]);

// exports


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "<div class=\"igx-date-picker\">\n    <input class=\"igx-date-picker__input-date\" igxInput (click)=\"onOpenEvent($event)\" [value]=\"displayData\" [disabled]=\"isDisabled\" />\n    <igx-dialog class=\"igx-date-picker__dialog-popup\" closeOnOutsideSelect=\"true\"\n        [leftButtonLabel]=\"cancelButtonLabel\" (onLeftButtonSelect)=\"alert.close()\"\n        [rightButtonLabel]=\"todayButtonLabel\" (onRightButtonSelect)=\"triggerTodaySelection()\">\n        <ng-container #container></ng-container>\n    </igx-dialog>\n</div>\n"

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.umd.min.js